/*!
 * @fortawesome/fontawesome-free@5.12.1 ((CC-BY-4.0 AND OFL-1.1 AND MIT))
 *   author: Dave Gandy (http://twitter.com/davegandy)
 *   url: git+https://github.com/FortAwesome/Font-Awesome.git
 *   contributors:
 *     Brian Talbot (http://twitter.com/talbs)
 *     Travis Chase (http://twitter.com/supercodepoet)
 *     Rob Madole (http://twitter.com/robmadole)
 *     Geremia Taglialatela (http://twitter.com/gtagliala)
 *     Mike Wilkerson (http://twitter.com/mw77)
 *
 *   Font Awesome Free License
 *   -------------------------
 *
 *   Font Awesome Free is free, open source, and GPL friendly. You can use it for
 *   commercial projects, open source projects, or really almost whatever you want.
 *   Full Font Awesome Free license: https://fontawesome.com/license/free.
 *
 *   # Icons: CC BY 4.0 License (https://creativecommons.org/licenses/by/4.0/)
 *   In the Font Awesome Free download, the CC BY 4.0 license applies to all icons
 *   packaged as SVG and JS file types.
 *
 *   # Fonts: SIL OFL 1.1 License (https://scripts.sil.org/OFL)
 *   In the Font Awesome Free download, the SIL OFL license applies to all icons
 *   packaged as web and desktop font files.
 *
 *   # Code: MIT License (https://opensource.org/licenses/MIT)
 *   In the Font Awesome Free download, the MIT license applies to all non-font and
 *   non-icon files.
 *
 *   # Attribution
 *   Attribution is required by MIT, SIL OFL, and CC BY licenses. Downloaded Font
 *   Awesome Free files already contain embedded comments with sufficient
 *   attribution, so you shouldn't need to do anything additional when using these
 *   files normally.
 *
 *   We've kept attribution comments terse, so we ask that you do not actively work
 *   to remove them from files, especially code. They're a great way for folks to
 *   learn about Font Awesome.
 *
 *   # Brand Icons
 *   All brand icons are trademarks of their respective owners. The use of these
 *   trademarks does not indicate endorsement of the trademark holder by Font
 *   Awesome, nor vice versa. **Please do not use brand logos for any purpose except
 *   to represent the company, product, or service to which they refer.**
 *
 *
 *
 * bowser@1.1.0 (MIT)
 *   author: Dustin Diaz (http://dustindiaz.com)
 *   url: git+https://github.com/ded/bowser.git
 *
 *   Copyright 2015, Dustin Diaz (the "Original Author")
 *   All rights reserved.
 *
 *   MIT License
 *
 *   Permission is hereby granted, free of charge, to any person
 *   obtaining a copy of this software and associated documentation
 *   files (the "Software"), to deal in the Software without
 *   restriction, including without limitation the rights to use,
 *   copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the
 *   Software is furnished to do so, subject to the following
 *   conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   Distributions of all or part of the Software intended to be used
 *   by the recipients as they would use the unmodified Software,
 *   containing modifications that substantially alter, remove, or
 *   disable functionality of the Software, outside of the documented
 *   configuration mechanisms provided by the Software, shall be
 *   modified such that the Original Author's bug reporting email
 *   addresses and urls are either replaced with the contact information
 *   of the parties responsible for the changes, or removed entirely.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 *   OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *   NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 *   HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 *   WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 *   FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 *   OTHER DEALINGS IN THE SOFTWARE.
 *
 *
 *   Except where noted, this license applies to any and all software
 *   programs and associated documentation files created by the
 *   Original Author, when distributed with the Software.
 *
 *
 *
 * glkit@0.0.2065 (MIT)
 *   author: Denis Belov
 *   url: git@github.com/denis-belov/glkit
 *
 *   glkit 0.0.2065
 *
 *   The MIT License
 *
 *   Copyright © 2017-2018 Denis Belov (GLKIT developer)
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 *   THE SOFTWARE.
 *
 *
 * jquery@3.4.1 (MIT)
 *   author: JS Foundation and other contributors (https://github.com/jquery/jquery/blob/3.4.1/AUTHORS.txt)
 *   url: git+https://github.com/jquery/jquery.git
 *
 *   Copyright JS Foundation and other contributors, https://js.foundation/
 *
 *   Permission is hereby granted, free of charge, to any person obtaining
 *   a copy of this software and associated documentation files (the
 *   "Software"), to deal in the Software without restriction, including
 *   without limitation the rights to use, copy, modify, merge, publish,
 *   distribute, sublicense, and/or sell copies of the Software, and to
 *   permit persons to whom the Software is furnished to do so, subject to
 *   the following conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *   NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 *   LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 *   OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 *   WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 *
 *
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/js/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@fortawesome/fontawesome-free/css/fontawesome.css":
/*!************************************************************************!*\
  !*** ./node_modules/@fortawesome/fontawesome-free/css/fontawesome.css ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./node_modules/@fortawesome/fontawesome-free/css/solid.css":
/*!******************************************************************!*\
  !*** ./node_modules/@fortawesome/fontawesome-free/css/solid.css ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./node_modules/bowser/src/bowser.js":
/*!*******************************************!*\
  !*** ./node_modules/bowser/src/bowser.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (name, definition) {
  if ( true && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else {}
}('bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , result

    if (/opera|opr/i.test(ua)) {
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
	else if (/vivaldi/i.test(ua)) {
		result = {
			name: 'Vivaldi'
			, vivaldi: t
			, version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
		}
	}
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
      , version: versionIdentifier
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/safari/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      , version: versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      result.name = result.name || "Webkit"
      result.webkit = t
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.msedge && (android || result.silk)) {
      result.android = t
    } else if (iosdevice) {
      result[iosdevice] = t
      result.ios = t
    } else if (windows) {
      result.windows = t
    } else if (mac) {
      result.mac = t
    } else if (linux) {
      result.linux = t
    }

    // OS version extraction
    var osVersion = '';
    if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (tablet || nexusTablet || iosdevice == 'ipad' || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile))) || result.silk) {
      result.tablet = t
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || nexusMobile || result.blackberry || result.webos || result.bada) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		(result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),

/***/ "./node_modules/glkit/build/index.js":
/*!*******************************************!*\
  !*** ./node_modules/glkit/build/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():undefined}(window,function(){return function(t){var n={};function i(e){if(n[e])return n[e].exports;var r=n[e]={i:e,l:!1,exports:{}};return t[e].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=n,i.d=function(t,n,e){i.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:e})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,n){if(1&n&&(t=i(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var e=Object.create(null);if(i.r(e),Object.defineProperty(e,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var r in t)i.d(e,r,function(n){return t[n]}.bind(null,r));return e},i.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(n,"a",n),n},i.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},i.p="",i(i.s=1)}([function(t,n){var i={null:"null"};t.exports={mix:function(t,n,i){return t+(n-t)*i},concatArrays:function t(n,i,e){if(i)for(var r=!0,a=i.length,s=0;s<a;s++){var o=i[s];if(o.arrays)for(var u in r=!0,o.arrays){var l=o.arrays[u];n.arrays?n.arrays[u]||(n.arrays[u]={arr:[],size:l.size||3,type:l.type}):(n.arrays={},n.arrays[u]={arr:[],size:l.size||3,type:l.type}),"IBO"===n.arrays[u].type?(n.arrays[u].arr=n.arrays[u].arr.concat(l.arr.map(function(t){return t+e})),e+=o.verticesNumber):n.arrays[u].arr=n.arrays[u].arr.concat(l.arr),r&&"VBO"===n.arrays[u].type&&(r=!1,n.batchIndices=n.batchIndices.concat(new Array(o.verticesNumber).fill(o.batchIndex)))}e=t(n,o.children,e)}return e},premultiplyParentMatrices:function(t){var n=t.parent;return t.matrix.premultiplyArray(n.scaleMatrix.arr).premultiplyArray(n.rotationMatrix.arr).premultiplyArrayPosition(n.position).switch[i[n.parent]](n)}}},function(t,n,i){t.exports=i(2)},function(t,n,i){function e(t,n,i){return n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i,t}var r=i(3),a=i(35);t.exports=function(t){for(var n=1;n<arguments.length;n++){var i=null!=arguments[n]?arguments[n]:{},r=Object.keys(i);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(i).filter(function(t){return Object.getOwnPropertyDescriptor(i,t).enumerable}))),r.forEach(function(n){e(t,n,i[n])})}return t}({WebGL:r,Loader:a},{version:"0.0.2065"})},function(t,n,i){function e(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function r(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}var a=i(4),s=i(5),o=i(6),u=i(7),l=i(8),h=i(9),c=i(10),f=i(11),p=i(12),d=i(13),y=i(14),m=i(15),v=i(16),b=i(17),x=i(18),g=i(19),T=i(20),O=i(21),k=i(22),M=i(23),F=i(24),w=i(25),A=i(26),E=i(27),S=i(28),B=i(29),C=i(30),R=i(31),U=i(32),I=i(33),P=i(34),D=i(0);t.exports=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t),this.init(n)}return function(t,n,i){n&&r(t.prototype,n),i&&r(t,i)}(t,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{version:1,class:"WebGL".concat(t.version||"","Context"),errorCallback:null,canvas:t.canvas||document.createElement("canvas"),antialias:!0,alpha:!1,premultipliedAlpha:!1},t),this.getWebGLContext(),this.frameTime={x:0},this.globalTime={x:0},this.lastTime={x:new Date},this.transitions=[],this.clbk=function(){return 0},this.DataInt1=s(this),this.DataInt2=o(this),this.DataInt3=u(this),this.DataInt4=l(this),this.DataFloat1=h(this),this.DataFloat2=c(this),this.DataFloat3=f(this),this.DataFloat4=p(this),this.DataArrayInt2=d(this),this.DataArrayInt3=y(this),this.DataArrayInt4=m(this),this.DataArrayFloat2=v(this),this.DataArrayFloat3=b(this),this.DataArrayFloat4=x(this),this.Mat4=g(this),this.VBO=T(this),this.MVBO=O(this),this.IBO=k(this),this.MIBO=M(this),this.VAO=F(this),this.UBO=w(this),this.Texture2D=A(this),this.RBO=E(this),this.FBO=S(this),this.Offscreen=B(this),this.OffscreenMultisample=C(this),this.Material=R(this),this.Obj=U(this);var n=I(this);Object.assign(this,n),Object.assign(this,{math:P,utility:D}),this.xOrig=0,this.yOrig=0,this.width=0,this.height=0,this.currentMIBO=null,this.currentMVBO=null,this.objects={},this.materials={},this.currentObject=new this.Obj,this.currentMatrix=new this.Mat4,this.currentNormalMatrix=new this.Mat4,Object.assign(this,a(this)),this.applyOptions(t)}},{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{anisotropy:!0,minDpr:1,maxDpr:999,preprocessing:!1,glsl300:!1},t);var n=this.WebGLRenderingContext;this.dpr=Math.min(Math.max(window.devicePixelRatio||1,this.minDpr),this.maxDpr),this.maxTextureUnits=n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS),this.textureUnits=new Array(this.maxTextureUnits).fill(null).map(function(t,i){return n["TEXTURE".concat(i)]}),this.maxPrecision={vs:{int:this.getMaxPrecision(),float:this.getMaxPrecision("vs","float")},fs:{int:this.getMaxPrecision("fs"),float:this.getMaxPrecision("fs","float")}},this.anisotropy&&(this.anisotropy=n.getExtension("EXT_texture_filter_anisotropic")||n.getExtension("MOZ_EXT_texture_filter_anisotropic")||n.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.maxAnisotropy=this.anisotropy?n.getParameter(this.anisotropy.MAX_TEXTURE_MAX_ANISOTROPY_EXT):0)}},{key:"getWebGLContext",value:function(){var t={antialias:this.antialias,alpha:this.alpha,premultipliedAlpha:this.premultipliedAlpha};try{this.WebGLRenderingContext=this.canvas.getContext("webgl".concat(1===this.version?"":this.version),t)}catch(t){if(!this.errorCallback)throw new Error(t);this.errorCallback(t)}}}]),t}()},function(t,n){t.exports=function(t){var n=t.WebGLRenderingContext,i=n.VERTEX_SHADER,e=n.FRAGMENT_SHADER,r=n.TEXTURE_2D,a=n.RENDERBUFFER,s=n.FRAMEBUFFER,o=n.BLEND,u=n.DEPTH_TEST,l=n.CULL_FACE,h=n.ARRAY_BUFFER,c=n.ELEMENT_ARRAY_BUFFER,f=n.UNIFORM_BUFFER,p={vs:i,fs:e};return{setDpr:function(){this.dpr=Math.min(Math.max(window.devicePixelRatio||1,this.minDpr),this.maxDpr)},viewport:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;n.viewport(t*this.dpr,i*this.dpr,e*this.dpr,r*this.dpr)},setSize:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;this.setDpr(),this.xOrig=t,this.yOrig=i,this.width=e,this.height=r,this.canvas.width=e*this.dpr,this.canvas.height=r*this.dpr,this.canvas.style.width="".concat(e,"px"),this.canvas.style.height="".concat(r,"px"),n.viewport(t*this.dpr,i*this.dpr,e*this.dpr,r*this.dpr)},updateTime:function(){var t=new Date;this.frameTime.x=t-this.lastTime.x,this.lastTime.x=t,this.globalTime.x+=this.frameTime.x},updateTransitions:function(){for(var t=this.transitions,n=t.length,i=0;i<n;i++)t[n-i-1].updateTransitionFunction()},getMaxPrecision:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"vs",i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"int",e=n.getShaderPrecisionFormat(p[t],n["MEDIUM_".concat(i.toUpperCase())]),r=n.getShaderPrecisionFormat(p[t],n["HIGH_".concat(i.toUpperCase())]),a="lowp";return r.precision+r.rangeMin+r.rangeMax?a="highp":e.precision+e.rangeMin+e.rangeMax&&(a="mediump"),a},disableTexture2D:function(){return n.bindTexture(r,null),this},disableRBO:function(){return n.bindRenderbuffer(a,null),this},framebufferRenderbuffer:function(t,i,e){return n.framebufferRenderbuffer(t,i,a,e.renderbuffer),this},framebufferTexture2D:function(t,i,e,r){return n.framebufferTexture2D(t,i,e,r.texture,0),this},renderbufferStorage:function(t,i,e){return n.renderbufferStorage(a,t,i,e),this},renderbufferStorageMultisample:function(t,i,e,r){return n.renderbufferStorageMultisample(a,t,i,e,r),this},disableFBO:function(){return n.bindFramebuffer(s,null),this},enableBlend:function(){return this.currentObject.enableBlend(),this},enableBlendSeparate:function(){return this.currentObject.enableBlendSeparate(),this},disableBlend:function(){return n.disable(o),this},enableDepthTest:function(){return this.currentObject.enableDepthTest(),this},disableDepthTest:function(){return n.disable(u),this},enableCullFace:function(){return this.currentObject.enableCullFace(),this},disableCullFace:function(){return n.disable(l),this},enableVAO:function(){return this.currentObject.enableVAO(),this},disableVAO:function(){return n.bindVertexArray(null),this},enableBuffers:function(){return this.currentObject.enableBuffers(),this},disableVBO:function(){return n.bindBuffer(h,null),this},disableIBO:function(){return n.bindBuffer(c,null),this},disableUBO:function(){return n.bindBuffer(f,null),this},disableMaterial:function(){return n.useProgram(null),this},updateMaterialUniforms:function(){return this.currentObject.updateMaterialUniforms(),this},updateAllMaterialUniforms:function(){return this.currentObject.updateAllMaterialUniforms(),this},updateMaterialAttributes:function(){return this.currentObject.updateMaterialAttributes(),this},updateMatrix:function(){return this.currentObject.updateMatrix(),this}}}},function(t,n){t.exports=function(){}},function(t,n){t.exports=function(){}},function(t,n){t.exports=function(){}},function(t,n){t.exports=function(){}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}var r=function(){};t.exports=function(t){var n=t.WebGLRenderingContext,a=t.transitions,s=t.frameTime,o=[function(t){t.x=t.transitionFrom+t.transitionFunc(t.transitionInterpolation)*(t.transitionTo-t.transitionFrom),t.transitionCurrentTime+=s.x},function(t){t.x=t.transitionTo,t.cancelTransition()}],u=[function(t){t.x=t.transitionFrom+t.transitionFunc(t.transitionInterpolation)*(t.transitionTo-t.transitionFrom),t.transitionCurrentTime+=s.x},function(t){t.x=t.transitionTo,t.cancelTransition(),t.transitionOnEnd()}],l=[r,function(t){var n=a[a.length-1];n.transitionIndex=t,a[t].inTransitions--,a[t]=n,a.pop()}];return function(){function h(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,h),this.class="DataFloat1",this.applyOptions(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(h,[{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",x:0,updated:!0,excludeMaterials:[]},t),this.inTransitions=0,this.transitionIndex=0,this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.transitionInterpolation=null,this.updateTransitionFunction=null,this.materials=[]}},{key:"uniform",value:function(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform float ".concat(this.name,";")}},{key:"set",value:function(t){this.x=t||this.x}},{key:"reset",value:function(){this.x=0}},{key:"setWithUniforms",value:function(t){this.x=t||this.x,this.updateUniforms()}},{key:"updateUniforms",value:function(){for(var t=this.materials,i=t.length,e=0;e<i;e++)n.useProgram(t[e].program),this.updateUniform(t[e].uniformLocations[this.name])}},{key:"initVertexAttrib",value:function(t){n.vertexAttrib1f(t,this.x)}},{key:"updateVertexAttrib",value:function(t){n.vertexAttrib1f(t,this.x)}},{key:"initUniform",value:function(t){n.uniform1f(t,this.x)}},{key:"updateUniform",value:function(t){n.uniform1f(t,this.x)}},{key:"initUBOSubdata",value:function(t){t.push(this.x)}},{key:"updateUBOSubdata",value:function(t,n){t[n]=this.x}},{key:"cancelTransition",value:function(){l[this.inTransitions](this.transitionIndex)}},{key:"setTransition",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateTransition,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateTransition",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,o[2+~(1-1e-10*~~this.transitionInterpolation)](this)}},{key:"setTransitionWithUniforms",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateTransitionWithUniforms,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateTransitionWithUniforms",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,o[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms()}},{key:"setCallbackTransition",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateCallbackTransition,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateCallbackTransition",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,o[2+~(1-1e-10*~~this.transitionInterpolation)](this),t.clbk()}},{key:"setCallbackTransitionWithUniforms",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateCallbackTransitionWithUniforms,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateCallbackTransitionWithUniforms",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,o[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms(),t.clbk()}},{key:"setExtendedTransition",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionOnProgress=t.onProgress||r,this.transitionOnEnd=t.onEnd||r,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateExtendedTransition,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateExtendedTransition",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,u[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.transitionOnProgress()}},{key:"setExtendedTransitionWithUniforms",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.x,this.transitionTo=t.to,this.transitionOnProgress=t.onProgress||r,this.transitionOnEnd=t.onEnd||r,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateExtendedTransitionWithUniforms,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateExtendedTransitionWithUniforms",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,u[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms(),this.transitionOnProgress()}}]),h}()}},function(t,n){t.exports=function(){}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext;return function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t),this.class="DataFloat3",this.applyOptions(n)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(t,[{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",x:0,y:0,z:0,updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom={},this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[]}},{key:"uniform",value:function(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform vec3 ".concat(this.name,";")}},{key:"set",value:function(t,n,i){this.x=t||this.x,this.y=n||this.y,this.z=i||this.z}},{key:"reset",value:function(){this.x=0,this.y=0,this.z=0}},{key:"setWithUniforms",value:function(t,n,i){this.x=t||this.x,this.y=n||this.y,this.z=i||this.z,this.updateUniforms()}},{key:"updateUniforms",value:function(){for(var t=this.materials,i=t.length,e=0;e<i;e++)n.useProgram(t[e].program),this.updateUniform(t[e].uniformLocations[this.name])}},{key:"initVertexAttrib",value:function(t){n.vertexAttrib3f(t,this.x,this.y,this.z)}},{key:"updateVertexAttrib",value:function(t){n.vertexAttrib3f(t,this.x,this.y,this.z)}},{key:"initUniform",value:function(t){n.uniform3f(t,this.x,this.y,this.z)}},{key:"updateUniform",value:function(t){n.uniform3f(t,this.x,this.y,this.z)}},{key:"initUBOSubdata",value:function(t){t.push(this.x,this.y,this.z)}},{key:"updateUBOSubdata",value:function(t,n){t[n]=this.x,t[n+1]=this.y,t[n+2]=this.z}},{key:"multiplyScalar",value:function(t){this.x*=t,this.y*=t,this.z*=t}},{key:"applyMatrix4",value:function(t){var n=this.x,i=this.y,e=this.z,r=t.arr,a=1/(r[3]*n+r[7]*i+r[11]*e+r[15]);this.x=(r[0]*n+r[4]*i+r[8]*e+r[12])*a,this.y=(r[1]*n+r[5]*i+r[9]*e+r[13])*a,this.z=(r[2]*n+r[6]*i+r[10]*e+r[14])*a}},{key:"applyMatrix4Array",value:function(t){var n=this.x,i=this.y,e=this.z,r=1/(t[3]*n+t[7]*i+t[11]*e+t[15]);this.x=(t[0]*n+t[4]*i+t[8]*e+t[12])*r,this.y=(t[1]*n+t[5]*i+t[9]*e+t[13])*r,this.z=(t[2]*n+t[6]*i+t[10]*e+t[14])*r}},{key:"cloneApplyMatrix4",value:function(t){var n=this.x,i=this.y,e=this.z,r=t.arr,a=1/(r[3]*n+r[7]*i+r[11]*e+r[15]);return new this.constructor({x:(r[0]*n+r[4]*i+r[8]*e+r[12])*a,y:(r[1]*n+r[5]*i+r[9]*e+r[13])*a,z:(r[2]*n+r[6]*i+r[10]*e+r[14])*a})}},{key:"cloneApplyMatrix4Array",value:function(t){var n=this.x,i=this.y,e=this.z,r=1/(t[3]*n+t[7]*i+t[11]*e+t[15]);return new this.constructor({x:(t[0]*n+t[4]*i+t[8]*e+t[12])*r,y:(t[1]*n+t[5]*i+t[9]*e+t[13])*r,z:(t[2]*n+t[6]*i+t[10]*e+t[14])*r})}},{key:"cloneObjApplyMatrix4",value:function(t){var n=this.x,i=this.y,e=this.z,r=t.arr,a=1/(r[3]*n+r[7]*i+r[11]*e+r[15]);return{x:(r[0]*n+r[4]*i+r[8]*e+r[12])*a,y:(r[1]*n+r[5]*i+r[9]*e+r[13])*a,z:(r[2]*n+r[6]*i+r[10]*e+r[14])*a}}},{key:"cloneObjApplyMatrix4Array",value:function(t){var n=this.x,i=this.y,e=this.z,r=1/(t[3]*n+t[7]*i+t[11]*e+t[15]);return{x:(t[0]*n+t[4]*i+t[8]*e+t[12])*r,y:(t[1]*n+t[5]*i+t[9]*e+t[13])*r,z:(t[2]*n+t[6]*i+t[10]*e+t[14])*r}}},{key:"divideScalar",value:function(t){this.multiplyScalar(1/t)}},{key:"length",value:function(){var t=this.x,n=this.y,i=this.z;return Math.sqrt(t*t+n*n+i*i)}},{key:"normalize",value:function(){this.divideScalar(this.length()||1)}},{key:"setFromMatrixColumn",value:function(t,n){this.fromArray(t.arr,4*n)}},{key:"fromArray",value:function(t,n){void 0===n&&(n=0),this.x=t[n],this.y=t[n+1],this.z=t[n+2]}}]),t}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}t.exports=function(t){var n=t.WebGLRenderingContext;return function(){return function t(){i(this,t),this.test=n,this.class="DataFloat4"}}()}},function(t,n){t.exports=function(){}},function(t,n){t.exports=function(){}},function(t,n){t.exports=function(){}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}var r=function(){};t.exports=function(t){var n=t.WebGLRenderingContext,a=t.transitions,s=t.frameTime,o=[function(t){var n=t.transitionFunc(t.transitionInterpolation),i=t.transitionFrom,e=t.transitionTo,r=t.arr;r[0]=i[0]+n*(e[0]-i[0]),r[1]=i[1]+n*(e[1]-i[1]),t.transitionCurrentTime+=s.x},function(t){var n=t.transitionTo,i=t.arr;i[0]=n[0],i[1]=n[1],t.cancelTransition()}],u=[function(t){var n=t.transitionFunc(t.transitionInterpolation),i=t.transitionFrom,e=t.transitionTo,r=t.arr;r[0]=i[0]+n*(e[0]-i[0]),r[1]=i[1]+n*(e[1]-i[1]),t.transitionCurrentTime+=s.x},function(t){var n=t.transitionTo,i=t.arr;i[0]=n[0],i[1]=n[1],t.cancelTransition(),t.transitionOnEnd()}],l=[r,function(t){var n=a[a.length-1];n.transitionIndex=t,a[t].inTransitions--,a[t]=n,a.pop()}];return function(){function h(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,h),this.class="DataArrayFloat2",this.applyOptions(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(h,[{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([0,0]),updated:!0,excludeMaterials:[]},t),this.inTransitions=0,this.transitionIndex=0,this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[]}},{key:"uniform",value:function(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform vec2 ".concat(this.name,";")}},{key:"set",value:function(t,n){var i=this.arr;i[0]=t||i[0],i[1]=n||i[1]}},{key:"reset",value:function(){var t=this.arr;t[0]=0,t[1]=0}},{key:"setWithUniforms",value:function(t,n){var i=this.arr;i[0]=t||i[0],i[1]=n||i[1],this.updateUniforms()}},{key:"updateUniforms",value:function(){for(var t=this.materials,i=t.length,e=0;e<i;e++)n.useProgram(t[e].program),this.updateUniform(t[e].uniformLocations[this.name])}},{key:"initVertexAttrib",value:function(t){n.vertexAttrib2fv(t,this.arr)}},{key:"updateVertexAttrib",value:function(t){n.vertexAttrib2fv(t,this.arr)}},{key:"initUniform",value:function(t){n.uniform2fv(t,this.arr)}},{key:"updateUniform",value:function(t){n.uniform2fv(t,this.arr)}},{key:"initUBOSubdata",value:function(t){var n=this.arr;t.push(n[0],n[1])}},{key:"updateUBOSubdata",value:function(t,n){var i=this.arr;t[n]=i[0],t[n+1]=i[1]}},{key:"cancelTransition",value:function(){l[this.inTransitions](this.transitionIndex)}},{key:"setTransition",value:function(n){this.cancelTransition(),this.transitionFunc=n.func,this.transitionDuration=n.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=n.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateTransition,t.transitions.push(this)}},{key:"updateTransition",value:function(){o[~~(this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration)](this)}},{key:"setCallbackTransition",value:function(n){this.cancelTransition(),this.transitionFunc=n.func,this.transitionDuration=n.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=n.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateCallbackTransition,t.transitions.push(this)}},{key:"updateCallbackTransition",value:function(){o[~~(this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration)](this)}},{key:"setCallbackTransitionWithUniforms",value:function(t){this.cancelTransition(),this.transitionFunc=t.func,this.transitionDuration=t.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=t.to,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateCallbackTransitionWithUniforms,this.inTransitions++,this.transitionIndex=a.push(this)-1}},{key:"updateCallbackTransitionWithUniforms",value:function(){this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration,o[2+~(1-1e-10*~~this.transitionInterpolation)](this),this.updateUniforms(),t.clbk()}},{key:"setExtendedTransition",value:function(n){this.cancelTransition(),this.transitionFunc=n.func,this.transitionDuration=n.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=n.to,this.transitionOnProgress=n.onProgress||r,this.transitionOnEnd=n.onEnd||r,this.transitionCurrentTime=s.x,this.updateTransitionFunction=this.updateExtendedTransition,t.transitions.push(this)}},{key:"updateExtendedTransition",value:function(){u[~~(this.transitionInterpolation=this.transitionCurrentTime/this.transitionDuration)](this)}}]),h}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext;return function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t),this.class="DataArrayFloat3",this.applyOptions(n)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(t,[{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([0,0,0]),updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[]}},{key:"set",value:function(t,n,i){var e=this.arr;e[0]=t||e[0],e[1]=n||e[1],e[2]=i||e[2]}},{key:"reset",value:function(){var t=this.arr;t[0]=0,t[1]=0,t[2]=0}},{key:"setWithUniforms",value:function(t,n,i){var e=this.arr;e[0]=t||e[0],e[1]=n||e[1],e[2]=i||e[2],this.updateUniforms()}},{key:"updateUniforms",value:function(){for(var t=this.materials,i=t.length,e=0;e<i;e++)n.useProgram(t[e].program),this.updateUniform(t[e].uniformLocations[this.name])}},{key:"initVertexAttrib",value:function(t){n.vertexAttrib3fv(t,this.arr)}},{key:"updateVertexAttrib",value:function(t){n.vertexAttrib3fv(t,this.arr)}},{key:"initUniform",value:function(t){n.uniform3fv(t,this.arr)}},{key:"updateUniform",value:function(t){n.uniform3fv(t,this.arr)}},{key:"initUBOSubdata",value:function(t){var n=this.arr;t.push(n[0],n[1],n[2])}},{key:"updateUBOSubdata",value:function(t,n){var i=this.arr;t[n]=i[0],t[n+1]=i[1],t[n+2]=i[2]}}]),t}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}var r=function(){return 0};t.exports=function(t){var n=t.WebGLRenderingContext;return[r].undefined=function(n){return t.transitions.splice(n,1)},function(){function a(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,a),this.class="DataArrayFloat4",this.applyOptions(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(a,[{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([0,0,0,1]),updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[]}},{key:"set",value:function(t,n,i,e){var r=this.arr;r[0]=t||r[0],r[1]=n||r[1],r[2]=i||r[2],r[3]=e||r[3]}},{key:"reset",value:function(){var t=this.arr;t[0]=0,t[1]=0,t[2]=0,t[3]=1}},{key:"setWithUniforms",value:function(t,n,i,e){var r=this.arr;r[0]=t||r[0],r[1]=n||r[1],r[2]=i||r[2],r[3]=e||r[3],this.updateUniforms()}},{key:"updateUniforms",value:function(){for(var t=this.materials,i=t.length,e=0;e<i;e++)n.useProgram(t[e].program),this.updateUniform(t[e].uniformLocations[this.name])}},{key:"initVertexAttrib",value:function(t){n.vertexAttrib4fv(t,this.arr)}},{key:"updateVertexAttrib",value:function(t){n.vertexAttrib4fv(t,this.arr)}},{key:"initUniform",value:function(t){n.uniform4fv(t,this.arr)}},{key:"updateUniform",value:function(t){n.uniform4fv(t,this.arr)}},{key:"initUBOSubdata",value:function(t){var n=this.arr;t.push(n[0],n[1],n[2],n[3])}},{key:"updateUBOSubdata",value:function(t,n){var i=this.arr;t[n]=i[0],t[n+1]=i[1],t[n+2]=i[2],t[n+3]=i[3]}},{key:"setTransition",value:function(n){this.cancelTransition(),this.transitionFunc=n.func,this.transitionDuration=n.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=n.to,this.transitionCurrentTime=t.frameTime.x,this.updateTransitionFunction=this.updateTransition,t.transitions.push(this)}},{key:"setCallbackTransition",value:function(n){this.cancelTransition(),this.transitionFunc=n.func,this.transitionDuration=n.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=n.to,this.transitionCurrentTime=t.frameTime.x,this.updateTransitionFunction=this.updateCallbackTransition,t.transitions.push(this)}},{key:"setExtendedTransition",value:function(n){this.cancelTransition(),this.transitionFunc=n.func,this.transitionDuration=n.duration,this.transitionFrom=this.arr.slice(),this.transitionTo=n.to,this.transitionOnProgress=n.onProgress||r,this.transitionOnEnd=n.onEnd||r,this.transitionCurrentTime=t.frameTime.x,this.updateTransitionFunction=this.updateExtendedTransition,t.transitions.push(this)}}]),a}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext;return function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t),this.class="Mat4",this.applyOptions(n)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(t,[{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",arr:t.arr||new Float32Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]),updated:!0,excludeMaterials:[]},t),this.transitionFunc=null,this.transitionDuration=null,this.transitionFrom=null,this.transitionTo=null,this.transitionOnProgress=null,this.transitionOnEnd=null,this.transitionCurrentTime=null,this.updateTransitionFunction=null,this.materials=[]}},{key:"uniform",value:function(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform mat4 ".concat(this.name,";")}},{key:"set",value:function(t){this.arr=t.slice()}},{key:"reset",value:function(){var t=this.arr;t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1}},{key:"updateUniforms",value:function(){for(var t=this.materials,i=t.length,e=0;e<i;e++)n.useProgram(t[e].program),this.updateUniform(t[e].uniformLocations[this.name])}},{key:"initUniform",value:function(t){n.uniformMatrix4fv(t,!1,this.arr)}},{key:"updateUniform",value:function(t){n.uniformMatrix4fv(t,!1,this.arr)}},{key:"initUBOSubdata",value:function(t){var n=this.arr;t.push(n[0],n[1],n[2],n[3],n[4],n[5],n[6],n[7],n[8],n[9],n[10],n[11],n[12],n[13],n[14],n[15])}},{key:"updateUBOSubdata",value:function(t,n){var i=this.arr;t[n]=i[0],t[n+1]=i[1],t[n+2]=i[2],t[n+3]=i[3],t[n+4]=i[4],t[n+5]=i[5],t[n+6]=i[6],t[n+7]=i[7],t[n+8]=i[8],t[n+9]=i[9],t[n+10]=i[10],t[n+11]=i[11],t[n+12]=i[12],t[n+13]=i[13],t[n+14]=i[14],t[n+15]=i[15]}},{key:"setRotationFromQuaternion",value:function(t){var n=this.arr,i=t.x,e=t.y,r=t.z,a=t.w,s=i+i,o=e+e,u=r+r,l=i*s,h=i*o,c=i*u,f=e*o,p=e*u,d=r*u,y=a*s,m=a*o,v=a*u;n[0]=1-(f+d),n[1]=h+v,n[2]=c-m,n[3]=0,n[4]=h-v,n[5]=1-(l+d),n[6]=p+y,n[7]=0,n[8]=c+m,n[9]=p-y,n[10]=1-(l+f),n[11]=0,n[12]=0,n[13]=0,n[14]=0,n[15]=1}},{key:"premultiply",value:function(t){var n=this.arr,i=this.arr.slice();n[0]=t[0]*i[0]+t[4]*i[1]+t[8]*i[2]+t[12]*i[3],n[1]=t[1]*i[0]+t[5]*i[1]+t[9]*i[2]+t[13]*i[3],n[2]=t[2]*i[0]+t[6]*i[1]+t[10]*i[2]+t[14]*i[3],n[3]=t[3]*i[0]+t[7]*i[1]+t[11]*i[2]+t[15]*i[3],n[4]=t[0]*i[4]+t[4]*i[5]+t[8]*i[6]+t[12]*i[7],n[5]=t[1]*i[4]+t[5]*i[5]+t[9]*i[6]+t[13]*i[7],n[6]=t[2]*i[4]+t[6]*i[5]+t[10]*i[6]+t[14]*i[7],n[7]=t[3]*i[4]+t[7]*i[5]+t[11]*i[6]+t[15]*i[7],n[8]=t[0]*i[8]+t[4]*i[9]+t[8]*i[10]+t[12]*i[11],n[9]=t[1]*i[8]+t[5]*i[9]+t[9]*i[10]+t[13]*i[11],n[10]=t[2]*i[8]+t[6]*i[9]+t[10]*i[10]+t[14]*i[11],n[11]=t[3]*i[8]+t[7]*i[9]+t[11]*i[10]+t[15]*i[11],n[12]=t[0]*i[12]+t[4]*i[13]+t[8]*i[14]+t[12]*i[15],n[13]=t[1]*i[12]+t[5]*i[13]+t[9]*i[14]+t[13]*i[15],n[14]=t[2]*i[12]+t[6]*i[13]+t[10]*i[14]+t[14]*i[15],n[15]=t[3]*i[12]+t[7]*i[13]+t[11]*i[14]+t[15]*i[15]}},{key:"postmultiply",value:function(t){var n=this.arr,i=this.arr.slice();n[0]=i[0]*t[0]+i[4]*t[1]+i[8]*t[2]+i[12]*t[3],n[1]=i[1]*t[0]+i[5]*t[1]+i[9]*t[2]+i[13]*t[3],n[2]=i[2]*t[0]+i[6]*t[1]+i[10]*t[2]+i[14]*t[3],n[3]=i[3]*t[0]+i[7]*t[1]+i[11]*t[2]+i[15]*t[3],n[4]=i[0]*t[4]+i[4]*t[5]+i[8]*t[6]+i[12]*t[7],n[5]=i[1]*t[4]+i[5]*t[5]+i[9]*t[6]+i[13]*t[7],n[6]=i[2]*t[4]+i[6]*t[5]+i[10]*t[6]+i[14]*t[7],n[7]=i[3]*t[4]+i[7]*t[5]+i[11]*t[6]+i[15]*t[7],n[8]=i[0]*t[8]+i[4]*t[9]+i[8]*t[10]+i[12]*t[11],n[9]=i[1]*t[8]+i[5]*t[9]+i[9]*t[10]+i[13]*t[11],n[10]=i[2]*t[8]+i[6]*t[9]+i[10]*t[10]+i[14]*t[11],n[11]=i[3]*t[8]+i[7]*t[9]+i[11]*t[10]+i[15]*t[11],n[12]=i[0]*t[12]+i[4]*t[13]+i[8]*t[14]+i[12]*t[15],n[13]=i[1]*t[12]+i[5]*t[13]+i[9]*t[14]+i[13]*t[15],n[14]=i[2]*t[12]+i[6]*t[13]+i[10]*t[14]+i[14]*t[15],n[15]=i[3]*t[12]+i[7]*t[13]+i[11]*t[14]+i[15]*t[15]}},{key:"premultiplyPosition",value:function(t){var n=this.arr,i=this.arr.slice(),e=t.x,r=t.y,a=t.z;n[0]=i[0]+e*i[3],n[1]=i[1]+r*i[3],n[2]=i[2]+a*i[3],n[3]=i[3],n[4]=i[4]+e*i[7],n[5]=i[5]+r*i[7],n[6]=i[6]+a*i[7],n[7]=i[7],n[8]=i[8]+e*i[11],n[9]=i[9]+r*i[11],n[10]=i[10]+a*i[11],n[11]=i[11],n[12]=i[12]+e*i[15],n[13]=i[13]+r*i[15],n[14]=i[14]+a*i[15],n[15]=i[15]}},{key:"getInverse",value:function(t){var n=this.arr,i=t[9]*t[14]*t[7]-t[13]*t[10]*t[7]+t[13]*t[6]*t[11]-t[5]*t[14]*t[11]-t[9]*t[6]*t[15]+t[5]*t[10]*t[15],e=t[12]*t[10]*t[7]-t[8]*t[14]*t[7]-t[12]*t[6]*t[11]+t[4]*t[14]*t[11]+t[8]*t[6]*t[15]-t[4]*t[10]*t[15],r=t[8]*t[13]*t[7]-t[12]*t[9]*t[7]+t[12]*t[5]*t[11]-t[4]*t[13]*t[11]-t[8]*t[5]*t[15]+t[4]*t[9]*t[15],a=t[12]*t[9]*t[6]-t[8]*t[13]*t[6]-t[12]*t[5]*t[10]+t[4]*t[13]*t[10]+t[8]*t[5]*t[14]-t[4]*t[9]*t[14],s=1/(t[0]*i+t[1]*e+t[2]*r+t[3]*a);n[0]=i*s,n[1]=(t[13]*t[10]*t[3]-t[9]*t[14]*t[3]-t[13]*t[2]*t[11]+t[1]*t[14]*t[11]+t[9]*t[2]*t[15]-t[1]*t[10]*t[15])*s,n[2]=(t[5]*t[14]*t[3]-t[13]*t[6]*t[3]+t[13]*t[2]*t[7]-t[1]*t[14]*t[7]-t[5]*t[2]*t[15]+t[1]*t[6]*t[15])*s,n[3]=(t[9]*t[6]*t[3]-t[5]*t[10]*t[3]-t[9]*t[2]*t[7]+t[1]*t[10]*t[7]+t[5]*t[2]*t[11]-t[1]*t[6]*t[11])*s,n[4]=e*s,n[5]=(t[8]*t[14]*t[3]-t[12]*t[10]*t[3]+t[12]*t[2]*t[11]-t[0]*t[14]*t[11]-t[8]*t[2]*t[15]+t[0]*t[10]*t[15])*s,n[6]=(t[12]*t[6]*t[3]-t[4]*t[14]*t[3]-t[12]*t[2]*t[7]+t[0]*t[14]*t[7]+t[4]*t[2]*t[15]-t[0]*t[6]*t[15])*s,n[7]=(t[4]*t[10]*t[3]-t[8]*t[6]*t[3]+t[8]*t[2]*t[7]-t[0]*t[10]*t[7]-t[4]*t[2]*t[11]+t[0]*t[6]*t[11])*s,n[8]=r*s,n[9]=(t[12]*t[9]*t[3]-t[8]*t[13]*t[3]-t[12]*t[1]*t[11]+t[0]*t[13]*t[11]+t[8]*t[1]*t[15]-t[0]*t[9]*t[15])*s,n[10]=(t[4]*t[13]*t[3]-t[12]*t[5]*t[3]+t[12]*t[1]*t[7]-t[0]*t[13]*t[7]-t[4]*t[1]*t[15]+t[0]*t[5]*t[15])*s,n[11]=(t[8]*t[5]*t[3]-t[4]*t[9]*t[3]-t[8]*t[1]*t[7]+t[0]*t[9]*t[7]+t[4]*t[1]*t[11]-t[0]*t[5]*t[11])*s,n[12]=a*s,n[13]=(t[8]*t[13]*t[2]-t[12]*t[9]*t[2]+t[12]*t[1]*t[10]-t[0]*t[13]*t[10]-t[8]*t[1]*t[14]+t[0]*t[9]*t[14])*s,n[14]=(t[12]*t[5]*t[2]-t[4]*t[13]*t[2]-t[12]*t[1]*t[6]+t[0]*t[13]*t[6]+t[4]*t[1]*t[14]-t[0]*t[5]*t[14])*s,n[15]=(t[4]*t[9]*t[2]-t[8]*t[5]*t[2]+t[8]*t[1]*t[6]-t[0]*t[9]*t[6]-t[4]*t[1]*t[10]+t[0]*t[5]*t[10])*s}},{key:"transpose",value:function(){var t=this.arr,n=t[1];t[1]=t[4],t[4]=n,n=t[2],t[2]=t[8],t[8]=n,n=t[6],t[6]=t[9],t[9]=n,n=t[3],t[3]=t[12],t[12]=n,n=t[7],t[7]=t[13],t[13]=n,n=t[11],t[11]=t[14],t[14]=n}},{key:"makePerspective",value:function(t){var n=this.arr,i=t[0],e=t[1],r=t[2],a=t[3],s=t[4],o=t[5];n[0]=2*s/(e-i),n[1]=0,n[2]=0,n[3]=0,n[4]=0,n[5]=2*s/(r-a),n[6]=0,n[7]=0,n[8]=(e+i)/(e-i),n[9]=(r+a)/(r-a),n[10]=-(o+s)/(o-s),n[11]=-1,n[12]=0,n[13]=0,n[14]=-2*o*s/(o-s),n[15]=0}},{key:"makeOrthographic",value:function(t){var n=this.arr,i=t[0],e=t[1],r=t[2],a=t[3],s=t[4],o=t[5],u=1/(e-i),l=1/(r-a),h=1/(o-s);n[0]=2*u,n[1]=0,n[2]=0,n[3]=0,n[4]=0,n[5]=2*l,n[6]=0,n[7]=0,n[8]=0,n[9]=0,n[10]=-2*h,n[11]=0,n[12]=-(e+i)*u,n[13]=-(r+a)*l,n[14]=-(o+s)*h,n[15]=1}},{key:"rotate",value:function(t,n){var i=t.x,e=void 0===i?0:i,r=t.y,a=void 0===r?0:r,s=t.z,o=void 0===s?0:s,u=Math.cos(n),l=Math.sin(n),h=e*e,c=a*a,f=o*o,p=e*a,d=e*o,y=a*o,m=1-u,v=e*l,b=a*l,x=o*l;this.premultiply([u+h*m,p*m-x,d*m+b,0,p*m+x,u+c*m,y*m-v,0,d*m-b,y*m+v,u+f*m,0,0,0,0,1])}},{key:"rotateX",value:function(t){var n=Math.cos(t),i=Math.sin(t);this.premultiply([1,0,0,0,0,n,-i,0,0,i,n,0,0,0,0,1])}},{key:"rotateY",value:function(t){var n=Math.cos(t),i=Math.sin(t);this.premultiply([n,0,i,0,0,1,0,0,-i,0,n,0,0,0,0,1])}},{key:"rotateZ",value:function(t){var n=Math.cos(t),i=Math.sin(t);this.premultiply([n,-i,0,0,i,n,0,0,0,0,1,0,0,0,0,1])}},{key:"translate",value:function(t){var n=t.x,i=void 0===n?0:n,e=t.y,r=void 0===e?0:e,a=t.z,s=void 0===a?0:a,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,i*o,r*o,s*o,1])}},{key:"translateX",value:function(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,t,0,0,1])}},{key:"translateY",value:function(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,0,t,0,1])}},{key:"translateZ",value:function(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,1,0,0,0,t,1])}},{key:"scale",value:function(t,n){var i=n-1,e=i*t.x,r=i*t.y,a=e*t.y,s=e*t.z,o=r*t.z;this.premultiply([1+e*t.x,a,s,0,a,1+r*t.y,o,0,s,o,1+i*t.z*t.z,0,0,0,0,1])}},{key:"scaleXYZ",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{x:1,y:1,z:1};this.premultiply([t.x,0,0,0,0,1,t.y,0,0,0,0,t.z,0,0,0,0,1])}},{key:"scaleX",value:function(t){this.premultiply([t,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1])}},{key:"scaleY",value:function(t){this.premultiply([1,0,0,0,0,t,0,0,0,0,1,0,0,0,0,1])}},{key:"scaleZ",value:function(t){this.premultiply([1,0,0,0,0,1,0,0,0,0,t,0,0,0,0,1])}}]),t}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.FLOAT,a=n.STATIC_DRAW,s=n.ARRAY_BUFFER;return function(){function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,o),this.class="VBO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(o,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=n.createBuffer(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",location:0,size:3,type:r,normalized:!1,stride:0,offset:0,content:[],usage:a},i),n.bindBuffer(s,this.buffer),n.bufferData(s,this.content,this.usage),n.enableVertexAttribArray(this.location),n.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset),t.disableVBO()}},{key:"enable",value:function(){n.bindBuffer(s,this.buffer),n.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset)}},{key:"delete",value:function(){n.deleteBuffer(this.buffer)}}]),o}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.FLOAT,a=n.DYNAMIC_DRAW,s=n.ARRAY_BUFFER,o=[function(){},function(t){n.bufferData(s,t.content[(t.current=t.next)+t.index],t.usage)}];return function(){function u(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,u),this.class="MVBO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(u,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=n.createBuffer(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",location:0,size:3,type:r,normalized:!1,stride:0,offset:0,content:[],usage:a,interpolation:new t.DataFloat1,index:0},i),this.current=0,this.next=0,n.bindBuffer(s,this.buffer),n.bufferData(s,this.content[this.index],this.usage),n.enableVertexAttribArray(this.location),n.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset),t.disableVBO()}},{key:"enable",value:function(){t.currentMVBO=this,n.bindBuffer(s,this.buffer);var i=(this.next=this.interpolation.x)-this.current;o[2+~(1-1e-10*~~(i*i))](this),n.vertexAttribPointer(this.location,this.size,this.type,this.normalized,this.stride,this.offset)}},{key:"delete",value:function(){n.deleteBuffer(this.buffer)}}]),u}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.STATIC_DRAW,a=n.ELEMENT_ARRAY_BUFFER;return function(){function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,s),this.class="IBO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(s,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=n.createBuffer(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",content:[],usage:r},i),n.bindBuffer(a,this.buffer),n.bufferData(a,this.content,this.usage),t.disableIBO()}},{key:"enable",value:function(){n.bindBuffer(a,this.buffer)}},{key:"delete",value:function(){n.deleteBuffer(this.buffer)}}]),s}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.DYNAMIC_DRAW,a=n.ELEMENT_ARRAY_BUFFER,s=[function(){},function(t){n.bufferData(a,t.content[t.current=t.next],t.usage)}];return function(){function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,o),this.class="MIBO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(o,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=n.createBuffer(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",content:[],usage:r,interpolation:new t.DataFloat1,index:0},i),this.current=0,this.next=0,n.bindBuffer(a,this.buffer),n.bufferData(a,this.content[0],this.usage),n.bindBuffer(a,null)}},{key:"enable",value:function(){t.currentMIBO=this,n.bindBuffer(a,this.buffer);var i=(this.next=this.interpolation.x)-this.current;s[2+~(1-1e-10*~~(i*i))](this)}},{key:"delete",value:function(){n.deleteBuffer(this.buffer)}}]),o}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext;return function(){function r(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,r),this.class="VAO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(r,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.vertexArray=n.createVertexArray(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",buffers:[]},n),this.buffersByName={},this.enable(),this.handleBuffers(),t.disableVAO()}},{key:"enable",value:function(){n.bindVertexArray(this.vertexArray)}},{key:"addBuffers",value:function(t){this.buffers=this.buffers.concat(t)}},{key:"handleBuffers",value:function(){for(var t=this.buffers,n=t.length,i=0;i<n;i++)t[i].bind()}},{key:"delete",value:function(){n.deleteVertexArray(this.vertexArray)}}]),r}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.DYNAMIC_DRAW,a=n.UNIFORM_BUFFER;return function(){function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,s),this.class="UBO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(s,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.buffer=n.createBuffer(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{content:[],usage:r,name:"",index:0,subData:{},material:null},e),this.updatedSubData=[];var s=[];Object.keys(this.subData).forEach(function(t){s.push(t),t.init(),!1!==t.updated&&i.updatedSubData.push(t)}),this.subData=s,this.enable(),n.bufferData(a,this.content=new Float32Array(this.content),this.usage),n.bindBufferBase(a,this.index,this.buffer),t.disableUBO()}},{key:"enable",value:function(){n.bindBuffer(a,this.buffer)}},{key:"enableSubData",value:function(){n.bindBuffer(a,this.buffer);for(var t=this.updatedSubData.length,i=0;i<t;i++)this.updatedSubData[i].update(this.content,this.offsets[this.updatedSubData[i].name]);n.bufferData(a,this.content,this.usage)}},{key:"delete",value:function(){n.deleteBuffer(this.buffer)}}]),s}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.TEXTURE_2D,a=n.RGBA,s=n.UNSIGNED_BYTE,o=n.LINEAR,u=n.NEAREST,l=n.CLAMP_TO_EDGE,h=n.TEXTURE_MAG_FILTER,c=n.TEXTURE_MIN_FILTER,f=n.TEXTURE_WRAP_S,p=n.TEXTURE_WRAP_T;return function(){function d(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,d),this.class="Texture2D",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(d,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.texture=n.createTexture(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",target:r,unit:0,image:null,internalFormat:a,format:a,width:0,height:0,level:0,border:0,type:s,mag:o,min:o,wrapS:l,wrapT:l,autosize:!0,anisotropy:!1,FBO:!1,excludeMaterials:[]},i),this.materials=[],this.image&&this.autosize&&(this.width=this.image.width,this.height=this.image.height),this.FBO&&(this.min=u,this.mag=u);var e=this.target,d=this.internalFormat,y=this.format,m=this.width,v=this.height,b=this.level,x=this.border,g=this.type,T=this.image,O=this.mag,k=this.min,M=this.wrapS,F=this.wrapT,w=this.anisotropy,A=this.FBO;n.bindTexture(this.target,this.texture),"WebGL2Context"===t.class||A?n.texImage2D(e,b,d,m,v,x,y,g,T):n.texImage2D(e,b,d,d,g,T),n.texParameteri(e,h,O),n.texParameteri(e,c,k),n.texParameteri(e,f,M),n.texParameteri(e,p,F),w&&t.anisotropy&&n.texParameterf(e,t.anisotropy.TEXTURE_MAX_ANISOTROPY_EXT,w),this.image&&n.generateMipmap(e),t.disableTexture2D()}},{key:"uniform",value:function(t){return t.uniforms||(t.uniforms=[]),t.uniforms.push(this),"uniform sampler2D ".concat(this.name,";")}},{key:"enable",value:function(){n.bindTexture(this.target,this.texture)}},{key:"delete",value:function(){n.deleteTexture(this.texture)}},{key:"initUniform",value:function(i){n.activeTexture(t.textureUnits[this.unit]),n.bindTexture(this.target,this.texture),n.uniform1i(i,this.unit)}},{key:"updateUniform",value:function(){n.activeTexture(t.textureUnits[this.unit]),n.bindTexture(this.target,this.texture)}}]),d}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.DEPTH_COMPONENT16,a=n.RGBA8,s=n.RENDERBUFFER;return function(){function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,o),this.class="RBO",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(o,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.renderbuffer=n.createRenderbuffer(),t.samples?this.applyOptionsMultisample(t):this.applyOptions(t)}},{key:"applyOptions",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",format:r,width:0,height:0},n);var i=this.format,e=this.width,a=this.height;this.enable(),t.renderbufferStorage(i,e,a),t.disableRBO()}},{key:"applyOptionsMultisample",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",format:a,width:0,height:0,samples:1},n);var i=this.format,e=this.width,r=this.height,s=this.samples;this.enable(),t.renderbufferStorageMultisample(s,i,e,r),t.disableRBO()}},{key:"enable",value:function(){n.bindRenderbuffer(s,this.renderbuffer)}},{key:"delete",value:function(){n.deleteRenderbuffer(this.renderbuffer)}}]),o}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.FRAMEBUFFER,a=n.READ_FRAMEBUFFER,s=n.DRAW_FRAMEBUFFER;return function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t),this.class="FBO",this.init(n)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(t,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.framebuffer=n.createFramebuffer(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",width:0,height:0},t)}},{key:"enable",value:function(){n.bindFramebuffer(r,this.framebuffer)}},{key:"read",value:function(){n.bindFramebuffer(a,this.framebuffer)}},{key:"draw",value:function(){n.bindFramebuffer(s,this.framebuffer)}},{key:"delete",value:function(){n.deleteFramebuffer(this.framebuffer)}}]),t}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.COLOR_ATTACHMENT0,a=n.DEPTH_ATTACHMENT,s=n.FRAMEBUFFER,o=n.TEXTURE_2D;return function(){function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,n),this.class="Offscreen",this.applyOptions(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(n,[{key:"applyOptions",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",texture:null,RBO:null,FBO:null,textureAttachment:r,renderbufferAttachment:a},n);var i=this.texture,e=this.RBO,u=this.FBO,l=this.textureAttachment,h=this.renderbufferAttachment;u.enable(),e&&t.framebufferRenderbuffer(s,h,e),i&&t.framebufferTexture2D(s,l,o,i),t.disableFBO()}},{key:"render",value:function(n){this.FBO.enable(),n(),t.disableFBO()}}]),n}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.COLOR_ATTACHMENT0,a=n.COLOR_BUFFER_BIT,s=n.NEAREST,o=n.FRAMEBUFFER,u=n.TEXTURE_2D;return function(){function l(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,l),this.class="OffscreenMultisample",this.applyOptions(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(l,[{key:"applyOptions",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",texture:null,RBO:null,readFBO:null,drawFBO:null,textureAttachment:r,renderbufferAttachment:r,mask:a,filter:s},n);var i=this.texture,e=this.RBO,l=this.readFBO,h=this.drawFBO,c=this.textureAttachment,f=this.renderbufferAttachment;l.enable(),t.framebufferRenderbuffer(o,f,e),h.enable(),t.framebufferTexture2D(o,c,u,i),t.disableFBO()}},{key:"render",value:function(i){var e=this.readFBO,r=this.drawFBO;e.enable(),i(),e.read(),r.draw(),n.blitFramebuffer(0,0,e.width,e.height,0,0,r.width,r.height,this.mask,this.filter),t.disableFBO()}}]),l}()}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(t){var n=t.WebGLRenderingContext,r=n.VERTEX_SHADER,a=n.FRAGMENT_SHADER,s=n.LINK_STATUS,o=n.COMPILE_STATUS,u=function(t,i){var e=n.createShader(i);if(n.shaderSource(e,t),n.compileShader(e),!n.getShaderParameter(e,o)){var r="\n".concat(t.split("\n").map(function(t,n){return"".concat(n+1,":").concat(t)}).join("\n"));throw new Error("".concat(r).concat(n.getShaderInfoLog(e)))}return e};return function(){function o(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,o),this.class="Material",this.init(t)}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(o,[{key:"init",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.delete(),this.program=n.createProgram(),this.applyOptions(t)}},{key:"applyOptions",value:function(){var i=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(Object.assign(this,{name:"",VS:null,FS:null,UBO:null,uniforms:null,onBeforeLink:null},e),this.UBOLocations=null,this.uniformLocations=null,this.updatedUniforms=null,"function"==typeof this.VS&&(this.VS=this.VS()),"function"==typeof this.FS&&(this.FS=this.FS()),this.VS.split("\n").filter(function(t){return t.search(/\battribute\b|\bin\b/)>-1}).forEach(function(t,e){var r=t.trim().split(" ").pop().replace(/[^0-9A-Za-z]/g,"");n.bindAttribLocation(i.program,e,r)}),n.attachShader(this.program,u(this.VS,r)),n.attachShader(this.program,u(this.FS,a)),(this.onBeforeLink||{}).call&&this.onBeforeLink(),this.link(),!n.getProgramParameter(this.program,s))throw new Error("".concat(s,", ").concat(n.getProgramInfoLog(this.program)));this.enable(),this.bindUBO(),this.bindUniforms(),t.disableMaterial()}},{key:"enable",value:function(){n.useProgram(this.program)}},{key:"link",value:function(){n.linkProgram(this.program)}},{key:"bindUBO",value:function(){var t=this;(this.UBO||[]).length&&(this.UBOLocations||(this.UBOLocations={}),this.UBO.forEach(function(i){t.UBOLocations[i.name]=n.getUniformLocation(t.program,i.name),n.uniformBlockBinding(t.program,t.UBOLocations[i.name],i.index)}))}},{key:"bindUniforms",value:function(){var t=this;(this.uniforms||[]).length&&(this.uniformLocations||(this.uniformLocations={}),this.uniforms.forEach(function(i){t.uniformLocations[i.name]=n.getUniformLocation(t.program,i.name),i.excludeMaterials&&i.excludeMaterials.indexOf(t.name)<0&&i.materials.push(t),i.initUniform(t.uniformLocations[i.name]),!1!==i.updated&&(t.updatedUniforms||(t.updatedUniforms=[]),t.updatedUniforms.push(i))}))}},{key:"updateUniforms",value:function(){for(var t=this.updatedUniforms,n=t.length,i=0;i<n;i++)t[i].updateUniform(this.uniformLocations[t[i].name])}},{key:"updateAllUniforms",value:function(){for(var t=this.uniforms,n=t.length,i=0;i<n;i++)t[i].updateUniform(this.uniformLocations[t[i].name])}},{key:"delete",value:function(){n.deleteProgram(this.program)}}]),o}()}},function(t,n,i){function e(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function r(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}var a=i(0),s=a.concatArrays,o=a.premultiplyParentMatrices,u=function(){};t.exports=function(t){var n=t.WebGLRenderingContext,i=n.LESS,a=n.BACK,l=n.DEPTH_TEST,h=n.BLEND,c=n.CULL_FACE,f=new t.DataFloat4;return function(){function p(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,p),this.class="Object",this.applyOptions(t)}return function(t,n,i){n&&r(t.prototype,n),i&&r(t,i)}(p,[{key:"applyOptions",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{name:"",material:null,VAO:null,buffers:null,arrays:null,blend:null,children:null,camera:null,draw:null,depthTest:i,cullFace:a,batchIndex:0,verticesNumber:0,enable:u,disable:u,enableChain:u,disableChain:u,mode:u},n),this.quaternion=new t.DataFloat4,this.rotation=new t.DataFloat3,this.position=new t.DataFloat3,this.matrix=new t.Mat4,this.normalMatrix=new t.Mat4,this.scaleMatrix=new t.Mat4,this.rotationMatrix=new t.Mat4,this.parent=null,this.batchIndices=[],this.draw||(this.draw=this.drawSingle),this.bindChain(),t.objects[this.name]=this}},{key:"addBuffers",value:function(t){this.buffers=this.buffers.concat(t)}},{key:"bindChain",value:function(){var t=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;this.parent=n,this.updateMatrix=this["updateMatrix".concat(this.parent?"Parent":"").concat(this.children?"Children":"")],this.children&&this.children.forEach(function(n){return n.bindChain(t)})}},{key:"batch",value:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.batchIndices=this.batchIndices.concat(new Array(this.verticesNumber).fill(this.batchIndex)),s(this,this.children,this.verticesNumber);var i=n.VAO?this.VAO=new t.VAO:this;for(var e in this.arrays){var r=null;"VBO"===this.arrays[e].type?r=new t.VBO({name:e,content:new Float32Array(this.arrays[e].arr),size:this.arrays[e].size||3}):"IBO"===this.arrays[e].type&&(r=new t.IBO({content:new window.Uint16Array(this.arrays[e].arr)})),i.buffers.push(r)}!1!==n.indexVBO&&i.buffers.push(new t.VBO({name:n.indexAttrName||"modelIndex",content:new Float32Array(this.batchIndices),size:1}))}},{key:"enableBlend",value:function(){var t=this.blend,i=t.func;n.enable(h),n.blendEquation(t.equation),n.blendFunc(i.sfactor,i.dfactor)}},{key:"enableBlendSeparate",value:function(){var t=this.blend,i=t.equationSeparate,e=t.funcSeparate;n.enable(h),n.blendEquationSeparate(i.modeRGB,i.modeAlpha),n.blendFuncSeparate(e.srcRGB,e.dstRGB,e.srcAlpha,e.dstAlpha)}},{key:"enableDepthTest",value:function(){n.enable(l),n.depthFunc(this.depthTest)}},{key:"enableCullFace",value:function(){n.enable(c),n.cullFace(this.cullFace)}},{key:"enableVAO",value:function(){this.VAO.enable()}},{key:"enableBuffers",value:function(){for(var t=this.buffers,n=t.length,i=0;i<n;i++)t[i].enable()}},{key:"updateMaterialUniforms",value:function(){this.material.updateUniforms()}},{key:"updateAllMaterialUniforms",value:function(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,this.material.updateAllUniforms()}},{key:"updateMaterialAttributes",value:function(){this.material.updateAttributes()}},{key:"updateAllMaterialAttributes",value:function(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,this.material.updateAllAttributes()}},{key:"drawSingle",value:function(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,n.useProgram(this.material.program),this.enable(),this.mode(),this.disable()}},{key:"updateSingle",value:function(){t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,n.useProgram(this.material.program),this.enable(),this.disable()}},{key:"drawChain",value:function(){var i=this.children,e=i.length;t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,n.useProgram(this.material.program),this.enableChain(),this.enable(),this.mode(),this.disable();for(var r=0;r<e;r++)i[r].draw();this.disableChain()}},{key:"updateChain",value:function(){var i=this.children,e=i.length;t.currentObject=this,t.currentMatrix.arr=this.matrix.arr,t.currentNormalMatrix.arr=this.normalMatrix.arr,n.useProgram(this.material.program),this.enableChain(),this.enable(),this.disable();for(var r=0;r<e;r++)i[r].update();this.disableChain()}},{key:"scale",value:function(t,n){this.scaleMatrix.scale(t,n)}},{key:"scaleXYZ",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{x:1,y:1,z:1};this.scaleMatrix.scaleXYZ(t)}},{key:"scaleX",value:function(t){this.scaleMatrix.scaleX(t)}},{key:"scaleY",value:function(t){this.scaleMatrix.scaleY(t)}},{key:"scaleZ",value:function(t){this.scaleMatrix.scaleZ(t)}},{key:"setRotation",value:function(t,n){var i=this.quaternion;i.setQuaternionRotation(t,n),this.rotationMatrix.setRotationFromQuaternion(i)}},{key:"setRotationX",value:function(t){var n=this.quaternion;n.setQuaternionRotationX(t),this.rotationMatrix.setRotationFromQuaternion(n)}},{key:"setRotationY",value:function(t){var n=this.quaternion;n.setQuaternionRotationY(t),this.rotationMatrix.setRotationFromQuaternion(n)}},{key:"setRotationZ",value:function(t){var n=this.quaternion;n.setQuaternionRotationZ(t),this.rotationMatrix.setRotationFromQuaternion(n)}},{key:"rotate",value:function(t,n){var i=this.quaternion;f.setQuaternionRotation(t,n),i.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(i)}},{key:"rotateX",value:function(t){var n=this.quaternion;f.setQuaternionRotationX(t),n.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(n)}},{key:"rotateY",value:function(t){var n=this.quaternion;f.setQuaternionRotationY(t),n.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(n)}},{key:"rotateZ",value:function(t){var n=this.quaternion;f.setQuaternionRotationZ(t),n.multiplyQuaternion(f),this.rotationMatrix.setRotationFromQuaternion(n)}},{key:"updateNormalMatrix",value:function(){var t=this.normalMatrix;t.getInverse(this.matrix.arr),t.transpose()}},{key:"updateMatrix",value:function(){var t=this.matrix;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position)}},{key:"updateMatrixParent",value:function(){var t=this.matrix;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position),o(this)}},{key:"updateMatrixChildren",value:function(){var t=this.matrix,n=this.children,i=n.length;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position);for(var e=0;e<i;e++)n[e].updateMatrix()}},{key:"updateMatrixParentChildren",value:function(){var t=this.matrix,n=this.children,i=n.length;t.reset(),t.premultiply(this.scaleMatrix.arr),t.premultiply(this.rotationMatrix.arr),t.premultiplyPosition(this.position),o(this);for(var e=0;e<i;e++)n[e].updateMatrix()}}]),p}()}},function(t,n){function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function e(t,n){return!n||"object"!==i(n)&&"function"!=typeof n?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):n}function r(t){return(r=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function a(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&s(t,n)}function s(t,n){return(s=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}function o(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function u(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}function l(t,n,i){return n&&u(t.prototype,n),i&&u(t,i),t}t.exports=function(t){var n=function(){function n(){o(this,n),this.class="Camera",this.matrix=new t.Mat4,this.viewMatrix=new t.Mat4({name:"viewMatrix"}),this.projectionMatrix=new t.Mat4({name:"projectionMatrix"}),this.position=new t.DataFloat3({name:"cameraPosition"}),this.fov=0,this.aspect=0,this.near=0,this.far=0,this.zoom=0,this.left=0,this.right=0,this.top=0,this.bottom=0,this.near=0}return l(n,[{key:"updateProjectionMatrixPerspective",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{fov:45,aspect:window.innerWidth/window.innerHeight,near:1,far:1e3,zoom:1},t);var n=this.fov,i=this.aspect,e=this.near,r=this.far,a=this.zoom,s=e*Math.tan(.008726646*n)/(a||1),o=2*s,u=i*o,l=-.5*u;this.projectionMatrix.makePerspective([l,l+u,s,s-o,e,r])}},{key:"updateProjectionMatrixOrthographic",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Object.assign(this,{left:window.innerWidth/-2,right:window.innerWidth/2,top:window.innerHeight/2,bottom:window.innerHeight/-2,near:1,far:1e3,zoom:1},t);var n=this.left,i=this.right,e=this.top,r=this.bottom,a=this.near,s=this.far,o=this.zoom,u=(i-n)/(2*(o||1)),l=(e-r)/(2*(o||1)),h=(i+n)/2,c=(e+r)/2,f=h-u,p=h+u,d=c+l,y=c-l;this.projectionMatrix.makeOrthographic([f,p,d,y,a,s])}},{key:"updateViewMatrix",value:function(){this.viewMatrix.getInverse(this.matrix.arr)}}]),n}();return{Camera:n,PerspectiveCamera:function(t){function i(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return o(this,i),(t=e(this,r(i).call(this))).class="PerspectiveCamera",t.updateProjectionMatrix(n),t}return a(i,n),l(i,[{key:"updateProjectionMatrix",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.updateProjectionMatrixPerspective(t),this}}]),i}(),OrthographicCamera:function(t){function i(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return o(this,i),(t=e(this,r(i).call(this))).class="OrthographicCamera",t.updateProjectionMatrix(n),t}return a(i,n),l(i,[{key:"updateProjectionMatrix",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.updateProjectionMatrixOrthographic(t),this}}]),i}(),Orbit:function(){function n(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};o(this,n),this.class="Orbit",Object.assign(this,{camera:new t.PerspectiveCamera,rotation:new t.DataArrayFloat2({name:"orbitRotation"}),translation:new t.DataFloat3({name:"orbitTranslation"})},i)}return l(n,[{key:"update",value:function(){var t=this.camera,n=t.position,i=t.matrix,e=this.rotation.arr,r=this.translation;i.reset(),i.rotateX(e[0]),i.rotateY(e[1]),n.x=r.x,n.y=r.y,n.z=r.z,n.applyMatrix4Array(i.arr),n.updateUniforms(),i.translate(n),t.viewMatrix.getInverse(i.arr),t.viewMatrix.updateUniforms()}}]),n}()}}},function(t,n){t.exports={Linear:function(t){return t},BezierCubicCurve:function(t,n,i,e){var r=2*Math.PI/3,a=3*t,s=3*i,o=a-s+1,u=(s-2*a)/o,l=u*u,h=a/o*3,c=h*u*3-2*l*u,f=(h-l)/9,p=f*f*f,d=Math.sqrt(-f),y=-d*f,m=2*d,v=u/3,b=[function(t,n){return n},function(t,n){return-t-n}],x=[function(t){return t},function(t,n){return b[1+~~(m*n-v)](t,n)}],g=[function(t){var n=Math.acos(t/y)/3,i=Math.cos(n),e=Math.cos(n+r);return m*x[~~(m*i-v)](i,e)},function(t,n){var i=Math.sqrt(n);return Math.cbrt(t+i)+Math.cbrt(t-i)}];return g[2]=g[1],function(t){var i=(c+27*t/o)/54,r=p+i*i,a=g[Math.floor(r)+1](i,r)-v,s=1-a,u=a*a;return 3*a*s*s*n+3*u*s*e+u*a}},GaussCurve:function(t,n){return 1/(t*Math.sqrt(2*Math.PI))*Math.exp(-n*n/2/t/t)},TriangleSquare:function(t,n,i){var e=Math.sqrt(2*(i.x-n.x)+2*(i.y-n.y)+2*(i.z-n.z)),r=Math.sqrt(2*(i.x-t.x)+2*(i.y-t.y)+2*(i.z-t.z)),a=Math.sqrt(2*(n.x-t.x)+2*(n.x-t.x)+2*(n.x-t.x)),s=(e+r+a)/2;return Math.sqrt(s*(s-e)*(s-r)*(s-a))},inTriangle2D:function(t,n,i,e){var r=(t.x-e.x)*(n.y-t.y)>(n.x-t.x)*(t.y-e.y),a=(n.x-e.x)*(i.y-n.y)>(i.x-n.x)*(n.y-e.y),s=(i.x-e.x)*(t.y-i.y)>(t.x-i.x)*(i.y-e.y);return r===a&&a===s}}},function(t,n){function i(t,n){if(!function(t,n){return null!=n&&"undefined"!=typeof Symbol&&n[Symbol.hasInstance]?n[Symbol.hasInstance](t):t instanceof n}(t,n))throw new TypeError("Cannot call a class as a function")}function e(t,n){for(var i=0;i<n.length;i++){var e=n[i];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}t.exports=function(){function t(){i(this,t),Object.assign(this,{content:{},length:null,current:null,loaded:null,progress:null,rejectOnError:!1})}return function(t,n,i){n&&e(t.prototype,n),i&&e(t,i)}(t,[{key:"getXhr",value:function(t,n,i,e,r){var a=this,s=new XMLHttpRequest;return s.lastLoaded=0,s.image=null,s.lengthComputable=!0,s.loaded=0,s.open("GET",n,!0),"image"===t?(s.responseType="arraybuffer",s.image=new Image):"document"===t?(s.responseType=t,s.overrideMimeType("text/xml")):s.responseType=t,s.setRequestHeader("X-Requested-With","XMLHttpRequest"),s.setRequestHeader("Content-type","text"),s.onprogress=function(t){return a.onprogress(s,t)},s.onload=function(){200===s.status?"image"===t?(s.image.onload=function(){return a.onload(s,i,e)},s.image.src=window.URL.createObjectURL(new Blob([s.response]))):a.onload(s,i,e):a.rejectOnError?r(s):a.onloadBroken(s,i,e)},s.onerror=function(t){return r(t)},s}},{key:"load",value:function(t){var n=this;return new Promise(function(i,e){if(t&&t.sources)for(var r in Object.assign(n,{length:Object.keys(t.sources).length,current:0,loaded:0,progress:function(){return 0},rejectOnError:!1},t),t.sources){var a=t.sources[r];n.content[r]=n.getXhr(a.type||"text",a.source||a,r,i,e),n.content[r].send()}else e(new Error("GLKIT Loader: no sources."))})}},{key:"onprogress",value:function(t,n){t.lengthComputable=n.lengthComputable,t.lengthComputable&&(this.loaded+=n.loaded/n.total-t.lastLoaded,t.lastLoaded=n.loaded/n.total,t.loaded=t.lastLoaded,this.progress())}},{key:"onload",value:function(t,n,i){this.loaded+=t.lengthComputable?1-t.loaded:1,this.progress();var e=this.content[n];this.content[n]=e.image||e.response||e.responseText,++this.current===this.length&&(this.loaded=this.length,this.progress(),i(this.content))}},{key:"onloadBroken",value:function(t,n,i){this.loaded++,this.progress(),this.content[n]=null,++this.current===this.length&&(this.loaded=this.length,this.progress(),i(this.content))}}]),t}()}])});

/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./src/components/buttons/index.js":
/*!*****************************************!*\
  !*** ./src/components/buttons/index.js ***!
  \*****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./style.scss */ "./src/components/buttons/style.scss");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ "./src/components/buttons/style.scss":
/*!*******************************************!*\
  !*** ./src/components/buttons/style.scss ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/dialog/index.js":
/*!****************************************!*\
  !*** ./src/components/dialog/index.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Dialog; });
function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Dialog =
/*#__PURE__*/
function () {
  function Dialog(selector) {
    _classCallCheck(this, Dialog);

    this.el = $(selector); // jQ obj

    this.enabled = false;
    this.data = {
      comment: ''
    };
  }

  _createClass(Dialog, [{
    key: "open",
    value: function open() {
      this.enabled = true;
      this.el.fadeIn(150);
    }
  }, {
    key: "close",
    value: function close() {
      this.enabled = false;
      this.el.fadeOut(150);
    }
  }]);

  return Dialog;
}();


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./src/components/index.js":
/*!*********************************!*\
  !*** ./src/components/index.js ***!
  \*********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./buttons */ "./src/components/buttons/index.js");
/* harmony import */ var _scrollbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scrollbar */ "./src/components/scrollbar/index.js");



/***/ }),

/***/ "./src/components/scrollbar/index.js":
/*!*******************************************!*\
  !*** ./src/components/scrollbar/index.js ***!
  \*******************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./style.scss */ "./src/components/scrollbar/style.scss");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ "./src/components/scrollbar/style.scss":
/*!*********************************************!*\
  !*** ./src/components/scrollbar/style.scss ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/js/cameras.js":
/*!***************************!*\
  !*** ./src/js/cameras.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(catchCallback) {module.exports = function (CTX, parent) {
  try {
    var orbit = new CTX.Orbit({
      camera: new CTX.Camera(),
      rotation: new CTX.DataArrayFloat2({
        name: 'orbitRotation'
      }),
      translation: new CTX.DataFloat3({
        name: 'orbitTranslation',
        z: 750
      })
    });
    orbit.startX = 0;
    orbit.currentX = 0;
    orbit.endX = 0;
    orbit.currentY = 0;
    orbit.endY = 0;
    orbit.startY = 0;
    var updateProjectionMatrix = [function () {
      return orbit.camera.updateProjectionMatrixPerspective({
        fov: 10,
        aspect: parent.offsetWidth / parent.offsetHeight,
        near: 1,
        far: 2000
      });
    }, function () {
      return orbit.camera.updateProjectionMatrixOrthographic({
        left: -parent.offsetWidth * 0.5,
        right: parent.offsetWidth * 0.5,
        top: parent.offsetHeight * 0.5,
        bottom: -parent.offsetHeight * 0.5,
        near: 1,
        far: 2000,
        zoom: 6
      });
    }];
    return {
      orbit: orbit,
      updateProjectionMatrix: updateProjectionMatrix
    };
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'cameras');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/catch-callback.js":
/*!**********************************!*\
  !*** ./src/js/catch-callback.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (evt, module) {
  if (false) { var url, error; }

  console.error(evt);
  throw '';
};

/***/ }),

/***/ "./src/js/circles.js":
/*!***************************!*\
  !*** ./src/js/circles.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(catchCallback) {module.exports = function (CTX, gl, uProjMat, uViewMat, uVisLower, uuIndex, uZoom, uVisUpper, uRotXY, sep, SEPARATIONS, values, ROTATION_MATRIX_X, ROTATION_MATRIX_Y) {
  try {
    var TRIANGLES = gl.TRIANGLES,
        UNSIGNED_SHORT = gl.UNSIGNED_SHORT;
    var n = -1;
    var position = [];
    var location = [];
    var indices = [];
    var indexes = [];
    var origin = [];
    var rad = 0.8;
    var segN = 32;
    var parse = window.__VIEWER_TYPE__ === 'main' ? function (stage, k, dir, loc) {
      n++;
      var a = stage.centroid[stage.separation[k].a];
      var b = stage.centroid[stage.separation[k].b];
      var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
      var ab = new CTX.DataFloat3({
        x: a[0] - b[0],
        y: a[1] - b[1],
        z: a[2] - b[2]
      });
      ab.normalize();
      var cd = [ab.z, 0, ab.x];
      var d0 = new CTX.DataFloat3({
        x: c[0] - cd[0] * 30,
        y: c[1] + dir * 20,
        z: c[2] + cd[2] * 30
      });
      var d1 = new CTX.DataFloat3({
        x: c[0] + cd[0] * 30,
        y: c[1] + dir * 20,
        z: c[2] - cd[2] * 30
      });
      var d = d0;

      if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
        d = d1;
      }

      var v = parseFloat(stage.separation[k].size.slice(1, stage.separation[k].size.length - 3));
      values.push(v * 2);
      position.push(d.x, d.y, d.z);
      location.push(loc);
      indexes.push(stage.model[0].from);
      origin.push(d.x, d.y, d.z);

      for (var i = 0; i < segN; i++) {
        var seg = i / segN * 6.3;
        var vx = rad * Math.cos(seg);
        var vy = rad * Math.sin(seg);
        position.push(vx + d.x, vy + d.y, d.z);
        location.push(loc);

        if (i) {
          indices.push(n * (segN + 1), i + n * (segN + 1), i + 1 + n * (segN + 1));
        }

        indexes.push(stage.model[0].from);
        origin.push(d.x, d.y, d.z);
      }

      indices.push(n * (segN + 1), segN + n * (segN + 1), 1 + n * (segN + 1));
    } : function (stage, k, dir, loc) {
      n++;
      var a = stage.centroid[stage.separation[k].a];
      var b = stage.centroid[stage.separation[k].b];
      var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
      var ab = new CTX.DataFloat3({
        x: a[0] - b[0],
        y: a[1] - b[1],
        z: a[2] - b[2]
      });
      ab.normalize();
      var cd = [ab.z, 0, ab.x];
      var d0 = new CTX.DataFloat3({
        x: c[0] - cd[0] * 30,
        y: c[1] + dir * 20,
        z: c[2] + cd[2] * 30
      });
      var d1 = new CTX.DataFloat3({
        x: c[0] + cd[0] * 30,
        y: c[1] + dir * 20,
        z: c[2] - cd[2] * 30
      });
      var d = d0;

      if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
        d = d1;
      }

      var v = parseFloat(stage.separation[k].size.slice(1, stage.separation[k].size.length - 3));
      values.push(v * 2);
      position.push(d.x, d.y, d.z);
      location.push(loc);
      indexes.push(stage.model[0] - 1);
      origin.push(d.x, d.y, d.z);

      for (var i = 0; i < segN; i++) {
        var seg = i / segN * 6.3;
        var vx = rad * Math.cos(seg);
        var vy = rad * Math.sin(seg);
        position.push(vx + d.x, vy + d.y, d.z);
        location.push(loc);

        if (i) {
          indices.push(n * (segN + 1), i + n * (segN + 1), i + 1 + n * (segN + 1));
        }

        indexes.push(stage.model[0] - 1);
        origin.push(d.x, d.y, d.z);
      }

      indices.push(n * (segN + 1), segN + n * (segN + 1), 1 + n * (segN + 1));
    };

    for (var i in sep.upper) {
      if (sep.upper[i].separation && Object.keys(sep.upper[i].separation).length) {
        for (var k in sep.upper[i].separation) {
          parse(sep.upper[i], k, 1, 1);
        }
      }
    }

    for (var _i in sep.lower) {
      if (sep.lower[_i].separation && Object.keys(sep.lower[_i].separation).length) {
        for (var _k in sep.lower[_i].separation) {
          parse(sep.lower[_i], _k, -1, 0);
        }
      }
    }

    var ySize = Math.pow(2, Math.ceil(Math.log(values.length) / Math.log(2)));

    if (ySize > values.length) {
      for (var t = values.length - 1; t < ySize - 1; t++) {
        values.push(0.0);
      }
    }

    var vCount = (n + 1) * segN * 3;
    var material = new CTX.Material({
      VS: function VS() {
        return "\n          precision ".concat(CTX.maxPrecision.vs.float, " float;\n          ").concat(uProjMat.uniform(this), "\n          ").concat(uViewMat.uniform(this), "\n          ").concat(uRotXY.uniform(this), "\n          ").concat(uZoom.uniform(this), "\n          ").concat(uuIndex.uniform(this), "\n          ").concat(uVisUpper.uniform(this), "\n          ").concat(uVisLower.uniform(this), "\n          attribute vec3 position;\n          attribute vec3 origin;\n          attribute float index;\n          attribute float location;\n          ").concat(ROTATION_MATRIX_X, "\n          ").concat(ROTATION_MATRIX_Y, "\n          void main() {\n            mat4 rot = rotationMatrixY(orbitRotation.y) * rotationMatrixX(orbitRotation.x);\n            vec4 pos = rot * vec4(position - origin, 1.);\n            pos.xyz += origin;\n            pos.w *= zoom;\n            gl_Position = projectionMatrix * viewMatrix * pos * (1. - abs(uIndex - index)) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n          }\n        ");
      },
      FS: "\n        precision ".concat(CTX.maxPrecision.fs.float, " float;\n        void main() {\n          gl_FragColor.y = .522;\n          gl_FragColor.z = .541;\n          gl_FragColor.w = 1.0;\n        }\n        ")
    });

    if (position.length) {
      var program = material.program;
      var positionBuf = new CTX.VBO({
        content: new Float32Array(position),
        name: 'position',
        location: 0
      });
      var originBuf = new CTX.VBO({
        content: new Float32Array(origin),
        name: 'origin',
        location: 1
      });
      var indexBuf = new CTX.VBO({
        content: new Float32Array(indexes),
        name: 'index',
        size: 1,
        location: 2
      });
      var locationBuf = new CTX.VBO({
        content: new Float32Array(location),
        name: 'location',
        size: 1,
        location: 3
      });
      var ibo = new CTX.IBO({
        content: new Uint16Array(indices)
      });
      var obj = new CTX.Obj({
        draw: function draw() {
          gl.useProgram(program);
          positionBuf.enable();
          originBuf.enable();
          indexBuf.enable();
          locationBuf.enable();
          ibo.enable();
          gl.drawElements(TRIANGLES, vCount, UNSIGNED_SHORT, 0);
        }
      });
      SEPARATIONS.push(obj);
    }
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'circles');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/cubic-bezier-curve-3.js":
/*!****************************************!*\
  !*** ./src/js/cubic-bezier-curve-3.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var CBP0 = function CBP0(t, p) {
  var k = 1 - t;
  return k * k * k * p;
};

var CBP1 = function CBP1(t, p) {
  var k = 1 - t;
  return 3 * k * k * t * p;
};

var CBP2 = function CBP2(t, p) {
  return 3 * (1 - t) * t * t * p;
};

var CBP3 = function CBP3(t, p) {
  return t * t * t * p;
};

var CubicBezier = function CubicBezier(t, p0, p1, p2, p3) {
  return CBP0(t, p0) + CBP1(t, p1) + CBP2(t, p2) + CBP3(t, p3);
};

var CubicBezierCurve3 = function CubicBezierCurve3(v0, v1, v2, v3) {
  this.v0 = v0;
  this.v1 = v1;
  this.v2 = v2;
  this.v3 = v3;
};

CubicBezierCurve3.prototype.getPoint = function (t) {
  var v0 = this.v0;
  var v1 = this.v1;
  var v2 = this.v2;
  var v3 = this.v3;
  return {
    x: CubicBezier(t, v0.x, v1.x, v2.x, v3.x),
    y: CubicBezier(t, v0.y, v1.y, v2.y, v3.y),
    z: CubicBezier(t, v0.z, v1.z, v2.z, v3.z)
  };
};

CubicBezierCurve3.prototype.getPoints = function (divisions) {
  var points = [];

  for (var d = 0; d <= divisions; d++) {
    points.push(this.getPoint(d / divisions));
  }

  return points;
};

module.exports = CubicBezierCurve3;

/***/ }),

/***/ "./src/js/deepct.js":
/*!**************************!*\
  !*** ./src/js/deepct.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(WebGL, errorCallback, $, Loader, progressCallback, prepareResponses, getCameras, ROTATION_MATRIX_X, hex, getDrawFunc4AttrSingle, getDrawFunc2AttrSingle, getGrid, getModes, getOrbit, getInfo, setFinalCSS, catchCallback) {module.exports = function (ORTHO) {
  var __style = document.createElement('style');

  __style.innerHTML = 'iframe#launcher {display: none !important;}';
  document.getElementsByTagName('head')[0].appendChild(__style);
  var CTX = new WebGL({
    errorCallback: errorCallback,
    alpha: true
  });
  var parent = $('.ortho-gl-container')[0];
  $('.ortho-nowebgl').hide();
  var prefix = ORTHO.source_stage_folder;
  var loader = new Loader();
  var CASE = {};

  if (true) {
    CASE.files = Object.values(ORTHO.json);
  } else {}

  var files = {};
  var i = CASE.files.length;

  if (true) {
    while (i--) {
      files[CASE.files[i]] = {
        source: CASE.files[i] + "?".concat(Date.now()),
        type: 'arraybuffer'
      };
    }
  } else {}

  loader.load({
    sources: files,
    progress: progressCallback()
  }).then(function (responses) {
    try {
      var gl = CTX.WebGLRenderingContext;
      var TRIANGLES = gl.TRIANGLES,
          UNSIGNED_SHORT = gl.UNSIGNED_SHORT,
          UNSIGNED_INT = gl.UNSIGNED_INT,
          COLOR_BUFFER_BIT = gl.COLOR_BUFFER_BIT,
          BLEND = gl.BLEND;
      var GLUINT = gl.getExtension('OES_element_index_uint');
      responses = prepareResponses(responses);
      CTX.setSize(0, 0, parent.offsetWidth, parent.offsetHeight);
      gl.clearColor(1, 1, 1, 1);
      gl.clear(COLOR_BUFFER_BIT);
      gl.enable(gl.DEPTH_TEST);
      gl.depthFunc(gl.LESS);
      gl.enable(BLEND);
      gl.enable(gl.CULL_FACE);
      gl.cullFace(gl.BACK);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.getExtension('OES_standard_derivatives') || gl.getExtension('MOZ_OES_standard_derivatives') || gl.getExtension('WEBKIT_OES_standard_derivatives'); // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////

      var bezier1 = CTX.math.BezierCubicCurve(0.25, 0, 0, 1);
      var DEEPCT = [];
      var rootsMode = new CTX.DataFloat1({
        x: 0.6,
        name: 'rootsMode'
      });
      var visUpper = new CTX.DataFloat1({
        name: 'visUpper',
        x: 1
      });
      var visLower = new CTX.DataFloat1({
        name: 'visLower',
        x: 1
      });
      var rot = new CTX.DataFloat1({
        name: 'rot'
      });
      var zoom = new CTX.DataFloat1({
        name: 'zoom',
        x: 1
      });
      var drawGrid = {
        x: 0
      }; // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////

      var _getCameras = getCameras(CTX, parent),
          orbit = _getCameras.orbit,
          updateProjectionMatrix = _getCameras.updateProjectionMatrix;

      updateProjectionMatrix[drawGrid.x](); // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////

      var _orbit$camera = orbit.camera,
          projectionMatrix = _orbit$camera.projectionMatrix,
          viewMatrix = _orbit$camera.viewMatrix,
          position = _orbit$camera.position;

      var getMaterialColor = function getMaterialColor(item, vis) {
        return new CTX.Material({
          VS: function VS() {
            return "\n              precision ".concat(CTX.maxPrecision.vs.float, " float;\n              ").concat(projectionMatrix.uniform(this), "\n              ").concat(viewMatrix.uniform(this), "\n              ").concat(zoom.uniform(this), "\n              ").concat(vis.uniform(this), "\n              ").concat(position.uniform(this), "\n              attribute vec3 position;\n              attribute vec3 color;\n              varying vec4 vPosition;\n              varying vec3 vColor;\n              varying vec3 lightDir;\n              ").concat(ROTATION_MATRIX_X, "\n              void main() {\n                vColor = color;\n                vPosition = vec4(position, zoom);\n                lightDir = normalize(cameraPosition - vPosition.xyz);\n                gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(vis.name, ";\n              }\n            ");
          },
          FS: function FS() {
            return "\n              #extension GL_OES_standard_derivatives: enable\n              precision ".concat(CTX.maxPrecision.fs.float, " float;\n              ").concat(rootsMode.uniform(this), "\n              varying vec4 vPosition;\n              varying vec3 vColor;\n              varying vec3 lightDir;\n              void main() {\n                float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                vec3 col = mix(vec3(.506, .51, .447), vColor, (rootsMode - .6) * 2.5) * diffuse;\n                gl_FragColor = vec4(col, rootsMode);\n              }\n            ");
          }
        });
      };

      var getMaterial = function getMaterial(color, item, vis, gums) {
        return new CTX.Material({
          VS: function VS() {
            return "\n              precision ".concat(CTX.maxPrecision.vs.float, " float;\n              ").concat(projectionMatrix.uniform(this), "\n              ").concat(viewMatrix.uniform(this), "\n              ").concat(zoom.uniform(this), "\n              ").concat(vis.uniform(this), "\n              ").concat(position.uniform(this), "\n              ").concat(gums ? rootsMode.uniform(this) : '', "\n              attribute vec3 position;\n              varying vec4 vPosition;\n              varying vec3 lightDir;\n              ").concat(ROTATION_MATRIX_X, "\n              void main() {\n                vPosition = vec4(position, zoom ").concat(gums ? '* (1. - (rootsMode - .6) * 2.5)' : '', ");\n                lightDir = normalize(cameraPosition - vPosition.xyz);\n                gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(vis.name, ";\n              }\n            ");
          },
          FS: function FS() {
            return "\n              #extension GL_OES_standard_derivatives: enable\n              precision ".concat(CTX.maxPrecision.fs.float, " float;\n              ").concat(hex(CTX, color).uniform(this), "\n              varying vec4 vPosition;\n              varying vec3 lightDir;\n              void main() {\n                float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                gl_FragColor = vec4(vec3(uColor * diffuse), ").concat(gums ? '.6' : '1.', ");\n              }\n            ");
          }
        });
      };

      var getObjectColor = function getObjectColor(item, material) {
        return new CTX.Obj({
          draw: getDrawFunc4AttrSingle(material, item, item.colors, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT)
        });
      };

      var getObject = function getObject(item, material) {
        return new CTX.Obj({
          draw: getDrawFunc2AttrSingle(material, item, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT)
        });
      }; // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////


      var grid = getGrid(CTX, gl, orbit.camera.projectionMatrix, zoom); // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////

      DEEPCT.push(getObject({
        triangles: responses['upper_deepct_teeth_t.b'],
        vertices: responses['upper_deepct_teeth_k.b']
      }, getMaterial('ffffff', '', visUpper)));
      DEEPCT.push(getObject({
        triangles: responses['lower_deepct_teeth_t.b'],
        vertices: responses['lower_deepct_teeth_k.b']
      }, getMaterial('ffffff', '-', visLower)));
      DEEPCT.push(getObject({
        triangles: responses['upper_deepct_gums_t.b'],
        vertices: responses['upper_deepct_gums_k.b']
      }, getMaterial('ff9c8e', '', visUpper, true)));
      DEEPCT.push(getObject({
        triangles: responses['lower_deepct_gums_t.b'],
        vertices: responses['lower_deepct_gums_k.b']
      }, getMaterial('ff9c8e', '-', visLower, true)));
      DEEPCT.push(getObjectColor({
        triangles: responses['upper_deepct_jaw_t.b'],
        vertices: responses['upper_deepct_jaw_k.b'],
        colors: responses['upper_deepct_jaw_c.b']
      }, getMaterialColor('', visUpper)));
      DEEPCT.push(getObjectColor({
        triangles: responses['lower_deepct_jaw_t.b'],
        vertices: responses['lower_deepct_jaw_k.b'],
        colors: responses['lower_deepct_jaw_c.b']
      }, getMaterialColor('-', visLower))); // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////

      getModes(ORTHO, rot, bezier1, visUpper, visLower, updateProjectionMatrix, drawGrid, CTX, false, false, false, orbit, rootsMode, responses['upper_deepct_teeth_t.b'], responses['lower_deepct_teeth_t.b']);
      getOrbit(orbit, gl, zoom, CTX, updateProjectionMatrix, drawGrid, false);
      getInfo(ORTHO, CASE, false, false, false, false, responses['upper_deepct_teeth_t.b'], responses['lower_deepct_teeth_t.b']); // //////////////////////////////////
      // //////////////////////////////////
      // //////////////////////////////////

      var BLANK_FUNCTION = function BLANK_FUNCTION() {};

      var DEEPCT_LENGHT = DEEPCT.length;
      var gridSwitch = [BLANK_FUNCTION, function () {
        grid.draw();
      }];

      var render = function render() {
        renderFlag = 1; // gl.clear(COLOR_BUFFER_BIT);

        orbit.update();

        for (var _i = 0; _i < DEEPCT_LENGHT; _i++) {
          DEEPCT[_i].draw();
        }

        gridSwitch[drawGrid.x]();
        gl.finish();
      };

      var renderFlag = 0;

      var updateTransitions = function updateTransitions() {
        renderFlag = 0;
        CTX.updateTime();
        CTX.updateTransitions();
        requestAnimationFrame(updateTransitions);
      };

      updateTransitions();
      var renderSwitch = [render, BLANK_FUNCTION];
      parent.appendChild(CTX.canvas);

      CTX.clbk = function () {
        renderSwitch[renderFlag]();
      };

      CTX.clbk();
      setFinalCSS(CTX, gl);
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'deepct');
    }
  }).catch();
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! glkit */ "./node_modules/glkit/build/index.js")["WebGL"], __webpack_require__(/*! ./error-callback */ "./src/js/error-callback.js"), __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! glkit */ "./node_modules/glkit/build/index.js")["Loader"], __webpack_require__(/*! ./onprogress */ "./src/js/onprogress.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["prepareResponses"], __webpack_require__(/*! ./cameras */ "./src/js/cameras.js"), __webpack_require__(/*! ./glsl-const */ "./src/js/glsl-const.js")["ROTATION_MATRIX_X"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["hex"], __webpack_require__(/*! ./draw-func */ "./src/js/draw-func.js")["getDrawFunc4AttrSingle"], __webpack_require__(/*! ./draw-func */ "./src/js/draw-func.js")["getDrawFunc2AttrSingle"], __webpack_require__(/*! ./grid */ "./src/js/grid.js"), __webpack_require__(/*! ./modes */ "./src/js/modes.js"), __webpack_require__(/*! ./orbit */ "./src/js/orbit.js"), __webpack_require__(/*! ./info */ "./src/js/info.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["setFinalCSS"], __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/draw-func.js":
/*!*****************************!*\
  !*** ./src/js/draw-func.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(catchCallback) {function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

module.exports = {
  getDrawFunc2Attr: function getDrawFunc2Attr(material, item, interp, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT) {
    try {
      var program = material.program;
      var vertices = item.vertices.map(function (elm) {
        return new Float32Array(elm);
      });
      var startPosition = new CTX.MVBO({
        content: vertices,
        name: 'aStartPosition',
        interpolation: interp,
        location: 0
      });
      var endPosition = new CTX.MVBO({
        content: vertices,
        name: 'aEndPosition',
        interpolation: interp,
        index: 1,
        location: 1
      });
      var draw = null;

      if (_toConsumableArray(startPosition.content).concat(_toConsumableArray(endPosition.content)).filter(function (elm) {
        return elm.length / 3 > 65536;
      }).length) {
        if (GLUINT) {
          var mibo = new CTX.MIBO({
            content: item.triangles.map(function (elm) {
              return new Uint32Array(elm);
            }),
            interpolation: interp
          });
          var miboContentLength = mibo.content.map(function (elm) {
            return elm.length;
          });

          draw = function draw() {
            gl.useProgram(program);
            startPosition.enable();
            endPosition.enable();
            mibo.enable();
            gl.drawElements(TRIANGLES, miboContentLength[mibo.current], UNSIGNED_INT, 0);
          };
        } else {
          var preContent = item.triangles.map(function (elm) {
            return Array.prototype.slice.call(new Uint32Array(elm));
          });
          var first = [];
          var last = [];
          var preContentLen = preContent.length;
          var testArrV = [];
          var testArrT = [];

          for (var i = 0; i < preContentLen; i++) {
            testArrT[i] = [];
            testArrV[i] = [];
            var content = preContent[i];
            var contentLen = preContent[i].length;
            first[i] = [];
            last[i] = [];
            var test = 0;
            var testObj = {};

            for (var k = 0; k < contentLen; k += 3) {
              if (content[k] > 65535 || content[k + 1] > 65535 || content[k + 2] > 65535) {
                for (var j = 0; j < 3; j++) {
                  first[i].push(content[k + j]);

                  if (!testObj[content[k + j]]) {
                    testObj[content[k + j]] = test++;
                    testArrV[i].push(vertices[i][content[k + j] * 3], vertices[i][content[k + j] * 3 + 1], vertices[i][content[k + j] * 3 + 2]);
                  }

                  testArrT[i].push(testObj[content[k + j]]);
                }
              } else {
                last[i].push(content[k], content[k + 1], content[k + 2]);
              }
            }
          }

          var miboFirst = new CTX.MIBO({
            content: testArrT.map(function (elm) {
              return new Uint16Array(elm);
            }),
            interpolation: interp
          });
          var miboLast = new CTX.MIBO({
            content: last.map(function (elm) {
              return new Uint16Array(elm);
            }),
            interpolation: interp
          });
          var arrV = testArrV.map(function (elm) {
            return new Float32Array(elm);
          });
          var startPositionFirst = new CTX.MVBO({
            content: arrV,
            name: 'aStartPosition',
            interpolation: interp,
            location: 0
          });
          var endPositionFirst = new CTX.MVBO({
            content: arrV,
            name: 'aEndPosition',
            interpolation: interp,
            index: 1,
            location: 1
          });
          var miboFirstContentLength = miboFirst.content.map(function (elm) {
            return elm.length;
          });
          var miboLastContentLength = miboLast.content.map(function (elm) {
            return elm.length;
          });

          draw = function draw() {
            gl.useProgram(program);
            startPositionFirst.enable();
            endPositionFirst.enable();
            miboFirst.enable();
            gl.drawElements(TRIANGLES, miboFirstContentLength[miboFirst.current], UNSIGNED_SHORT, 0);
            startPosition.enable();
            endPosition.enable();
            miboLast.enable();
            gl.drawElements(TRIANGLES, miboLastContentLength[miboLast.current], UNSIGNED_SHORT, 0);
          };
        }
      } else {
        var _mibo = new CTX.MIBO({
          content: item.triangles.map(function (elm) {
            return new Uint16Array(elm);
          }),
          interpolation: interp
        });

        var _miboContentLength = _mibo.content.map(function (elm) {
          return elm.length;
        });

        draw = function draw() {
          gl.useProgram(program);
          startPosition.enable();
          endPosition.enable();

          _mibo.enable();

          gl.drawElements(TRIANGLES, _miboContentLength[_mibo.current], UNSIGNED_SHORT, 0);
        };
      }

      return draw;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getDrawFunc2Attr');
    }
  },
  getDrawFunc4Attr: function getDrawFunc4Attr(material, item, interp, colors, interpColors, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT) {
    try {
      var program = material.program;
      var vertices = item.vertices.map(function (elm) {
        return new Float32Array(elm);
      });
      var startPosition = new CTX.MVBO({
        content: vertices,
        name: 'aStartPosition',
        interpolation: interp,
        location: 0
      });
      var endPosition = new CTX.MVBO({
        content: vertices,
        name: 'aEndPosition',
        interpolation: interp,
        index: 1,
        location: 1
      });

      var _colors = colors.map(function (elm) {
        return new Float32Array(elm);
      });

      var startColor = new CTX.MVBO({
        content: _colors,
        name: 'aStartColor',
        interpolation: interpColors,
        location: 2
      });
      var endColor = new CTX.MVBO({
        content: _colors,
        name: 'aEndColor',
        interpolation: interpColors,
        index: 1,
        location: 3
      });
      var draw = null;

      if (_toConsumableArray(startPosition.content).concat(_toConsumableArray(endPosition.content)).filter(function (elm) {
        return elm.length / 3 > 65536;
      }).length) {
        if (GLUINT) {
          var mibo = new CTX.MIBO({
            content: item.triangles.map(function (elm) {
              return new Uint32Array(elm);
            }),
            interpolation: interp
          });
          var miboContentLength = mibo.content.map(function (elm) {
            return elm.length;
          });

          draw = function draw() {
            gl.useProgram(program);
            startPosition.enable();
            endPosition.enable();
            startColor.enable();
            endColor.enable();
            mibo.enable();
            gl.drawElements(TRIANGLES, miboContentLength[mibo.current], UNSIGNED_INT, 0);
          };
        } else {
          var preContent = item.triangles.map(function (elm) {
            return Array.prototype.slice.call(new Uint32Array(elm));
          });
          var first = [];
          var last = [];
          var preContentLen = preContent.length;
          var testArrV = [];
          var testArrC = [];
          var testArrT = [];

          for (var i = 0; i < preContentLen; i++) {
            testArrT[i] = [];
            testArrV[i] = [];
            testArrC[i] = [];
            var content = preContent[i];
            var contentLen = preContent[i].length;
            first[i] = [];
            last[i] = [];
            var test = 0;
            var testObj = {};

            for (var k = 0; k < contentLen; k += 3) {
              if (content[k] > 65535 || content[k + 1] > 65535 || content[k + 2] > 65535) {
                for (var j = 0; j < 3; j++) {
                  first[i].push(content[k + j]);

                  if (!testObj[content[k + j]]) {
                    testObj[content[k + j]] = test++;
                    testArrV[i].push(vertices[i][content[k + j] * 3], vertices[i][content[k + j] * 3 + 1], vertices[i][content[k + j] * 3 + 2]);
                    testArrC[i].push(_colors[i][content[k + j] * 3], _colors[i][content[k + j] * 3 + 1], _colors[i][content[k + j] * 3 + 2]);
                  }

                  testArrT[i].push(testObj[content[k + j]]);
                }
              } else {
                last[i].push(content[k], content[k + 1], content[k + 2]);
              }
            }
          }

          var miboFirst = new CTX.MIBO({
            content: testArrT.map(function (elm) {
              return new Uint16Array(elm);
            }),
            interpolation: interp
          });
          var miboLast = new CTX.MIBO({
            content: last.map(function (elm) {
              return new Uint16Array(elm);
            }),
            interpolation: interp
          });
          var arrV = testArrV.map(function (elm) {
            return new Float32Array(elm);
          });
          var arrC = testArrC.map(function (elm) {
            return new Float32Array(elm);
          });
          var startPositionFirst = new CTX.MVBO({
            content: arrV,
            name: 'aStartPosition',
            interpolation: interp,
            location: 0
          });
          var endPositionFirst = new CTX.MVBO({
            content: arrV,
            name: 'aEndPosition',
            interpolation: interp,
            index: 1,
            location: 1
          });
          var startColorFirst = new CTX.MVBO({
            content: arrC,
            name: 'aStartColor',
            interpolation: interp,
            location: 2
          });
          var endColorFirst = new CTX.MVBO({
            content: arrC,
            name: 'aEndColor',
            interpolation: interp,
            index: 1,
            location: 3
          });
          var miboFirstContentLength = miboFirst.content.map(function (elm) {
            return elm.length;
          });
          var miboLastContentLength = miboLast.content.map(function (elm) {
            return elm.length;
          });

          draw = function draw() {
            gl.useProgram(program);
            startPositionFirst.enable();
            endPositionFirst.enable();
            startColorFirst.enable();
            endColorFirst.enable();
            miboFirst.enable();
            gl.drawElements(TRIANGLES, miboFirstContentLength[miboFirst.current], UNSIGNED_SHORT, 0);
            startPosition.enable();
            endPosition.enable();
            startColor.enable();
            endColor.enable();
            miboLast.enable();
            gl.drawElements(TRIANGLES, miboLastContentLength[miboLast.current], UNSIGNED_SHORT, 0);
          };
        }
      } else {
        var _mibo2 = new CTX.MIBO({
          content: item.triangles.map(function (elm) {
            return new Uint16Array(elm);
          }),
          interpolation: interp
        });

        var _miboContentLength2 = _mibo2.content.map(function (elm) {
          return elm.length;
        });

        draw = function draw() {
          gl.useProgram(program);
          startPosition.enable();
          endPosition.enable();
          startColor.enable();
          endColor.enable();

          _mibo2.enable();

          gl.drawElements(TRIANGLES, _miboContentLength2[_mibo2.current], UNSIGNED_SHORT, 0);
        };
      }

      return draw;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getDrawFunc4Attr');
    }
  },
  getDrawFunc2AttrSingle: function getDrawFunc2AttrSingle(material, item, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT) {
    try {
      var program = material.program;
      var vertices = new Float32Array(item.vertices);
      var position = new CTX.VBO({
        content: vertices,
        name: 'position',
        location: 0
      });
      var draw = null;

      if (position.content.length / 3 > 65536) {
        if (GLUINT) {
          var mibo = new CTX.IBO({
            content: new Uint32Array(item.triangles)
          });
          var miboContentLength = mibo.content.length;

          draw = function draw() {
            gl.useProgram(program);
            position.enable();
            mibo.enable();
            gl.drawElements(TRIANGLES, miboContentLength, UNSIGNED_INT, 0);
          };
        } else {
          var first = [];
          var last = [];
          var testArrV = [];
          var testArrT = [];
          var content = Array.prototype.slice.call(new Uint32Array(item.triangles));
          var contentLen = content.length;
          var test = 0;
          var testObj = {};

          for (var k = 0; k < contentLen; k += 3) {
            if (content[k] > 65535 || content[k + 1] > 65535 || content[k + 2] > 65535) {
              for (var j = 0; j < 3; j++) {
                first.push(content[k + j]);

                if (!testObj[content[k + j]]) {
                  testObj[content[k + j]] = test++;
                  testArrV.push(vertices[content[k + j] * 3], vertices[content[k + j] * 3 + 1], vertices[content[k + j] * 3 + 2]);
                }

                testArrT.push(testObj[content[k + j]]);
              }
            } else {
              last.push(content[k], content[k + 1], content[k + 2]);
            }
          }

          var miboFirst = new CTX.IBO({
            content: new Uint16Array(testArrT)
          });
          var miboLast = new CTX.IBO({
            content: new Uint16Array(last)
          });
          var arrV = new Float32Array(testArrV);
          var positionFirst = new CTX.VBO({
            content: arrV,
            name: 'position',
            location: 0
          });
          var miboFirstContentLength = miboFirst.content.length;
          var miboLastContentLength = miboLast.content.length;

          draw = function draw() {
            gl.useProgram(program);
            positionFirst.enable();
            miboFirst.enable();
            gl.drawElements(TRIANGLES, miboFirstContentLength, UNSIGNED_SHORT, 0);
            position.enable();
            miboLast.enable();
            gl.drawElements(TRIANGLES, miboLastContentLength, UNSIGNED_SHORT, 0);
          };
        }
      } else {
        var _mibo3 = new CTX.IBO({
          content: new Uint16Array(item.triangles)
        });

        var _miboContentLength3 = _mibo3.content.length;

        draw = function draw() {
          gl.useProgram(program);
          position.enable();

          _mibo3.enable();

          gl.drawElements(TRIANGLES, _miboContentLength3, UNSIGNED_SHORT, 0);
        };
      }

      return draw;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getDrawFunc2AttrSingle');
    }
  },
  getDrawFunc4AttrSingle: function getDrawFunc4AttrSingle(material, item, colors, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT) {
    try {
      var program = material.program;
      var vertices = new Float32Array(item.vertices);

      var _colors = new Float32Array(colors);

      var position = new CTX.VBO({
        content: vertices,
        name: 'position',
        location: 0
      });
      var color = new CTX.VBO({
        content: _colors,
        name: 'color',
        location: 1
      });
      var draw = null;

      if (position.content.length / 3 > 65536) {
        if (GLUINT) {
          var mibo = new CTX.IBO({
            content: new Uint32Array(item.triangles)
          });
          var miboContentLength = mibo.content.length;

          draw = function draw() {
            gl.useProgram(program);
            position.enable();
            color.enable();
            mibo.enable();
            gl.drawElements(TRIANGLES, miboContentLength, UNSIGNED_INT, 0);
          };
        } else {
          var first = [];
          var last = [];
          var testArrV = [];
          var testArrC = [];
          var testArrT = [];
          var content = Array.prototype.slice.call(new Uint32Array(item.triangles));
          var contentLen = content.length;
          var test = 0;
          var testObj = {};

          for (var k = 0; k < contentLen; k += 3) {
            if (content[k] > 65535 || content[k + 1] > 65535 || content[k + 2] > 65535) {
              for (var j = 0; j < 3; j++) {
                first.push(content[k + j]);

                if (!testObj[content[k + j]]) {
                  testObj[content[k + j]] = test++;
                  testArrV.push(vertices[content[k + j] * 3], vertices[content[k + j] * 3 + 1], vertices[content[k + j] * 3 + 2]);
                  testArrC.push(_colors[content[k + j] * 3], _colors[content[k + j] * 3 + 1], _colors[content[k + j] * 3 + 2]);
                }

                testArrT.push(testObj[content[k + j]]);
              }
            } else {
              last.push(content[k], content[k + 1], content[k + 2]);
            }
          }

          var miboFirst = new CTX.IBO({
            content: new Uint16Array(testArrT)
          });
          var miboLast = new CTX.IBO({
            content: new Uint16Array(last)
          });
          var arrV = new Float32Array(testArrV);
          var arrC = new Float32Array(testArrC);
          var positionFirst = new CTX.VBO({
            content: arrV,
            name: 'position',
            location: 0
          });
          var colorFirst = new CTX.VBO({
            content: arrC,
            name: 'color',
            location: 1
          });
          var miboFirstContentLength = miboFirst.content.length;
          var miboLastContentLength = miboLast.content.length;

          draw = function draw() {
            gl.useProgram(program);
            positionFirst.enable();
            colorFirst.enable();
            miboFirst.enable();
            gl.drawElements(TRIANGLES, miboFirstContentLength, UNSIGNED_SHORT, 0);
            position.enable();
            color.enable();
            miboLast.enable();
            gl.drawElements(TRIANGLES, miboLastContentLength, UNSIGNED_SHORT, 0);
          };
        }
      } else {
        var _mibo4 = new CTX.IBO({
          content: new Uint16Array(item.triangles)
        });

        var _miboContentLength4 = _mibo4.content.length;

        draw = function draw() {
          gl.useProgram(program);
          position.enable();
          color.enable();

          _mibo4.enable();

          gl.drawElements(TRIANGLES, _miboContentLength4, UNSIGNED_SHORT, 0);
        };
      }

      return draw;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getDrawFunc4AttrSingle');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/error-callback.js":
/*!**********************************!*\
  !*** ./src/js/error-callback.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (evt) {
  document.getElementsByClassName('ortho-nowebgl')[0].getElementsByTagName('span')[0].style.display = 'table-cell';
  throw new Error(evt);
};

/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(catchCallback, $) {function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

module.exports = {
  getLayers: function getLayers(srcArr, separations) {
    try {
      var dstArr = [];

      for (var i = 0; i < srcArr.length; i++) {
        if (i % 2 && i !== srcArr.length - 1) {
          if (separations.indexOf(srcArr[i + 1]) > -1) {
            dstArr.push(srcArr[i], srcArr[i], srcArr[i]);
          } else {
            dstArr.push(srcArr[i], srcArr[i], srcArr[i + 1]);
          }
        } else {
          dstArr.push(srcArr[i]);
        }
      }

      dstArr.push(dstArr[dstArr.length - 1]); // console.log(`getLayers, srcArr: ${ srcArr }, separations: ${ separations }, dstArr: ${ dstArr }`);

      return dstArr;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getLayers');
    }
  },
  getTriangles: function getTriangles(layers, separations) {
    try {
      var arr = new Array(layers.length);

      for (var i = 0; i < separations.length; i++) {
        arr.fill(separations[i], layers.indexOf(separations[i]));
      } // console.log(`getTriangles, layers: ${ layers }, separations: ${ separations }, arr: ${ arr }`);


      return arr;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getTriangles');
    }
  },
  getLayersLocks: function getLayersLocks(srcArr) {
    try {
      var dstArr = [];

      for (var i = 0; i < srcArr.length; i++) {
        if (i % 2 && i !== srcArr.length - 1) {
          dstArr.push(srcArr[i], srcArr[i], srcArr[i]);
        } else {
          dstArr.push(srcArr[i]);
        }
      }

      dstArr.push(dstArr[dstArr.length - 1]); // console.log(`getLayersLocks, srcArr: ${ srcArr }, dstArr: ${ dstArr }`);

      return dstArr;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getLayersLocks');
    }
  },
  getTrianglesLocks: function getTrianglesLocks(layers, srcArr) {
    try {
      var arr = new Array(layers.length);

      for (var i = 0; i < srcArr.length; i += 2) {
        if (layers.indexOf(srcArr[i]) > -1) {
          arr.fill(srcArr[i], layers.indexOf(srcArr[i]));
        }
      } // console.log(`getTrianglesLocks, layers: ${ layers }, srcArr: ${ srcArr }, arr: ${ arr }`);


      return arr;
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, 'getTrianglesLocks');
    }
  },
  hex: function hex(CTX, _hex) {
    return new CTX.DataFloat3({
      name: 'uColor',
      x: parseInt("0x".concat(_hex[0]).concat(_hex[1]), 16) / 255,
      y: parseInt("0x".concat(_hex[2]).concat(_hex[3]), 16) / 255,
      z: parseInt("0x".concat(_hex[4]).concat(_hex[5]), 16) / 255
    });
  },
  extArr: function extArr(arr) {
    return _toConsumableArray(arr).concat([arr.slice().pop()]);
  },
  setFinalCSS: function setFinalCSS(CTX, gl) {
    $(gl.canvas).css({
      position: 'fixed',
      zIndex: 0
    });
    $('.ortho-loader').find('circle').css({
      "stroke-dasharray": '280, 1000'
    });
    $('.ortho-perc').html('100%');
    setTimeout(function () {
      $('.ortho-loader').remove();
      CTX.clbk();
    }, 100);
  },
  prepareResponses: function prepareResponses(responses) {
    if (true) {
      var _responses = {};

      for (var key in responses) {
        _responses[key.split('/').slice(-1)[0]] = responses[key];
      }

      responses = _responses;
    }

    return responses;
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js"), __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./src/js/glsl-const.js":
/*!******************************!*\
  !*** ./src/js/glsl-const.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
  ROTATION_MATRIX_X: "mat4 rotationMatrixX(float a) {\n      float c = cos(a);\n      float s = sin(a);\n      return mat4(1., 0., 0., 0., 0., c, -s, 0., 0., s, c, 0., 0., 0., 0., 1.);\n    }",
  ROTATION_MATRIX_Y: "mat4 rotationMatrixY(float a) {\n      float c = cos(a);\n      float s = sin(a);\n      return mat4(c, 0., s, 0., 0., 1., 0., 0., -s, 0., c, 0., 0., 0., 0., 1.);\n    }"
};

/***/ }),

/***/ "./src/js/grid.js":
/*!************************!*\
  !*** ./src/js/grid.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (CTX, gl, uProjMat, uZoom) {
  var LINES = gl.LINES;
  var position = [];
  var color = [];

  for (var k = 0; k <= 100; k++) {
    position.push(-50, k - 50, -100, 50, k - 50, -100, k - 50, -50, -100, k - 50, 50, -100);

    if (k % 5 === 0) {
      color.push(0, 0.522 / 1.2, 0.541 / 1.2, 0, 0.522 / 1.2, 0.541 / 1.2, 0, 0.522 / 1.2, 0.541 / 1.2, 0, 0.522 / 1.2, 0.541 / 1.2);
    } else {
      color.push(0, 0.522 / 0.8, 0.541 / 0.8, 0, 0.522 / 0.8, 0.541 / 0.8, 0, 0.522 / 0.8, 0.541 / 0.8, 0, 0.522 / 0.8, 0.541 / 0.8);
    }
  }

  var vl = position.length / 3;
  var material = new CTX.Material({
    VS: function VS() {
      return "\n        precision ".concat(CTX.maxPrecision.vs.float, " float;\n        ").concat(uProjMat.uniform(this), "\n        ").concat(uZoom.uniform(this), "\n        attribute vec3 position;\n        attribute vec3 color;\n        varying vec3 vColor;\n        void main() {\n          vColor = color;\n          gl_Position = projectionMatrix * vec4(position, zoom);\n        }\n      ");
    },
    FS: "\n      precision ".concat(CTX.maxPrecision.fs.float, " float;\n      varying vec3 vColor;\n      void main() {\n        gl_FragColor = vec4(vColor, 1.);\n      }\n      ")
  });
  var program = material.program;
  var positionBuf = new CTX.VBO({
    name: 'position',
    content: new Float32Array(position),
    location: 0
  });
  var colorBuf = new CTX.VBO({
    name: 'color',
    content: new Float32Array(color),
    location: 1
  });
  var obj = new CTX.Obj({
    draw: function draw() {
      gl.useProgram(program);
      positionBuf.enable();
      colorBuf.enable();
      gl.drawArrays(LINES, 0, vl);
    }
  });
  return obj;
};

/***/ }),

/***/ "./src/js/index.js":
/*!*************************!*\
  !*** ./src/js/index.js ***!
  \*************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scss_main_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scss/main.scss */ "./src/scss/main.scss");
/* harmony import */ var _scss_main_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_scss_main_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fortawesome_fontawesome_free_css_fontawesome_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @fortawesome/fontawesome-free/css/fontawesome.css */ "./node_modules/@fortawesome/fontawesome-free/css/fontawesome.css");
/* harmony import */ var _fortawesome_fontawesome_free_css_fontawesome_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_free_css_fontawesome_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fortawesome_fontawesome_free_css_solid_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @fortawesome/fontawesome-free/css/solid.css */ "./node_modules/@fortawesome/fontawesome-free/css/solid.css");
/* harmony import */ var _fortawesome_fontawesome_free_css_solid_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_free_css_solid_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components */ "./src/components/index.js");



 //import version from './version.json';
// document.getElementsByTagName('head')[0].innerHTML += `<!-- version ${ require('../version.json').version } -->`;
//document.getElementsByTagName('head')[0].innerHTML += `${ Object.keys(version).map((key) => `<!-- ${ key }: ${ version[key] } -->`).join('') }`

window.ortho = null;

if (false) {} else {
  var _ortho = {
    main: __webpack_require__(/*! ./main */ "./src/js/main.js"),
    roots: __webpack_require__(/*! ./roots */ "./src/js/roots.js"),
    deepct: __webpack_require__(/*! ./deepct */ "./src/js/deepct.js")
  };

  window.ortho = function (params) {
    window.__VIEWER_TYPE__ = params.type;

    _ortho[params.type](params);
  };
} // (module && module.exports) ? (module.exports = window.ortho) : null;

/***/ }),

/***/ "./src/js/info.js":
/*!************************!*\
  !*** ./src/js/info.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, catchCallback) {function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var bowser = __webpack_require__(/*! bowser */ "./node_modules/bowser/src/bowser.js");

var Dialog = __webpack_require__(/*! ../components/dialog */ "./src/components/dialog/index.js").default;

var isMobile = window.innerWidth < 768;

module.exports =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(function* (ORTHO, CASE, upperLayers, upperSrcSep, lowerLayers, lowerSrcSep, upperExists, lowerExists) {
    // Local Components
    var CommentDialog =
    /*#__PURE__*/
    function (_Dialog) {
      _inherits(CommentDialog, _Dialog);

      function CommentDialog(selector) {
        var _this;

        _classCallCheck(this, CommentDialog);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(CommentDialog).call(this, selector));
        _this.textarea = _this.el.find("textarea");

        var _this$el$find = _this.el.find(".ortho-btn"),
            _this$el$find2 = _slicedToArray(_this$el$find, 2),
            applyBtn = _this$el$find2[0],
            cancelBtn = _this$el$find2[1];

        _this.LOCAL = Object({"Plan ID":"Plan ID ","Upper jaw":"Upper jaw","Lower jaw":"Lower jaw","Total steps":"Total steps","IPR before step":"IPR before step","Step":"Step","Approve":"Approve","Publish_QA":"Next: Clinical review","Publish_CR":"Next: Printable models","Rework":"Adjust","Rework_QA":"Fallback to Modelling","Rework_CR":"Fallback to Modelling","Rework_comment":"3D Plan comment.","Aligner":"Aligner","Are you sure?":"Are you sure?","Initial condition":"Initial condition","Correction":"Correction","profile":"Profile (not smiling)","full_face_with_smile":"Full face (smiling)","full_face_without_smile":"Full face (not smiling)","occlusal_view_upper":"Upper occlusal","occlusal_view_lower":"Lower occlusal","lateral_view_right":"Right view","front_view":"Front view","lateral_view_left":"Left view","Extra photos":"Extra photos","Cancel":"Cancel","Send":"Send"});
        $(applyBtn).html(_this.LOCAL.Send);
        $(cancelBtn).html(_this.LOCAL.Cancel);
        _this.applyBtn = $(applyBtn);
        _this.cancelBtn = $(cancelBtn);

        _this.textarea.on("keydown", function (e) {
          e.stopPropagation();
        }).on("input",  false ? undefined : function (e) {
          _this.data.comment = _this.textarea.val();
        });

        _this.applyBtn.on("click", _this.apply.bind(_assertThisInitialized(_assertThisInitialized(_this))));

        _this.cancelBtn.on("click", _this.cancel.bind(_assertThisInitialized(_assertThisInitialized(_this)))); // iOS hack for soft keyboard. The only way to see buttons is watch window's height


        if (bowser.ios) {
          $(window).on("resize.dialog", function (e) {
            if (isMobile) {
              // only mobile view
              _this.el[0].style.height = window.innerHeight + "px";
            } else {
              _this.el[0].style.height = "";
            }
          });
        }

        return _this;
      }

      _createClass(CommentDialog, [{
        key: "open",
        value: function open() {
          _get(_getPrototypeOf(CommentDialog.prototype), "open", this).call(this);

          this.textarea.focus();
        }
      }, {
        key: "apply",
        value: function () {
          var _apply = _asyncToGenerator(function* () {
            var _this2 = this;

            var TARGET = "3d-api-simple-frontend"; // this.data.comment_updated = `${this.LOCAL["Rework_comment"]} ${ORTHO.case}\n\n${this.data.comment}`

            if (TARGET === "3d-plan") return this.sendComment();

            if (TARGET === "3d-api-simple-frontend") {
              return ORTHO.comment(this.data.comment, function () {
                _this2.close();

                window.location = "/";
              });
            }
          });

          return function apply() {
            return _apply.apply(this, arguments);
          };
        }()
      }, {
        key: "cancel",
        value: function cancel() {
          this.close();
        }
      }, {
        key: "sendComment",
        value: function () {
          var _sendComment = _asyncToGenerator(function* () {
            yield fetch("https://".concat(ORTHO.lk_api_link, "/api/v1/doctor/patients/").concat(ORTHO.lk_id, "/status/rework"), {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                plan_id: ORTHO.case
              })
            });
            yield fetch("https://".concat(ORTHO.lk_api_link, "/api/v1/doctor/patients/").concat(ORTHO.lk_id, "/comments"), {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                comment: this.data.comment,
                type: 2,
                plan_id: ORTHO.case
              })
            });
            this.close();
            window.location.href = "https://".concat(ORTHO.lk_api_link, "/pages/patients");
          });

          return function sendComment() {
            return _sendComment.apply(this, arguments);
          };
        }()
      }]);

      return CommentDialog;
    }(Dialog); // Entry


    try {
      var LOCAL = Object({"Plan ID":"Plan ID ","Upper jaw":"Upper jaw","Lower jaw":"Lower jaw","Total steps":"Total steps","IPR before step":"IPR before step","Step":"Step","Approve":"Approve","Publish_QA":"Next: Clinical review","Publish_CR":"Next: Printable models","Rework":"Adjust","Rework_QA":"Fallback to Modelling","Rework_CR":"Fallback to Modelling","Rework_comment":"3D Plan comment.","Aligner":"Aligner","Are you sure?":"Are you sure?","Initial condition":"Initial condition","Correction":"Correction","profile":"Profile (not smiling)","full_face_with_smile":"Full face (smiling)","full_face_without_smile":"Full face (not smiling)","occlusal_view_upper":"Upper occlusal","occlusal_view_lower":"Lower occlusal","lateral_view_right":"Right view","front_view":"Front view","lateral_view_left":"Left view","Extra photos":"Extra photos","Cancel":"Cancel","Send":"Send"});
      var info = document.getElementsByClassName("ortho-info-inner")[0];
      info.innerHTML = "<div class=\"non_scrollable ortho-info-row -head\">".concat(LOCAL["Plan ID"]).concat(ORTHO.case, "</div>");
      var infoBlock = document.createElement("div");
      infoBlock.className = "non_scrollable ortho-info-block";
      infoBlock.innerHTML = "";

      if (Boolean(upperExists)) {
        if (window.__VIEWER_TYPE__ !== "deepct") {
          infoBlock.innerHTML += "\n        <div class=\"non_scrollable ortho-info-row\">".concat(LOCAL["Upper jaw"], ":</div>\n        <div class=\"non_scrollable ortho-info-row\">").concat(LOCAL["Total steps"], ": ").concat(parseInt(upperLayers[upperLayers.length - 1]) + 1, "</div>\n        ");
        }

        if (window.__VIEWER_TYPE__ === "ply") {
          if (CASE.upper.separations) {
            infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row\">".concat(LOCAL["IPR before step"], ":</div>");

            for (var i = 0; i < upperSrcSep.length; i++) {
              infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row -stage ".concat(upperSrcSep[i], " -blue\">").concat(LOCAL.Step, ": ").concat(parseInt(upperSrcSep[i]) + 1, "</div>");
            }
          }
        } else if (window.__VIEWER_TYPE__ === "main") {
          var USS = [];

          for (var key in CASE.dict.upper) {
            if (CASE.dict.upper[key].separation) {
              USS.push(CASE.dict.upper[key].model[0].from);
            }
          }

          if (USS.length) {
            infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row\">".concat(LOCAL["IPR before step"], ":</div>");

            for (var _i2 = 0; _i2 < USS.length; _i2++) {
              infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row -stage ".concat(USS[_i2], " -blue\">").concat(LOCAL.Step, ": ").concat(parseInt(USS[_i2]) + 1, "</div>");
            }
          }
        }
      }

      if (Boolean(lowerExists)) {
        if (window.__VIEWER_TYPE__ !== "deepct") {
          infoBlock.innerHTML += "\n        <div class=\"non_scrollable ortho-info-row\">".concat(LOCAL["Lower jaw"], ":</div>\n        <div class=\"non_scrollable ortho-info-row\">").concat(LOCAL["Total steps"], ": ").concat(parseInt(lowerLayers[lowerLayers.length - 1]) + 1, "</div>\n        ");
        }

        if (window.__VIEWER_TYPE__ === "ply") {
          if (CASE.lower.separations) {
            infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row\">".concat(LOCAL["IPR before step"], ":</div>");

            for (var _i3 = 0; _i3 < lowerSrcSep.length; _i3++) {
              infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row -stage ".concat(lowerSrcSep[_i3], " -blue\">").concat(LOCAL.Step, ": ").concat(parseInt(lowerSrcSep[_i3]) + 1, "</div>");
            }
          }
        } else if (window.__VIEWER_TYPE__ === "main") {
          var LSS = [];

          for (var _key in CASE.dict.lower) {
            if (CASE.dict.lower[_key].separation) {
              LSS.push(CASE.dict.lower[_key].model[0].from);
            }
          }

          if (LSS.length) {
            infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row\">".concat(LOCAL["IPR before step"], ":</div>");

            for (var _i4 = 0; _i4 < LSS.length; _i4++) {
              infoBlock.innerHTML += "<div class=\"non_scrollable ortho-info-row -stage ".concat(LSS[_i4], " -blue\">").concat(LOCAL.Step, ": ").concat(parseInt(LSS[_i4]) + 1, "</div>");
            }
          }
        }
      }

      info.appendChild(infoBlock);

      if (true) {
        info.innerHTML += "\n        <div class=\"non_scrollable ortho-info-block -bottom\">\n          <a class=\"ortho-publish-button btn btn-success\">\n            <i class=\"fas fa-check\"></i>\n            ".concat(ORTHO.json.step_name === 'S_QUALITY_CONTROL' || ORTHO.json.step_name === 'S_FULL_PLAN_QUALITY_CONTROL' ? LOCAL.Publish_QA : LOCAL.Publish_CR, "\n          </a>\n          <a class=\"ortho-rework-button btn btn-danger\" href=\"javascript:void(0)\">\n            <i class=\"fas fa-times\"></i>\n            ").concat(ORTHO.json.step_name === 'S_QUALITY_CONTROL' || ORTHO.json.step_name === 'S_FULL_PLAN_QUALITY_CONTROL' ? LOCAL.Rework_QA : LOCAL.Rework_CR, "\n          </a>\n        </div>\n      ");
      } else { var lower_jaw, upper_jaw, reworkLink; }

      if (!(bowser.mobile || bowser.tablet) && "3d-api-simple-frontend" === "3d-plan" && "all" === "main") {
        var openPatientInfo = function openPatientInfo() {
          $("#ortho-patient-button-chevron").addClass("-opened");
          $("#ortho-patient-scroll").addClass("-opened");
          if (commentDialog) commentDialog.close();
        };

        var closePatientInfo = function closePatientInfo() {
          $("#ortho-patient-button-chevron").removeClass("-opened");
          $("#ortho-patient-scroll").removeClass("-opened");
        };

        var togglePatientInfo = function togglePatientInfo() {
          var isOpened = $("#ortho-patient-scroll").hasClass("-opened");
          return isOpened ? closePatientInfo() : openPatientInfo();
        };

        var res = yield fetch("https://".concat(ORTHO.lk_api_link, "/api/v1/doctor/patients/").concat(ORTHO.lk_id), {
          credentials: "include"
        });
        var data = yield res.json();

        var patientData = _objectSpread({}, data.patient);

        if (!patientData.media) patientData.media = {};
        var required_images = patientData.media.required_images;
        var required_images_arr = required_images ? Object.keys(required_images) : [];
        var required_order = ["profile", "full_face_with_smile", "full_face_without_smile", "occlusal_view_upper", "occlusal_view_lower", "lateral_view_right", "front_view", "lateral_view_left"].filter(function (elm) {
          return required_images_arr.indexOf(elm) > -1;
        });
        var correction_media = patientData.media.correction_media;
        var correction_media_arr = correction_media ? Object.keys(correction_media) : [];
        var optional_media = patientData.media.optional_media || [];
        window.reqPhotoCount = 0;
        window.reqPhotoHeight = 47;
        window.reqPhotoState = 0;

        window.computeHeightReq = function () {
          window.reqPhotoCount++;

          if (window.reqPhotoCount === required_images_arr.length) {
            window.reqPhotoHeight = $("#ortho-patient-scroll-group_req").height();
            $("#ortho-patient-scroll-group_req").height(47);
          }
        };

        window.corrPhotoCount = 0;
        window.corrPhotoHeight = 47;
        window.corrPhotoState = 0; // window.computeHeightCorr = () => {
        //   window.corrPhotoCount++;
        //   if (window.corrPhotoCount === optional_media.length) {
        //     window.corrPhotoHeight = $('#ortho-patient-scroll-group_corr').height();
        //     $('#ortho-patient-scroll-group_corr').height(47);
        //   }
        // };

        window.extraPhotoCount = 0;
        window.extraPhotoHeight = 47;
        window.extraPhotoState = 0;

        window.computeHeightExtra = function () {
          window.extraPhotoCount++;

          if (window.extraPhotoCount === optional_media.length) {
            window.extraPhotoHeight = $("#ortho-patient-scroll-group_extra").height();
            $("#ortho-patient-scroll-group_extra").height(47);
          }
        };

        info.innerHTML += "\n        <div class=\"non_scrollable ortho-patient\">\n          <div class=\"non_scrollable ortho-patient-button\">\n            <svg class=\"non_scrollable\" id=\"ortho-patient-button-chevron\" version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256;\" xml:space=\"preserve\">\n              <polygon points=\"225.813,48.907 128,146.72 30.187,48.907 0,79.093 128,207.093 256,79.093\"/>\n            </svg>\n          </div>\n          <div id=\"ortho-patient-scroll\" class=\"non_scrollable ortho-patient-scroll\">\n            \n          ".concat(required_order.length ? "<div class=\"non_scrollable ortho-patient-scroll-group ortho-patient-scroll-group_req\" id=\"ortho-patient-scroll-group_req\">\n                <div class=\"non_scrollable ortho-patient-scroll-group-header\">".concat("Initial condition", "</div>\n                <div class=\"non_scrollable ortho-patient-sub_button_req\">\n                  <svg class=\"non_scrollable\" id=\"ortho-patient-sub_button_req-chevron\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" text-rendering=\"geometricPrecision\" shape-rendering=\"geometricPrecision\" style=\"white-space: pre;\">\n                    <path id=\"path0\" d=\"M0,0L-25,24.5\" stroke=\"#00858a\" fill=\"none\" stroke-linecap=\"square\" stroke-width=\"10\" transform=\"translate(44.5,32)\"/>\n                    <path id=\"path1\" d=\"M0,0L-25,-24.5\" stroke=\"#00858a\" fill=\"none\" stroke-linecap=\"square\" stroke-width=\"10\" transform=\"translate(44.5,32)\"/>\n                  </svg>\n                </div>\n\n                ").concat(required_order.map(function (elm) {
          return "\n                    <div class=\"non_scrollable ortho-patient-scroll-group-item\">\n                      <div class=\"non_scrollable ortho-patient-scroll-group-item-header\">".concat(Object({"Plan ID":"Plan ID ","Upper jaw":"Upper jaw","Lower jaw":"Lower jaw","Total steps":"Total steps","IPR before step":"IPR before step","Step":"Step","Approve":"Approve","Publish_QA":"Next: Clinical review","Publish_CR":"Next: Printable models","Rework":"Adjust","Rework_QA":"Fallback to Modelling","Rework_CR":"Fallback to Modelling","Rework_comment":"3D Plan comment.","Aligner":"Aligner","Are you sure?":"Are you sure?","Initial condition":"Initial condition","Correction":"Correction","profile":"Profile (not smiling)","full_face_with_smile":"Full face (smiling)","full_face_without_smile":"Full face (not smiling)","occlusal_view_upper":"Upper occlusal","occlusal_view_lower":"Lower occlusal","lateral_view_right":"Right view","front_view":"Front view","lateral_view_left":"Left view","Extra photos":"Extra photos","Cancel":"Cancel","Send":"Send"})[elm], "</div>\n                      <img src=\"https://").concat(ORTHO.lk_api_link, "/api/v1/doctor/patients/").concat(ORTHO.lk_id, "/images/").concat(required_images[elm].linkto, "\" onload=\"window.computeHeightReq()\">\n                    </div>\n                  ");
        }).join(""), "\n              </div>") : "", "\n\n            ").concat(correction_media_arr.length ? correction_media_arr.map(function (elm) {
          var correction_media_elm_arr = Object.keys(correction_media[elm]);
          var correction_order = ["profile", "full_face_with_smile", "full_face_without_smile", "occlusal_view_upper", "occlusal_view_lower", "lateral_view_right", "front_view", "lateral_view_left"].filter(function (elm) {
            return correction_media_elm_arr.indexOf(elm) > -1;
          });

          window.computeHeightCorr = function () {
            window.corrPhotoCount++;

            if (window.corrPhotoCount === correction_media_elm_arr.length) {
              window.corrPhotoHeight = $("#ortho-patient-scroll-group_corr").height();
              $("#ortho-patient-scroll-group_corr").height(47);
            }
          };

          return correction_order.length ? "\n                <div class=\"non_scrollable ortho-patient-scroll-group  ortho-patient-scroll-group_corr\" id=\"ortho-patient-scroll-group_corr\">\n                  <div class=\"non_scrollable ortho-patient-scroll-group-header\">\n                    ".concat("Correction", " \u2116").concat(elm, "\n                  </div>\n                  <div class=\"non_scrollable ortho-patient-sub_button_corr\">\n                    <svg class=\"non_scrollable\" id=\"ortho-patient-sub_button_corr-chevron\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" text-rendering=\"geometricPrecision\" shape-rendering=\"geometricPrecision\" style=\"white-space: pre;\">\n                      <path id=\"path0\" d=\"M0,0L-25,24.5\" stroke=\"#00858a\" fill=\"none\" stroke-linecap=\"square\" stroke-width=\"10\" transform=\"translate(44.5,32)\"/>\n                      <path id=\"path1\" d=\"M0,0L-25,-24.5\" stroke=\"#00858a\" fill=\"none\" stroke-linecap=\"square\" stroke-width=\"10\" transform=\"translate(44.5,32)\"/>\n                    </svg>\n                    </div>\n                  ").concat(correction_order.map(function (_elm) {
            return "\n                    <div class=\"non_scrollable ortho-patient-scroll-group-item\">\n                      <div class=\"non_scrollable ortho-patient-scroll-group-item-header\">".concat(Object({"Plan ID":"Plan ID ","Upper jaw":"Upper jaw","Lower jaw":"Lower jaw","Total steps":"Total steps","IPR before step":"IPR before step","Step":"Step","Approve":"Approve","Publish_QA":"Next: Clinical review","Publish_CR":"Next: Printable models","Rework":"Adjust","Rework_QA":"Fallback to Modelling","Rework_CR":"Fallback to Modelling","Rework_comment":"3D Plan comment.","Aligner":"Aligner","Are you sure?":"Are you sure?","Initial condition":"Initial condition","Correction":"Correction","profile":"Profile (not smiling)","full_face_with_smile":"Full face (smiling)","full_face_without_smile":"Full face (not smiling)","occlusal_view_upper":"Upper occlusal","occlusal_view_lower":"Lower occlusal","lateral_view_right":"Right view","front_view":"Front view","lateral_view_left":"Left view","Extra photos":"Extra photos","Cancel":"Cancel","Send":"Send"})[_elm], "</div>\n                      <img src=\"https://").concat(ORTHO.lk_api_link, "/api/v1/doctor/patients/").concat(ORTHO.lk_id, "/images/").concat(correction_media[elm][_elm].linkto, "\" onload=\"window.computeHeightCorr()\">\n                    </div>\n                  ");
          }).join(""), "\n                </div>\n              ") : "";
        }).join("") : "", "\n            ").concat(optional_media.length ? "<div class=\"non_scrollable ortho-patient-scroll-group ortho-patient-scroll-group_extra\" id=\"ortho-patient-scroll-group_extra\">\n                <div class=\"non_scrollable ortho-patient-scroll-group-header\">\n                  ".concat("Extra photos", "\n                </div>\n                <div class=\"non_scrollable ortho-patient-sub_button_extra\">\n                  <svg class=\"non_scrollable\" id=\"ortho-patient-sub_button_extra-chevron\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" text-rendering=\"geometricPrecision\" shape-rendering=\"geometricPrecision\" style=\"white-space: pre;\">\n                    <path id=\"path0\" d=\"M0,0L-25,24.5\" stroke=\"#00858a\" fill=\"none\" stroke-linecap=\"square\" stroke-width=\"10\" transform=\"translate(44.5,32)\"/>\n                    <path id=\"path1\" d=\"M0,0L-25,-24.5\" stroke=\"#00858a\" fill=\"none\" stroke-linecap=\"square\" stroke-width=\"10\" transform=\"translate(44.5,32)\"/>\n                  </svg>\n                </div>\n              ").concat(optional_media.map(function (elm, i) {
          return "\n                <div class=\"non_scrollable ortho-patient-scroll-group-item\">\n                  <div class=\"non_scrollable ortho-patient-scroll-group-item-header\">\n                    ".concat(elm.linkto.split("/").pop(), "\n                  </div>\n                  <img src=\"https://").concat(ORTHO.lk_api_link, "/api/v1/doctor/patients/").concat(ORTHO.lk_id, "/images/").concat(elm.linkto, "\" onload=\"window.computeHeightExtra()\">\n                </div>\n              ");
        }).join(""), "\n              </div>") : "", "\n          </div>\n        </div>\n      ");
        $(".ortho-patient-button").on("click", togglePatientInfo);
        $(".ortho-rework-button").on("click", closePatientInfo);
        $(".ortho-patient-sub_button_req").on("click", function () {
          $("#ortho-patient-sub_button_req-chevron").toggleClass("-opened");

          if (window.reqPhotoState = 1 - window.reqPhotoState) {
            $("#ortho-patient-scroll-group_req").height(window.reqPhotoHeight);
          } else {
            $("#ortho-patient-scroll-group_req").height(47);
          }
        });
        $(".ortho-patient-sub_button_corr").on("click", function () {
          $("#ortho-patient-sub_button_corr-chevron").toggleClass("-opened");

          if (window.corrPhotoState = 1 - window.corrPhotoState) {
            $("#ortho-patient-scroll-group_corr").height(window.corrPhotoHeight);
          } else {
            $("#ortho-patient-scroll-group_corr").height(47);
          }
        });
        $(".ortho-patient-sub_button_extra").on("click", function () {
          $("#ortho-patient-sub_button_extra-chevron").toggleClass("-opened");

          if (window.extraPhotoState = 1 - window.extraPhotoState) {
            $("#ortho-patient-scroll-group_extra").height(window.extraPhotoHeight);
          } else {
            $("#ortho-patient-scroll-group_extra").height(47);
          }
        });
      }

      if (window.__VIEWER_TYPE__ === "deepct" && "3d-api-simple-frontend" === "3d-plan") {
        $(".ortho-info-row.-head").css({
          "border-bottom": "0px"
        });
        $(".ortho-info-block").remove();
      }

      var infoRow = document.getElementsByClassName("-stage");

      for (var _i5 = 0; _i5 < infoRow.length; _i5++) {
        infoRow[_i5].stage = infoRow[_i5].className.split(" ")[2];
      }

      $(".ortho-info-row.-stage.0").addClass("-red");
      $(".ortho-publish-button").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (window.confirm(LOCAL["Are you sure?"]) && ORTHO.nextStep) {
          ORTHO.nextStep();
        }
      });

      if (true) {}

      var reworkBtn = $(".ortho-rework-button");
      var commentDialog;

      if (reworkBtn[0]) {
        commentDialog = new CommentDialog(".ortho-rework-comment");
        reworkBtn.on("click", function () {
          !isMobile && commentDialog.open();
        });
      }

      $(".ortho-correction .ortho-card__close").on("click", function () {
        $(".ortho-info").removeClass('-visible');
        ;
      });
      $(".ortho-correction").on("click", function (e) {
        var isBackdrop = !e.target.closest(".ortho-info-inner");

        if (isBackdrop) {
          $(".ortho-info").removeClass('-visible');
          ;
        }
      });
      var up = $($(".ortho-controls-current")[0]);
      var down = $($(".ortho-controls-current")[1]);
      up.html("".concat(LOCAL.Aligner, " 1"));
      down.html("".concat(LOCAL.Aligner, " 1"));
      var preventedKeys = [37, 38, 39, 40];
      $(window).on("keydown keyup", function (evt) {
        if (preventedKeys.indexOf(evt.keyCode) > -1) {
          evt.preventDefault();
        }
      });
    } catch (evt) {
      (catchCallback || function () {
        return 0;
      })(evt, "info");
    }
  });

  return function (_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/lines.js":
/*!*************************!*\
  !*** ./src/js/lines.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(CubicBezierCurve3, catchCallback) {module.exports = function (CTX, gl, uProjMat, uViewMat, uVisUpper, uVisLower, uuIndex, uZoom, sep, SEPARATIONS) {
  try {
    var LINES = gl.LINES;
    var position = [];
    var indexes = [];
    var location = [];

    var parse = function parse(stage, position, indexes, k, dir, loc) {
      var a = stage.centroid[stage.separation[k].a];
      var b = stage.centroid[stage.separation[k].b];
      var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
      var ab = new CTX.DataFloat3({
        x: a[0] - b[0],
        y: a[1] - b[1],
        z: a[2] - b[2]
      });
      ab.normalize();
      var cd = [ab.z, 0, ab.x];
      var d0 = new CTX.DataFloat3({
        x: c[0] - cd[0] * 30,
        y: c[1] + dir * 20,
        z: c[2] + cd[2] * 30
      });
      var d1 = new CTX.DataFloat3({
        x: c[0] + cd[0] * 30,
        y: c[1] + dir * 20,
        z: c[2] - cd[2] * 30
      });
      var from = new CTX.DataFloat3({
        x: c[0],
        y: c[1],
        z: c[2]
      });
      var to = new CTX.DataFloat3({
        x: d0.x,
        y: d0.y,
        z: d0.z
      });

      if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
        to = new CTX.DataFloat3({
          x: d1.x,
          y: d1.y,
          z: d1.z
        });
      }

      var mid = new CTX.DataFloat3({
        x: (from.x + to.x) * 0.5,
        y: from.y,
        z: (from.z + to.z) * 0.5
      });

      var _points = new CubicBezierCurve3(from, mid, mid, to).getPoints(41);

      for (var h = 0; h < _points.length; h++) {
        position.push(_points[h].x, _points[h].y, _points[h].z);
        indexes.push(window.__VIEWER_TYPE__ === 'main' ? stage.model[0].from : stage.model[0] - 1);
        location.push(loc);
      }
    };

    for (var i in sep.upper) {
      if (sep.upper[i].separation && Object.keys(sep.upper[i].separation).length) {
        for (var k in sep.upper[i].separation) {
          parse(sep.upper[i], position, indexes, k, 1, 1);
        }
      }
    }

    for (var _i in sep.lower) {
      if (sep.lower[_i].separation && Object.keys(sep.lower[_i].separation).length) {
        for (var _k in sep.lower[_i].separation) {
          parse(sep.lower[_i], position, indexes, _k, -1, 0);
        }
      }
    }

    var material = new CTX.Material({
      VS: function VS() {
        return "\n          precision ".concat(CTX.maxPrecision.vs.float, " float;\n          ").concat(uProjMat.uniform(this), "\n          ").concat(uViewMat.uniform(this), "\n          ").concat(uZoom.uniform(this), "\n          ").concat(uuIndex.uniform(this), "\n          ").concat(uVisUpper.uniform(this), "\n          ").concat(uVisLower.uniform(this), "\n          attribute vec3 position;\n          attribute float index;\n          attribute float location;\n          void main() {\n            gl_Position = projectionMatrix * viewMatrix * vec4(position, zoom) * (1. - (abs(uIndex - index))) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n          }\n        ");
      },
      FS: "\n        precision ".concat(CTX.maxPrecision.fs.float, " float;\n        void main() {\n          gl_FragColor.y = .522;\n          gl_FragColor.z = .541;\n          gl_FragColor.w = 1.0;\n        }\n        ")
    });

    if (position.length) {
      var program = material.program;
      var vCount = position.length / 3;
      var positionBuf = new CTX.VBO({
        content: new Float32Array(position),
        name: 'position',
        location: 0
      });
      var indexBuf = new CTX.VBO({
        content: new Float32Array(indexes),
        name: 'index',
        size: 1,
        location: 1
      });
      var locationBuf = new CTX.VBO({
        content: new Float32Array(location),
        name: 'location',
        size: 1,
        location: 2
      });
      var obj = new CTX.Obj({
        draw: function draw() {
          gl.useProgram(program);
          positionBuf.enable();
          indexBuf.enable();
          locationBuf.enable();
          gl.drawArrays(LINES, 0, vCount);
        }
      });
      SEPARATIONS.push(obj);
    }
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'info');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./cubic-bezier-curve-3 */ "./src/js/cubic-bezier-curve-3.js"), __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(WebGL, errorCallback, $, Loader, progressCallback, prepareResponses, getCameras, ROTATION_MATRIX_X, hex, getDrawFunc4Attr, getDrawFunc2Attr, getGrid, getLayers, getTriangles, getLayersLocks, getTrianglesLocks, extArr, getSpheres, ROTATION_MATRIX_Y, getLines, getCircles, getQuads, getSlider, getModes, getOrbit, getInfo, setFinalCSS, catchCallback) {module.exports = function (ORTHO) {
  var __style = document.createElement('style');

  __style.innerHTML = 'iframe#launcher {display: none !important;}';
  document.getElementsByTagName('head')[0].appendChild(__style);
  var CTX = new WebGL({
    errorCallback: errorCallback,
    alpha: true
  });
  var parent = $('.ortho-gl-container')[0];
  $('.ortho-nowebgl').hide();
  var prefix = ORTHO.source_stage_folder;
  var loader = new Loader();
  var _window$env = Object({"BUILD":undefined,"API":undefined,"TARGET":"3d-api-simple-frontend","TYPE":"all","BRAND":"predict","LANG":"en","ACTION":"build","LOCAL":Object({"Plan ID":"Plan ID ","Upper jaw":"Upper jaw","Lower jaw":"Lower jaw","Total steps":"Total steps","IPR before step":"IPR before step","Step":"Step","Approve":"Approve","Publish_QA":"Next: Clinical review","Publish_CR":"Next: Printable models","Rework":"Adjust","Rework_QA":"Fallback to Modelling","Rework_CR":"Fallback to Modelling","Rework_comment":"3D Plan comment.","Aligner":"Aligner","Are you sure?":"Are you sure?","Initial condition":"Initial condition","Correction":"Correction","profile":"Profile (not smiling)","full_face_with_smile":"Full face (smiling)","full_face_without_smile":"Full face (not smiling)","occlusal_view_upper":"Upper occlusal","occlusal_view_lower":"Lower occlusal","lateral_view_right":"Right view","front_view":"Front view","lateral_view_left":"Left view","Extra photos":"Extra photos","Cancel":"Cancel","Send":"Send"})}),
      TARGET = _window$env.TARGET,
      TYPE = _window$env.TYPE,
      BRAND = _window$env.BRAND,
      LANG = _window$env.LANG,
      ACTION = _window$env.ACTION;
  loader.load({
    sources: {
      list: ( true ? ORTHO.json['case.json'] : undefined) + "?".concat(Date.now())
    }
  }).then(function (responses) {
    var CASE = JSON.parse(responses.list);

    if (true) {
      CASE.files = Object.values(ORTHO.json);
    }

    var files = {};
    var i = CASE.files.length;

    if (true) {
      while (i--) {
        if (CASE.files[i].split) {
          files[CASE.files[i]] = {
            source: CASE.files[i] + "?".concat(Date.now()),
            type: 'arraybuffer'
          };
        }
      }
    } else {}

    if (true) {
      if (true) {
        files.logo = {
          source: "".concat(ORTHO.base_url, "/static/media/cup_logo.png") + "?".concat(Date.now()),
          type: 'image'
        };
      } else {}
    } else {}

    loader.load({
      sources: files,
      progress: progressCallback()
    }).then(function (responses) {
      try {
        var gl = CTX.WebGLRenderingContext;
        var TRIANGLES = gl.TRIANGLES,
            UNSIGNED_SHORT = gl.UNSIGNED_SHORT,
            UNSIGNED_INT = gl.UNSIGNED_INT,
            COLOR_BUFFER_BIT = gl.COLOR_BUFFER_BIT,
            BLEND = gl.BLEND;
        var GLUINT = gl.getExtension('OES_element_index_uint');
        responses = prepareResponses(responses);
        CTX.setSize(0, 0, parent.offsetWidth, parent.offsetHeight);
        gl.clearColor(1, 1, 1, 1);
        gl.clear(COLOR_BUFFER_BIT);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LESS);
        gl.enable(BLEND); // gl.enable(gl.CULL_FACE);
        // gl.cullFace(gl.BACK);

        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        gl.getExtension('OES_standard_derivatives') || gl.getExtension('MOZ_OES_standard_derivatives') || gl.getExtension('WEBKIT_OES_standard_derivatives'); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var bezier1 = CTX.math.BezierCubicCurve(0.25, 0, 0, 1);
        var TEETH_GUMS = [];
        var LOCKS = [];
        var timeline = [new CTX.DataFloat1(), new CTX.DataFloat1()];
        var timelineLocks = [new CTX.DataFloat1(), new CTX.DataFloat1()];
        var timelineRamps = [new CTX.DataFloat1(), new CTX.DataFloat1()];
        var timelineTorq = [new CTX.DataFloat1(), new CTX.DataFloat1()];
        var timelineColors = new CTX.DataFloat1();
        var sep = CASE.dict;
        var visUpper = new CTX.DataFloat1({
          name: 'visUpper',
          x: 1
        });
        var visLower = new CTX.DataFloat1({
          name: 'visLower',
          x: 1
        });
        var rot = new CTX.DataFloat1({
          name: 'rot'
        });
        var zoom = new CTX.DataFloat1({
          name: 'zoom',
          x: 1
        });
        var uIndex = new CTX.DataFloat1({
          name: 'uIndex'
        });
        var drawGrid = {
          x: 0
        };
        var drawSep = {
          x: 1
        };
        var drawLoc = {
          x: 1
        };
        var upperSrcLayers = CASE.upper.keys.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var lowerSrcLayers = CASE.lower.keys.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var upperSrcSep = CASE.upper.separations;
        var lowerSrcSep = CASE.lower.separations;
        var upperSrcLayersLocks = CASE.upper.locksKeys.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var lowerSrcLayersLocks = CASE.lower.locksKeys.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var upperSrcLayersRamps = (CASE.upper.rampsKeys || []).map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var lowerSrcLayersRamps = (CASE.lower.rampsKeys || []).map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var upperSrcLayersTorq = (CASE.upper.torqKeys || []).map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var lowerSrcLayersTorq = (CASE.lower.torqKeys || []).map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        }); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var _getCameras = getCameras(CTX, parent),
            orbit = _getCameras.orbit,
            updateProjectionMatrix = _getCameras.updateProjectionMatrix;

        updateProjectionMatrix[drawGrid.x](); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var upperInterp = new CTX.DataFloat1();
        var lowerInterp = new CTX.DataFloat1();
        var upperInterpFract = new CTX.DataFloat1({
          name: 'interp'
        });
        var lowerInterpFract = new CTX.DataFloat1({
          name: 'interp'
        });
        var upperInterpLocks = new CTX.DataFloat1();
        var lowerInterpLocks = new CTX.DataFloat1();
        var upperInterpFractLocks = new CTX.DataFloat1({
          name: 'interp'
        });
        var lowerInterpFractLocks = new CTX.DataFloat1({
          name: 'interp'
        });
        var upperInterpRamps = new CTX.DataFloat1();
        var lowerInterpRamps = new CTX.DataFloat1();
        var upperInterpFractRamps = new CTX.DataFloat1({
          name: 'interp'
        });
        var lowerInterpFractRamps = new CTX.DataFloat1({
          name: 'interp'
        });
        var upperInterpTorq = new CTX.DataFloat1();
        var lowerInterpTorq = new CTX.DataFloat1();
        var upperInterpFractTorq = new CTX.DataFloat1({
          name: 'interp'
        });
        var lowerInterpFractTorq = new CTX.DataFloat1({
          name: 'interp'
        });
        var interpColors = new CTX.DataFloat1();
        var interpColorsFract = new CTX.DataFloat1({
          name: 'interpColors'
        });
        var _orbit$camera = orbit.camera,
            projectionMatrix = _orbit$camera.projectionMatrix,
            viewMatrix = _orbit$camera.viewMatrix,
            position = _orbit$camera.position;

        var getMaterialTeeth = function getMaterialTeeth(item, vis, interpFract, colored, _ref, interpColorsFract) {
          var minZ = _ref.minZ;
          return new CTX.Material({
            VS: function VS() {
              return "\n                  precision ".concat(CTX.maxPrecision.vs.float, " float;\n                  ").concat(projectionMatrix.uniform(this), "\n                  ").concat(viewMatrix.uniform(this), "\n                  ").concat(interpFract.uniform(this), "\n                  ").concat(interpColorsFract ? interpColorsFract.uniform(this) : '', "\n                  ").concat(rot.uniform(this), "\n                  ").concat(zoom.uniform(this), "\n                  ").concat(position.uniform(this), "\n                  ").concat(vis.uniform(this), "\n                  attribute vec3 aStartPosition;\n                  attribute vec3 aEndPosition;\n                  ").concat(colored ? "\n                    attribute vec3 aStartColor;\n                    attribute vec3 aEndColor;\n                  " : '', "\n                  varying vec4 vPosition;\n                  varying vec4 vCol;\n                  varying vec3 lightDir;\n                  ").concat(ROTATION_MATRIX_X, "\n                  void main() {\n                    vec3 vPosXYZ = mix(aStartPosition, aEndPosition, interp);\n                    vCol = vec4(").concat(colored ? "mix(vec3(1.), mix(aStartColor, aEndColor, ".concat(interpColorsFract ? 'interpColors' : 'interp', "), rot), ") : '', "1.);\n                    vPosXYZ.z -= ").concat((minZ - 3).toString().split('.')[0], ".;\n                    vPosition = rotationMatrixX(").concat(item, " rot) * vec4(vPosXYZ, zoom);\n                    vPosition.z += ").concat((minZ - 3).toString().split('.')[0], ".;\n                    lightDir = normalize(cameraPosition - vPosXYZ);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(vis.name, ";\n                  }\n                ");
            },
            FS: "\n                #extension GL_OES_standard_derivatives: enable\n                precision ".concat(CTX.maxPrecision.fs.float, " float;\n                varying vec4 vPosition;\n                varying vec4 vCol;\n                varying vec3 lightDir;\n                void main() {\n                  float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                  gl_FragColor = vCol * diffuse;\n                  gl_FragColor.w = 1.0;\n                }\n                ")
          });
        };

        var TexLogo = new CTX.Texture2D({
          name: 'LOGO',
          image: responses.logo,
          max: gl.LINEAR,
          min: gl.LINEAR_MIPMAP_LINEAR,
          anisotropy: 16,
          unit: 0
        });

        var getMaterial = function getMaterial(color, item, vis, interpFract, _ref2, _ref3, blend) {
          var minZ = _ref2.minZ,
              avZ = _ref2.avZ;
          var minY = _ref3.minY,
              maxY = _ref3.maxY;
          return new CTX.Material({
            VS: function VS() {
              return "\n                  precision ".concat(CTX.maxPrecision.vs.float, " float;\n                  ").concat(projectionMatrix.uniform(this), "\n                  ").concat(viewMatrix.uniform(this), "\n                  ").concat(interpFract.uniform(this), "\n                  ").concat(rot.uniform(this), "\n                  ").concat(zoom.uniform(this), "\n                  ").concat(position.uniform(this), "\n                  ").concat(vis.uniform(this), "\n                  attribute vec3 aStartPosition;\n                  attribute vec3 aEndPosition;\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  varying float absPosY;\n                  varying vec2 texCoords;\n                  ").concat(ROTATION_MATRIX_X, "\n                  void main() {\n                    vec3 vPosXYZ = mix(aStartPosition, aEndPosition, interp);\n                    absPosY = abs(vPosXYZ.y);\n                    if (vPosXYZ.y < ").concat(minY.toString().split('.')[0], ".) {\n                      vPosXYZ.y = ").concat(minY.toString().split('.')[0], ".;\n                    }\n                    if (vPosXYZ.y > ").concat(maxY.toString().split('.')[0], ".) {\n                      vPosXYZ.y = ").concat(maxY.toString().split('.')[0], ".;\n                    }\n                    texCoords = vPosXYZ.xz;\n                    texCoords.y -= ").concat((avZ - 3).toString().split('.')[0], ".;\n                    vPosXYZ.z -= ").concat((minZ - 3).toString().split('.')[0], ".;\n                    vPosition = rotationMatrixX(").concat(item, " rot) * vec4(vPosXYZ, zoom);\n                    vPosition.z +=  ").concat((minZ - 3).toString().split('.')[0], ".;\n                    lightDir = normalize(cameraPosition - vPosXYZ);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(vis.name, ";\n                  }\n                ");
            },
            FS: function FS() {
              return "\n                  #extension GL_OES_standard_derivatives: enable\n                  precision ".concat(CTX.maxPrecision.fs.float, " float;\n                  ").concat(hex(CTX, color).uniform(this), "\n                  ").concat(TexLogo.uniform(this), "\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  varying float absPosY;\n                  varying vec2 texCoords;\n                  void main() {\n                    float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                    vec4 texel = texture2D(LOGO, (texCoords * 0.05 + 0.5) * (sign(vPosition.y) + 1.0) * 0.5);\n                    gl_FragColor = vec4(absPosY > ").concat((maxY - 1).toString().split('.')[0], ".99 ? texel.xyz : uColor, 1.0) * diffuse;\n                    gl_FragColor.w = ").concat(blend ? '0.5' : '1.0', ";\n                  }\n                ");
            }
          });
        };

        var getObjectTeeth = function getObjectTeeth(item, material, interp, interpColors) {
          return new CTX.Obj({
            draw: getDrawFunc4Attr(material, item, interp, item.colors, interpColors, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT)
          });
        };

        var getObject = function getObject(item, material, interp) {
          return new CTX.Obj({
            draw: getDrawFunc2Attr(material, item, interp, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT)
          });
        }; // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////


        var grid = getGrid(CTX, gl, orbit.camera.projectionMatrix, zoom); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var minZ = 0;
        var maxZ = 0;

        if (responses['upper_gums_k_0.b']) {
          var vert = new Float32Array(responses['upper_gums_k_0.b']);

          for (var _i = 2; _i < vert.length; _i += 3) {
            !(vert[_i] < minZ) || (minZ = Math.round(vert[_i]));
            !(vert[_i] > maxZ) || (maxZ = Math.round(vert[_i]));
          }
        }

        if (responses['lower_gums_k_0.b']) {
          var _vert = new Float32Array(responses['lower_gums_k_0.b']);

          for (var _i2 = 2; _i2 < _vert.length; _i2 += 3) {
            !(_vert[_i2] < minZ) || (minZ = Math.round(_vert[_i2]));
            !(_vert[_i2] > maxZ) || (maxZ = Math.round(_vert[_i2]));
          }
        }

        var avZ = (maxZ + minZ) * 0.5;
        var minY = 0;
        var maxY = 0;

        if (responses['upper_teeth_k_0.b']) {
          var _vert2 = new Float32Array(responses['upper_teeth_k_0.b']);

          for (var _i3 = 1; _i3 < _vert2.length; _i3 += 3) {
            !(_vert2[_i3] < minY) || (minY = Math.round(_vert2[_i3]));
            !(_vert2[_i3] > maxY) || (maxY = Math.round(_vert2[_i3]));
          }
        }

        if (responses['lower_teeth_k_0.b']) {
          var _vert3 = new Float32Array(responses['lower_teeth_k_0.b']);

          for (var _i4 = 1; _i4 < _vert3.length; _i4 += 3) {
            !(_vert3[_i4] < minY) || (minY = Math.round(_vert3[_i4]));
            !(_vert3[_i4] > maxY) || (maxY = Math.round(_vert3[_i4]));
          }
        }

        if (minY >= -15) {
          minY = -20;
        } else {
          minY -= 5;
        }

        if (maxY <= 15) {
          maxY = 20;
        } else {
          maxY += 5;
        }

        var parse4 = function parse4(param) {
          var i = 0;

          for (; i < param.length; i++) {
            if (param[i] === param[i + 1] && param[i + 1] === param[i + 2] && param[i + 2] === param[i + 3] && param[i - 1] + 1) {
              if (param[i + 4] + 1) {
                param.splice(i, 4, param[i - 1], param[i]);
                break;
              } else {
                param.pop();
              }
            }
          }

          if (i < param.length) {
            parse4(param);
          }
        };

        var upperLayers = getLayers(upperSrcLayers, upperSrcSep);
        parse4(upperLayers);
        var lowerLayers = getLayers(lowerSrcLayers, lowerSrcSep);
        parse4(lowerLayers);
        var upperTriangles = getTriangles(upperLayers, upperSrcSep);
        var lowerTriangles = getTriangles(lowerLayers, lowerSrcSep);
        var layersColors = null;
        var upperLayersLocks = getLayersLocks(upperSrcLayersLocks);
        parse4(upperLayersLocks);
        var lowerLayersLocks = getLayersLocks(lowerSrcLayersLocks);
        parse4(lowerLayersLocks);
        var upperTrianglesLocks = getTrianglesLocks(upperLayersLocks, upperSrcLayersLocks);
        var lowerTrianglesLocks = getTrianglesLocks(lowerLayersLocks, lowerSrcLayersLocks);
        var upperLayersRamps = getLayersLocks(upperSrcLayersRamps);
        parse4(upperLayersRamps);
        var lowerLayersRamps = getLayersLocks(lowerSrcLayersRamps);
        parse4(lowerLayersRamps);
        var upperTrianglesRamps = getTrianglesLocks(upperLayersRamps, upperSrcLayersRamps);
        var lowerTrianglesRamps = getTrianglesLocks(lowerLayersRamps, lowerSrcLayersRamps);
        var upperLayersTorq = getLayersLocks(upperSrcLayersTorq);
        parse4(upperLayersTorq);
        var lowerLayersTorq = getLayersLocks(lowerSrcLayersTorq);
        parse4(lowerLayersTorq);
        var upperTrianglesTorq = getTrianglesLocks(upperLayersTorq, upperSrcLayersTorq);
        var lowerTrianglesTorq = getTrianglesLocks(lowerLayersTorq, lowerSrcLayersTorq);
        var upperLayersExt = extArr(upperLayers);
        var upperTrianglesExt = extArr(upperTriangles);
        var lowerLayersExt = extArr(lowerLayers);
        var lowerTrianglesExt = extArr(lowerTriangles);
        var upperLayersLocksExt = extArr(upperLayersLocks);
        var upperTrianglesLocksExt = extArr(upperTrianglesLocks);
        var lowerLayersLocksExt = extArr(lowerLayersLocks);
        var lowerTrianglesLocksExt = extArr(lowerTrianglesLocks);
        var upperLayersRampsExt = extArr(upperLayersRamps);
        var upperTrianglesRampsExt = extArr(upperTrianglesRamps);
        var lowerLayersRampsExt = extArr(lowerLayersRamps);
        var lowerTrianglesRampsExt = extArr(lowerTrianglesRamps);
        var upperLayersTorqExt = extArr(upperLayersTorq);
        var upperTrianglesTorqExt = extArr(upperTrianglesTorq);
        var lowerLayersTorqExt = extArr(lowerLayersTorq);
        var lowerTrianglesTorqExt = extArr(lowerTrianglesTorq);

        if (CASE.upper.teethIs) {
          var layersColors_ = getLayers(function () {
            var res = upperSrcLayers.slice();
            res.pop();
            res.push(Math.max(upperSrcLayers.slice().pop(), lowerSrcLayers.slice().pop()));
            return res;
          }(), upperSrcSep);
          parse4(layersColors_);
          TEETH_GUMS.push(getObjectTeeth({
            triangles: upperTrianglesExt.map(function (elm) {
              return responses["upper_teeth_t_".concat(elm, ".b")];
            }),
            vertices: upperLayersExt.map(function (elm) {
              return responses["upper_teeth_k_".concat(elm, ".b")];
            }),
            colors: extArr(layersColors_).map(function (elm) {
              return responses["upper_teeth_c_".concat(elm, ".b")];
            })
          }, getMaterialTeeth('', visUpper, upperInterpFract, responses['upper_teeth_c_0.b'], {
            minZ: minZ
          }, function () {
            var res = null;

            if (upperSrcLayers.slice().pop() < lowerSrcLayers.slice().pop()) {
              var srcLayersColors = upperSrcLayers.slice();
              srcLayersColors.pop();
              srcLayersColors.push(lowerSrcLayers.slice().pop());
              layersColors = getLayers(srcLayersColors, upperSrcSep);
              parse4(layersColors);
              res = interpColorsFract;
            }

            return res;
          }()), upperInterp, upperSrcLayers.slice().pop() >= lowerSrcLayers.slice().pop() ? upperInterp : interpColors));
        }

        if (CASE.lower.teethIs) {
          var _layersColors_ = getLayers(function () {
            var res = lowerSrcLayers.slice();
            res.pop();
            res.push(Math.max(upperSrcLayers.slice().pop(), lowerSrcLayers.slice().pop()));
            return res;
          }(), lowerSrcSep);

          parse4(_layersColors_);
          TEETH_GUMS.push(getObjectTeeth({
            triangles: lowerTrianglesExt.map(function (elm) {
              return responses["lower_teeth_t_".concat(elm, ".b")];
            }),
            vertices: lowerLayersExt.map(function (elm) {
              return responses["lower_teeth_k_".concat(elm, ".b")];
            }),
            colors: extArr(_layersColors_).map(function (elm) {
              return responses["lower_teeth_c_".concat(elm, ".b")];
            })
          }, getMaterialTeeth('-', visLower, lowerInterpFract, responses['lower_teeth_c_0.b'], {
            minZ: minZ
          }, function () {
            var res = null;

            if (upperSrcLayers.slice().pop() >= lowerSrcLayers.slice().pop()) {
              var srcLayersColors = lowerSrcLayers.slice();
              srcLayersColors.pop();
              srcLayersColors.push(upperSrcLayers.slice().pop());
              layersColors = getLayers(srcLayersColors, lowerSrcSep);
              parse4(layersColors);
              res = interpColorsFract;
            }

            return res;
          }()), lowerInterp, upperSrcLayers.slice().pop() < lowerSrcLayers.slice().pop() ? lowerInterp : interpColors));
        }

        if (CASE.upper.gumsIs) {
          TEETH_GUMS.push(getObject({
            triangles: upperTrianglesExt.map(function (elm) {
              return responses["upper_gums_t_".concat(elm, ".b")];
            }),
            vertices: upperLayersExt.map(function (elm) {
              return responses["upper_gums_k_".concat(elm, ".b")];
            })
          }, getMaterial('ff9c8e', '', visUpper, upperInterpFract, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }), upperInterp));
        }

        if (CASE.lower.gumsIs) {
          TEETH_GUMS.push(getObject({
            triangles: lowerTrianglesExt.map(function (elm) {
              return responses["lower_gums_t_".concat(elm, ".b")];
            }),
            vertices: lowerLayersExt.map(function (elm) {
              return responses["lower_gums_k_".concat(elm, ".b")];
            })
          }, getMaterial('ff9c8e', '-', visLower, lowerInterpFract, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }), lowerInterp));
        }

        if (CASE.upper.locksIs) {
          LOCKS.push(getObject({
            triangles: upperTrianglesLocksExt.map(function (elm) {
              return responses["upper_locks_t_".concat(elm, ".b")];
            }),
            vertices: upperLayersLocksExt.map(function (elm) {
              return responses["upper_locks_k_".concat(elm, ".b")];
            })
          }, getMaterial('82d9d4', '', visUpper, upperInterpFractLocks, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }), upperInterpLocks));
        }

        if (CASE.lower.locksIs) {
          LOCKS.push(getObject({
            triangles: lowerTrianglesLocksExt.map(function (elm) {
              return responses["lower_locks_t_".concat(elm, ".b")];
            }),
            vertices: lowerLayersLocksExt.map(function (elm) {
              return responses["lower_locks_k_".concat(elm, ".b")];
            })
          }, getMaterial('82d9d4', '-', visLower, lowerInterpFractLocks, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }), lowerInterpLocks));
        }

        if (CASE.upper.rampsIs) {
          LOCKS.push(getObject({
            triangles: upperTrianglesRampsExt.map(function (elm) {
              return responses["upper_ramps_t_".concat(elm, ".b")];
            }),
            vertices: upperLayersRampsExt.map(function (elm) {
              return responses["upper_ramps_k_".concat(elm, ".b")];
            })
          }, getMaterial('00858A', '', visUpper, upperInterpFractRamps, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }, true), upperInterpRamps));
        }

        if (CASE.lower.rampsIs) {
          LOCKS.push(getObject({
            triangles: lowerTrianglesRampsExt.map(function (elm) {
              return responses["lower_ramps_t_".concat(elm, ".b")];
            }),
            vertices: lowerLayersRampsExt.map(function (elm) {
              return responses["lower_ramps_k_".concat(elm, ".b")];
            })
          }, getMaterial('00858A', '-', visLower, lowerInterpFractRamps, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }, true), lowerInterpRamps));
        }

        if (CASE.upper.torqIs) {
          LOCKS.push(getObject({
            triangles: upperTrianglesTorqExt.map(function (elm) {
              return responses["upper_torq_t_".concat(elm, ".b")];
            }),
            vertices: upperLayersTorqExt.map(function (elm) {
              return responses["upper_torq_k_".concat(elm, ".b")];
            })
          }, getMaterial('ff00ff', '', visUpper, upperInterpFractTorq, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }), upperInterpTorq));
        }

        if (CASE.lower.torqIs) {
          LOCKS.push(getObject({
            triangles: lowerTrianglesTorqExt.map(function (elm) {
              return responses["lower_torq_t_".concat(elm, ".b")];
            }),
            vertices: lowerLayersTorqExt.map(function (elm) {
              return responses["lower_torq_k_".concat(elm, ".b")];
            })
          }, getMaterial('ff00ff', '-', visLower, lowerInterpFractTorq, {
            minZ: minZ,
            avZ: avZ
          }, {
            minY: minY,
            maxY: maxY
          }), lowerInterpTorq));
        } // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////


        var SEPARATIONS = [];
        var values = [];
        getSpheres(CTX, gl, orbit.camera.projectionMatrix, orbit.camera.viewMatrix, visLower, uIndex, zoom, visUpper, orbit.rotation, sep, SEPARATIONS, ROTATION_MATRIX_X, ROTATION_MATRIX_Y);
        getLines(CTX, gl, orbit.camera.projectionMatrix, orbit.camera.viewMatrix, visUpper, visLower, uIndex, zoom, sep, SEPARATIONS);
        getCircles(CTX, gl, orbit.camera.projectionMatrix, orbit.camera.viewMatrix, visLower, uIndex, zoom, visUpper, orbit.rotation, sep, SEPARATIONS, values, ROTATION_MATRIX_X, ROTATION_MATRIX_Y);
        getQuads(CTX, gl, orbit.camera.projectionMatrix, orbit.camera.viewMatrix, visLower, uIndex, zoom, visUpper, orbit.rotation, sep, SEPARATIONS, values, ROTATION_MATRIX_X, ROTATION_MATRIX_Y);
        var slider = getSlider(upperLayers, lowerLayers, upperLayersLocks, lowerLayersLocks, CTX, timeline, timelineLocks, uIndex, upperInterp, lowerInterp, upperInterpFract, lowerInterpFract, upperInterpLocks, lowerInterpLocks, upperInterpFractLocks, lowerInterpFractLocks, interpColors, interpColorsFract, timelineColors, layersColors, upperLayersRamps, lowerLayersRamps, timelineRamps, upperInterpRamps, lowerInterpRamps, upperInterpFractRamps, lowerInterpFractRamps, upperLayersTorq, lowerLayersTorq, timelineTorq, upperInterpTorq, lowerInterpTorq, upperInterpFractTorq, lowerInterpFractTorq);
        getModes(ORTHO, rot, bezier1, visUpper, visLower, updateProjectionMatrix, drawGrid, CTX, drawLoc, drawSep, false, orbit, false, responses['upper_teeth_t_0.b'], responses['lower_teeth_t_0.b']);
        getOrbit(orbit, gl, zoom, CTX, updateProjectionMatrix, drawGrid, slider);
        getInfo(ORTHO, CASE, upperLayers, upperSrcSep, lowerLayers, lowerSrcSep, responses['upper_teeth_t_0.b'], responses['lower_teeth_t_0.b']); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var BLANK_FUNCTION = function BLANK_FUNCTION() {};

        var LOCKS_LENGHT = LOCKS.length;
        var TEETH_GUMS_LENGHT = TEETH_GUMS.length;
        var gridSwitch = [BLANK_FUNCTION, function () {
          grid.draw();
        }];
        var locSwitch = [BLANK_FUNCTION, function () {
          for (var _i5 = 0; _i5 < LOCKS_LENGHT; _i5++) {
            LOCKS[_i5].draw();
          }
        }];
        var sepSwitch = [BLANK_FUNCTION, function () {
          var SEPARATIONS_LENGHT = SEPARATIONS.length;

          for (var _i6 = 0; _i6 < SEPARATIONS_LENGHT; _i6++) {
            SEPARATIONS[_i6].draw();
          }
        }];

        var render = function render() {
          renderFlag = 1; // gl.clear(COLOR_BUFFER_BIT);

          orbit.update();
          gl.activeTexture(gl.TEXTURE0);

          for (var _i7 = 0; _i7 < TEETH_GUMS_LENGHT; _i7++) {
            TEETH_GUMS[_i7].draw();
          }

          gl.activeTexture(gl.TEXTURE1);
          sepSwitch[drawSep.x * (1 - ~~rot.x)]();
          locSwitch[drawLoc.x]();
          gridSwitch[drawGrid.x]();
          gl.finish();
        };

        var renderFlag = 0;

        var updateTransitions = function updateTransitions() {
          renderFlag = 0;
          CTX.updateTime();
          CTX.updateTransitions();
          requestAnimationFrame(updateTransitions);
        };

        updateTransitions();
        var renderSwitch = [render, BLANK_FUNCTION];
        parent.appendChild(CTX.canvas);

        CTX.clbk = function () {
          renderSwitch[renderFlag]();
        };

        CTX.clbk();
        setFinalCSS(CTX, gl);
      } catch (evt) {
        (catchCallback || function () {
          return 0;
        })(evt, 'main');
      }
    }).catch();
  }).catch();
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! glkit */ "./node_modules/glkit/build/index.js")["WebGL"], __webpack_require__(/*! ./error-callback */ "./src/js/error-callback.js"), __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! glkit */ "./node_modules/glkit/build/index.js")["Loader"], __webpack_require__(/*! ./onprogress */ "./src/js/onprogress.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["prepareResponses"], __webpack_require__(/*! ./cameras */ "./src/js/cameras.js"), __webpack_require__(/*! ./glsl-const */ "./src/js/glsl-const.js")["ROTATION_MATRIX_X"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["hex"], __webpack_require__(/*! ./draw-func */ "./src/js/draw-func.js")["getDrawFunc4Attr"], __webpack_require__(/*! ./draw-func */ "./src/js/draw-func.js")["getDrawFunc2Attr"], __webpack_require__(/*! ./grid */ "./src/js/grid.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["getLayers"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["getTriangles"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["getLayersLocks"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["getTrianglesLocks"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["extArr"], __webpack_require__(/*! ./spheres */ "./src/js/spheres.js"), __webpack_require__(/*! ./glsl-const */ "./src/js/glsl-const.js")["ROTATION_MATRIX_Y"], __webpack_require__(/*! ./lines */ "./src/js/lines.js"), __webpack_require__(/*! ./circles */ "./src/js/circles.js"), __webpack_require__(/*! ./quads */ "./src/js/quads.js"), __webpack_require__(/*! ./slider */ "./src/js/slider.js"), __webpack_require__(/*! ./modes */ "./src/js/modes.js"), __webpack_require__(/*! ./orbit */ "./src/js/orbit.js"), __webpack_require__(/*! ./info */ "./src/js/info.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["setFinalCSS"], __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/modes.js":
/*!*************************!*\
  !*** ./src/js/modes.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, catchCallback) {function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable */
module.exports = function (ORTHO, rot, bezier1, visUpper, visLower, updateProjectionMatrix, drawGrid, CTX, drawLoc, drawSep, drawPly, orbit, rootsMode, upperExists, lowerExists) {
  try {
    var getButton = function getButton(name) {
      return $("a.ortho-nav-mobile-icon.-".concat(name, ", a.ortho-nav-cell.-").concat(name));
    };

    var menu = $('a.ortho-nav-mobile-icon.-menu');
    var both = getButton('both');
    var upper = getButton('upper');
    var lower = getButton('lower');
    var occlusion = getButton('occlusion');
    var allVis = $('a.ortho-nav-cell.-both, a.ortho-nav-cell.-upper, a.ortho-nav-cell.-lower, a.ortho-nav-cell.-occlusion');
    var separations = getButton('separations');
    var locks = getButton('locks');
    var grid = getButton('grid');
    var pdf = getButton('pdf');
    var en = $('.ortho-subnav-cell.-en');
    var ru = $('.ortho-subnav-cell.-ru');
    var plan_bone = getButton('plan_bone');
    var back = getButton('back');
    var transp = getButton('transp');
    var transp_back = getButton('transp_back');
    var navMobile = $('.ortho-nav-mobile');
    var subnavDesk = $('.ortho-subnav');
    var info = $('a.ortho-nav-mobile-icon.-info');
    var orthoInfo = $('.ortho-info');
    var view = 0; // 0: both, 1: occlusion

    var pi05 = Math.PI * 0.5;
    var pi2 = Math.PI * 2; //

    var __ORBIT_PARAMS__ = {};

    window.__GET_ORBIT_ROTATION__ = function () {
      var _orbit$rotation$arr = _slicedToArray(orbit.rotation.arr, 2),
          x = _orbit$rotation$arr[0],
          y = _orbit$rotation$arr[1];

      __ORBIT_PARAMS__.currentY = orbit.currentY;
      __ORBIT_PARAMS__.currentX = orbit.currentX;
      __ORBIT_PARAMS__.endY = orbit.endY;
      __ORBIT_PARAMS__.endX = orbit.endX;
      __ORBIT_PARAMS__.startY = orbit.startY;
      __ORBIT_PARAMS__.startX = orbit.startX;
      console.log("__SET_ORBIT_ROTATION__(".concat(x, ", ").concat(y, ", 1000)"));
    };

    window.__SET_ORBIT_ROTATION__ = function (x, y, duration) {
      orbit.currentY = __ORBIT_PARAMS__.currentY;
      orbit.currentX = __ORBIT_PARAMS__.currentX;
      orbit.endY = __ORBIT_PARAMS__.endY;
      orbit.endX = __ORBIT_PARAMS__.endX;
      orbit.startY = __ORBIT_PARAMS__.startY;
      orbit.startX = __ORBIT_PARAMS__.startX;
      orbit.rotation.setCallbackTransitionWithUniforms({
        func: bezier1,
        to: [x, y],
        duration: duration
      });
    }; //


    var transParams1 = {
      func: bezier1,
      to: [0, 0],
      duration: 1000
    };
    var transParams2 = {
      func: bezier1,
      to: 0,
      duration: 1000
    };
    var transParams3 = {
      func: bezier1,
      to: pi05,
      duration: 1000
    };
    var modeAction = null;

    if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {
      modeAction = function modeAction(active, _view, _visUpper, _visLower, _drawPly, transParams) {
        allVis.removeClass('-active');
        active.addClass('-active');
        $('.ortho-occl').hide();
        view = _view;
        visUpper.x = _visUpper;
        visLower.x = _visLower;
        visUpper.updateUniforms();
        visLower.updateUniforms();

        if (window.__VIEWER_TYPE__ === 'ply') {
          drawPly.x = _drawPly;
        }

        rot.setCallbackTransitionWithUniforms(transParams);
      };
    } else {
      modeAction = function modeAction(active, _view, _visUpper, _visLower, _drawPly, transParams) {
        allVis.removeClass('-active');
        active.addClass('-active');
        view = _view;
        visUpper.x = _visUpper;
        visLower.x = _visLower;
        visUpper.updateUniforms();
        visLower.updateUniforms();

        if (window.__VIEWER_TYPE__ === 'ply') {
          drawPly.x = _drawPly;
        }

        rot.setCallbackTransitionWithUniforms(transParams);
      };
    }

    var bothActions = [function () {
      var arr = orbit.rotation.arr;

      if (arr[0] !== 0 || arr[1] !== 0) {
        orbit.currentY = 0;
        orbit.currentX = 0;
        orbit.endY = 0;
        orbit.endX = 0;
        orbit.startY = 0;
        orbit.startX = 0;
        arr[0] -= Math.round(arr[0] / pi2) * pi2;
        arr[1] -= Math.round(arr[1] / pi2) * pi2;
        orbit.rotation.setCallbackTransitionWithUniforms(transParams1);
      } else {
        var startY = orbit.translation.y;
        var startX = orbit.translation.x;
        transInterp.x = 0;
        transInterp.setExtendedTransition({
          func: bezier1,
          to: 1,
          duration: 500,
          onProgress: function onProgress() {
            var interp = bezier1(transInterp.transitionInterpolation);
            orbit.translation.y = startY + interp * (0 - startY);
            orbit.translation.x = startX + interp * (0 - startX);
            CTX.clbk();
          },
          onEnd: function onEnd() {
            orbit.translation.y = 0;
            orbit.translation.x = 0;
            CTX.clbk();
          }
        });
      }
    }, function () {
      return modeAction(both, 0, 1, 1, 0, transParams2);
    }];
    menu.on('click', function () {
      return navMobile.toggleClass('-visible');
    });

    window.__VIEW_BOTH__ = function () {
      return bothActions[view]();
    };

    both.on('click', window.__VIEW_BOTH__);
    var transInterp = new CTX.DataFloat1(); // console.log(transInterp);

    window.__VIEW_BOTH_2__ = function () {
      // orbit.mouseTransX = 0;
      // orbit.mouseTransY = 0;
      // orbit.mousePrevTransX = 0;
      // orbit.mousePrevTransY = 0;
      // orbit.translation.y = 0;
      // orbit.translation.x = 0;
      // CTX.clbk();
      window.__VIEW_BOTH__();

      var startY = orbit.translation.y;
      var startX = orbit.translation.x;
      transInterp.x = 0;
      transInterp.setExtendedTransition({
        func: bezier1,
        to: 1,
        duration: 500,
        onProgress: function onProgress() {
          var interp = bezier1(transInterp.transitionInterpolation);
          orbit.translation.y = startY + interp * (0 - startY);
          orbit.translation.x = startX + interp * (0 - startX);
          CTX.clbk();
        },
        onEnd: function onEnd() {
          orbit.translation.y = 0;
          orbit.translation.x = 0;
          CTX.clbk();
        }
      });
    };

    both.on('dblclick', window.__VIEW_BOTH_2__);

    window.__VIEW_UPPER__ = function () {
      return modeAction(upper, 1, 1, 0, 0, transParams2);
    };

    upper.on('click', window.__VIEW_UPPER__);

    window.__VIEW_LOWER__ = function () {
      return modeAction(lower, 1, 0, 1, 0, transParams2);
    };

    lower.on('click', window.__VIEW_LOWER__);

    if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {
      if (Boolean(upperExists && lowerExists)) {
        window.__OCCLUSION__ = function () {
          modeAction(occlusion, 1, 1, 1, 1, transParams3);
          $('.ortho-occl').show();
        };

        occlusion.on('click', window.__OCCLUSION__);
      } else {
        occlusion.remove();
      }
    } else {
      occlusion.remove();
    }

    if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {
      window.__VIEW_IPR__ = function () {
        separations.toggleClass('-active');
        drawSep.x = 1 - drawSep.x;
        CTX.clbk();
      };

      separations.on('click', window.__VIEW_IPR__);

      window.__VIEW_ATTACHMENTS__ = function () {
        locks.toggleClass('-active');
        drawLoc.x = 1 - drawLoc.x;
        CTX.clbk();
      };

      locks.on('click', window.__VIEW_ATTACHMENTS__);
    } else {
      var lockParent = $(locks[1]).parent();
      lockParent.next().remove();
      lockParent.remove();
      locks.remove();
      separations.remove();
    }

    window.__VIEW_GRID__ = function () {
      grid.toggleClass('-active');
      updateProjectionMatrix[drawGrid.x = 1 - drawGrid.x]();
      orbit.camera.projectionMatrix.updateUniforms();
      CTX.clbk();
    };

    grid.on('click', window.__VIEW_GRID__);

    if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {
      if (false) {} else if (true) {
        subnavDesk.on('click', function () {
          return subnavDesk.hide();
        });
        en.on('click', function () {
          return window.open(ORTHO.pdf.en);
        });
        ru.on('click', function () {
          return window.open(ORTHO.pdf.ru);
        });
        pdf.on('click', function () {
          subnavDesk.toggle();
          pdf.toggleClass('-active');
        });
      }
    } else {
      subnavDesk.remove();
      en.remove();
      ru.remove();
      pdf.remove();
    }

    if ((window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') && "3d-api-simple-frontend" === '3d-plan' && ORTHO.roots) {
      plan_bone.on('click', function () {
        return window.open(ORTHO.roots_link);
      });
    } else {
      plan_bone.remove();
    }

    if (window.__VIEWER_TYPE__ === 'roots' && "3d-api-simple-frontend" === '3d-plan' && ORTHO.master) {
      back.on('click', function () {
        return window.open(ORTHO.master_link);
      });
    } else {
      back.remove();
    }

    if (window.__VIEWER_TYPE__ === 'roots' || window.__VIEWER_TYPE__ === 'deepct') {
      var transpSwitch = {
        0.6: 1,
        1: 0.6
      };
      transp_back.hide();

      window.__VIEW_TRANSPARENT_ON__ = function () {
        transp.hide();
        transp_back.show();
        $('.ortho-dist').show();
        rootsMode.x = transpSwitch[rootsMode.x];
        rootsMode.updateUniforms();
        CTX.clbk();
      };

      transp.on('click', window.__VIEW_TRANSPARENT_ON__);

      window.__VIEW_TRANSPARENT_OFF__ = function () {
        transp_back.hide();
        transp.show();
        $('.ortho-dist').hide();
        rootsMode.x = transpSwitch[rootsMode.x];
        rootsMode.updateUniforms();
        CTX.clbk();
      };

      transp_back.on('click', window.__VIEW_TRANSPARENT_OFF__);
    } else {
      transp.remove();
      transp_back.remove();
    } // ???
    // orthoInfo.on('click', (evt) => {
    //   if (evt.target.tagName.toLowerCase() !== 'a') {
    //     orthoInfo.removeClass('-visible');
    //   } else {
    //     window.location = evt.target.href;
    //   }
    // });


    info.on('click', function () {
      return orthoInfo.addClass('-visible');
    });

    if (window.__VIEWER_TYPE__ === 'deepct') {
      $('.ortho-controls').remove();
    }

    if (window.__VIEWER_TYPE__ !== 'main') {
      $('.ortho-occl').remove();
    } else {
      $('.ortho-occl').hide();

      if (true) {
        $('.ortho-occl-ru').remove();
      } else {}
    }

    if (window.__VIEWER_TYPE__ !== 'roots' && window.__VIEWER_TYPE__ !== 'deepct') {
      $('.ortho-dist').remove();
    } else {
      $('.ortho-dist').hide();

      if (true) {
        $('.ortho-dist-ru').remove();
      } else {}
    }

    if (!Boolean(upperExists)) {
      $('.ortho-controls-current.-up').remove();
    }

    if (!Boolean(lowerExists)) {
      $('.ortho-controls-current.-down').remove();
    }
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'modes');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/onprogress.js":
/*!******************************!*\
  !*** ./src/js/onprogress.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = function () {
  var orthoLoaderCircle = $('.ortho-loader').find('circle');
  var orthoPerc = $('.ortho-perc');
  return function () {
    var prog = this.loaded / this.length;
    orthoLoaderCircle.css({
      "stroke-dasharray": "".concat(prog * 280, ", 1000")
    });
    orthoPerc.html("".concat(Math.floor(prog * 100), "%"));
  };
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./src/js/orbit.js":
/*!*************************!*\
  !*** ./src/js/orbit.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, catchCallback) {var bowser = __webpack_require__(/*! bowser */ "./node_modules/bowser/src/bowser.js");

var ISMOBILE = bowser.mobile || bowser.tablet;
var touchPoints = [];
var canMove = false;

module.exports = function (orbit, gl, zoom, CTX, updateProjectionMatrix, drawGrid, slider) {
  try {
    var sliderControls = slider ? slider.controls : null;
    var bezier2 = CTX.math.BezierCubicCurve(0.25, 1, 1, 1);
    var touchState = 0;
    var touchPrevRotX = 0;
    var touchPrevRotY = 0;
    var touchRotX = 0;
    var touchRotY = 0;
    var touchPrevL = 0;
    var touchCurrL = 0;
    var touchPrevTransX = 0;
    var touchPrevTransY = 0;
    var touchTransX = 0;
    var touchTransY = 0;
    orbit.mousePrevTransX = 0;
    orbit.mousePrevTransY = 0;
    orbit.mouseTransX = 0;
    orbit.mouseTransY = 0;
    var mouseBtn = 0;

    var updateZoom = function updateZoom() {
      if (zoom.x < 0.25) {
        zoom.x = 0.25;
      } else if (zoom.x > 1.5) {
        zoom.x = 1.5;
      }

      if (slider) {
        if (zoom.x < 0.5) {
          sliderControls.hide();
        } else {
          sliderControls.show();
        }
      }

      zoom.updateUniforms();
      CTX.clbk();
    };

    window.addEventListener('wheel', function (e) {
      var isScrollable = !!e.target.closest(".non_scrollable");

      if (!isScrollable) {
        zoom.x += Math.sign(e.deltaY || e.detail || e.wheelDelta) * 0.1;
        updateZoom();
      }
    }, false);
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        zoom.x += (e.keyCode - 39) * 0.1;
        updateZoom();
      }
    }, false);
    var mouseMoveTo = [];

    window.__GET_ORBIT_TRANSLATION__ = function () {
      return console.log("__SET_ORBIT_TRANSLATION__(".concat(orbit.translation.x, ", ").concat(orbit.translation.y, ")"));
    };

    window.__SET_ORBIT_TRANSLATION__ = function (x, y) {
      orbit.translation.x = x;
      orbit.translation.y = y;
      CTX.clbk();
    };

    var orbitMouseMove = [function (e) {
      orbit.currentX = e.clientY - orbit.startX;
      orbit.currentY = e.clientX - orbit.startY;
      mouseMoveTo[0] = (orbit.endX + orbit.currentX) * 0.0025;
      mouseMoveTo[1] = (orbit.endY + orbit.currentY) * 0.0025;
      orbit.rotation.setCallbackTransitionWithUniforms({
        func: bezier2,
        to: mouseMoveTo,
        duration: 300
      });
    }, function (e) {
      orbit.mouseTransX = (e.clientY - orbit.mousePrevTransX) * 0.005;
      orbit.mouseTransY = (e.clientX - orbit.mousePrevTransY) * 0.005;
      orbit.mousePrevTransX = e.clientY;
      orbit.mousePrevTransY = e.clientX;
      orbit.translation.y += orbit.mouseTransX * 26.76;
      orbit.translation.x -= orbit.mouseTransY * 26.76;
      CTX.clbk();
    }];

    orbit.mousemove = function (e) {
      orbitMouseMove[mouseBtn](e);
    };

    var orbitMouseDown = [function (e) {
      mouseBtn = 0;
      orbit.startX = e.clientY;
      orbit.startY = e.clientX;
      orbit.currentX = e.clientY - orbit.startX;
      orbit.currentY = e.clientX - orbit.startY;
      mouseMoveTo[0] = (orbit.endX + orbit.currentX) * 0.0025;
      mouseMoveTo[1] = (orbit.endY + orbit.currentY) * 0.0025;
      orbit.rotation[0] = mouseMoveTo[0];
      orbit.rotation[1] = mouseMoveTo[1];
      $(window).on('mousemove', orbit.mousemove);
    }, function (e) {
      mouseBtn = 0;
      orbit.startX = e.clientY;
      orbit.startY = e.clientX;
      orbit.currentX = e.clientY - orbit.startX;
      orbit.currentY = e.clientX - orbit.startY;
      mouseMoveTo[0] = (orbit.endX + orbit.currentX) * 0.0025;
      mouseMoveTo[1] = (orbit.endY + orbit.currentY) * 0.0025;
      orbit.rotation[0] = mouseMoveTo[0];
      orbit.rotation[1] = mouseMoveTo[1];
      $(window).on('mousemove', orbit.mousemove);
    }, function (e) {
      mouseBtn = 1;
      orbit.mousePrevTransX = e.clientY;
      orbit.mousePrevTransY = e.clientX;
      $(window).on('mousemove', orbit.mousemove);
    }, function (e) {
      mouseBtn = 1;
      orbit.mousePrevTransX = e.clientY;
      orbit.mousePrevTransY = e.clientX;
      $(window).on('mousemove', orbit.mousemove);
    }];

    orbit.mousedown = function (e) {
      // e.preventDefault();
      if (e.target === gl.canvas) {
        canMove = true;
        orbitMouseDown[e[e.which ? 'which' : 'button']](e);
      } else {
        canMove = false;
      }
    };

    $(window).on('mousedown', orbit.mousedown);
    var orbitMouseUp = [function (e) {
      orbit.endY += orbit.currentY;
      orbit.endX += orbit.currentX;
    }, function () {}];

    orbit.mouseup = function () {
      if (canMove) {
        orbitMouseUp[mouseBtn]();
      }

      $(window).off('mousemove', orbit.mousemove);
    };

    $(window).on('mouseup', orbit.mouseup);
    var orbitTouchMove = [function () {}, function (e) {
      var t = e.touches;

      if (t[0].clientY < window.innerHeight - 80) {
        touchRotX = (t[0].clientY - touchPrevRotX) * 0.005;
        touchRotY = (t[0].clientX - touchPrevRotY) * 0.005;
        touchPrevRotX = t[0].clientY;
        touchPrevRotY = t[0].clientX;
        orbit.rotation.arr[0] += touchRotX;
        orbit.rotation.arr[1] += touchRotY;
        orbit.rotation.updateUniforms();
        CTX.clbk();
      }
    }, function (e) {
      var t = e.touches;

      if (t[0].clientY < window.innerHeight - 80 && t[1].clientY < window.innerHeight - 80) {
        var x1x0 = t[1].clientX - t[0].clientX;
        x1x0 *= x1x0;
        var y1y0 = t[1].clientY - t[0].clientY;
        y1y0 *= y1y0;
        touchCurrL = Math.sqrt(x1x0 + y1y0);
        zoom.x -= (touchCurrL - touchPrevL) * 0.001;
        touchPrevL = touchCurrL;
        updateZoom();
      }
    }, function (e) {
      var t = e.touches;

      if (t[0].clientY < window.innerHeight - 80 && t[1].clientY < window.innerHeight - 80 && t[2].clientY < window.innerHeight - 80) {
        touchTransX = (t[1].clientY - touchPrevTransX) * 0.005;
        touchTransY = (t[1].clientX - touchPrevTransY) * 0.005;
        touchPrevTransX = t[1].clientY;
        touchPrevTransY = t[1].clientX;
        orbit.translation.y += touchTransX * 20;
        orbit.translation.x -= touchTransY * 20;
        CTX.clbk();
      }
    }];

    orbit.touchmove = function (e) {
      e.preventDefault();

      if (slider && !slider.isMoving || !slider) {
        orbitTouchMove[touchState](e);
      }
    };

    var orbitTouchStart = [function () {}, function (e) {
      var t = e.touches;
      touchPrevRotX = t[0].clientY;
      touchPrevRotY = t[0].clientX;
    }, function (e) {
      var t = e.touches;
      touchPoints = [[t[0].clientX, t[0].clientY], [t[1].clientX, t[1].clientY]];
      var x1x0 = touchPoints[1][0] - touchPoints[0][0];
      x1x0 *= x1x0;
      var y1y0 = touchPoints[1][1] - touchPoints[0][1];
      y1y0 *= y1y0;
      touchCurrL = touchPrevL = Math.sqrt(x1x0 + y1y0);
    }, function (e) {
      var t = e.touches;
      touchPrevTransX = t[1].clientY;
      touchPrevTransY = t[1].clientX;
    }];

    orbit.touchstart = function (e) {
      e.preventDefault();
      touchState = e.touches.length;
      orbitTouchStart[touchState](e);
    };

    orbit.touchend = function (e) {
      e.preventDefault();
      touchState = 0;

      if (slider) {
        slider.isMoving = false;
      }
    };

    $(gl.canvas).on('touchstart', orbit.touchstart).on('touchend', orbit.touchend).on('touchmove', orbit.touchmove);
    $(window).on('contextmenu', function (e) {
      e.preventDefault();
    });

    if (ISMOBILE) {
      var orientationChanged = false; // if (document.body.offsetWidth > document.body.offsetHeight && sliderControls) {
      //   sliderControls.hide();
      // } else if (sliderControls) {

      if (sliderControls) {
        sliderControls.show();
      } // }


      $(window).on('resize', function () {
        if (orientationChanged) {
          orientationChanged = false;

          if (document.body.offsetWidth > document.body.offsetHeight && sliderControls) {
            sliderControls.hide();
          } else if (zoom.x >= 0.5 && sliderControls) {
            sliderControls.show();
          }

          CTX.setSize(0, 0, document.body.offsetWidth, document.body.offsetHeight);
          updateProjectionMatrix[drawGrid.x]();
          orbit.camera.projectionMatrix.updateUniforms();

          if (slider) {
            slider.left = slider.currStep / slider.steps * slider.parent.offsetWidth;
            slider.style.left = "".concat(slider.left, "px");
            slider.mouseupX = Math.round(slider.left / slider.parent.offsetWidth * slider.steps) * slider.parent.offsetWidth / slider.steps;
          }

          CTX.clbk();
        }
      });
      $(window).on('orientationchange', function () {
        orientationChanged = true;
      });
    } else {
      window.addEventListener('resize', function () {
        CTX.setSize(0, 0, document.body.offsetWidth, document.body.offsetHeight);
        updateProjectionMatrix[drawGrid.x]();
        orbit.camera.projectionMatrix.updateUniforms();

        if (slider) {
          slider.left = slider.currStep / slider.steps * slider.parent.offsetWidth;
          slider.style.left = "".concat(slider.left, "px");
          slider.mouseupX = Math.round(slider.left / slider.parent.offsetWidth * slider.steps) * slider.parent.offsetWidth / slider.steps;
        }

        CTX.clbk();
      }, false);
    }
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'orbit');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/quads.js":
/*!*************************!*\
  !*** ./src/js/quads.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(generateTexture, catchCallback) {module.exports = function (CTX, gl, uProjMat, uViewMat, uVisLower, uuIndex, uZoom, uVisUpper, uRotXY, sep, SEPARATIONS, values, ROTATION_MATRIX_X, ROTATION_MATRIX_Y) {
  try {
    var TRIANGLES = gl.TRIANGLES,
        UNSIGNED_SHORT = gl.UNSIGNED_SHORT;

    if (values.length) {
      generateTexture(values, function (image) {
        var quads = function () {
          var n = -1;
          var position = [];
          var indices = [];
          var indexes = [];
          var origin = [];
          var tIndexes = [];
          var location = [];
          var uv = [];
          var size = 64 / 40;
          var parse = window.__VIEWER_TYPE__ === 'main' ? function (stage, k, dir, loc) {
            n++;
            tIndexes.push(n, n, n, n);
            var a = stage.centroid[stage.separation[k].a];
            var b = stage.centroid[stage.separation[k].b];
            var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
            var ab = new CTX.DataFloat3({
              x: a[0] - b[0],
              y: a[1] - b[1],
              z: a[2] - b[2]
            });
            ab.normalize();
            var cd = [ab.z, 0, ab.x];
            var d0 = new CTX.DataFloat3({
              x: c[0] - cd[0] * 30,
              y: c[1] + dir * 20,
              z: c[2] + cd[2] * 30
            });
            var d1 = new CTX.DataFloat3({
              x: c[0] + cd[0] * 30,
              y: c[1] + dir * 20,
              z: c[2] - cd[2] * 30
            });
            var d = d0;

            if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
              d = d1;
            }

            indexes.push(stage.model[0].from, stage.model[0].from, stage.model[0].from, stage.model[0].from);
            origin.push(d.x, d.y, d.z, d.x, d.y, d.z, d.x, d.y, d.z, d.x, d.y, d.z);
            uv.push(0, 1, 0, 0, 1, 0, 1, 1);
            position.push(d.x - size * 2, d.y - size, d.z, d.x - size * 2, d.y + size, d.z, d.x + size * 2, d.y + size, d.z, d.x + size * 2, d.y - size, d.z);
            indices.push(0 + 4 * n, 1 + 4 * n, 2 + 4 * n, 0 + 4 * n, 3 + 4 * n, 2 + 4 * n);
            location.push(loc, loc, loc, loc);
          } : function (stage, k, dir, loc) {
            n++;
            tIndexes.push(n, n, n, n);
            var a = stage.centroid[stage.separation[k].a];
            var b = stage.centroid[stage.separation[k].b];
            var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
            var ab = new CTX.DataFloat3({
              x: a[0] - b[0],
              y: a[1] - b[1],
              z: a[2] - b[2]
            });
            ab.normalize();
            var cd = [ab.z, 0, ab.x];
            var d0 = new CTX.DataFloat3({
              x: c[0] - cd[0] * 30,
              y: c[1] + dir * 20,
              z: c[2] + cd[2] * 30
            });
            var d1 = new CTX.DataFloat3({
              x: c[0] + cd[0] * 30,
              y: c[1] + dir * 20,
              z: c[2] - cd[2] * 30
            });
            var d = d0;

            if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
              d = d1;
            }

            indexes.push(stage.model[0] - 1, stage.model[0] - 1, stage.model[0] - 1, stage.model[0] - 1);
            origin.push(d.x, d.y, d.z, d.x, d.y, d.z, d.x, d.y, d.z, d.x, d.y, d.z);
            uv.push(0, 1, 0, 0, 1, 0, 1, 1);
            position.push(d.x - size * 2, d.y - size, d.z, d.x - size * 2, d.y + size, d.z, d.x + size * 2, d.y + size, d.z, d.x + size * 2, d.y - size, d.z);
            indices.push(0 + 4 * n, 1 + 4 * n, 2 + 4 * n, 0 + 4 * n, 3 + 4 * n, 2 + 4 * n);
            location.push(loc, loc, loc, loc);
          };

          for (var i in sep.upper) {
            if (sep.upper[i].separation && Object.keys(sep.upper[i].separation).length) {
              for (var k in sep.upper[i].separation) {
                parse(sep.upper[i], k, 1, 1);
              }
            }
          }

          for (var _i in sep.lower) {
            if (sep.lower[_i].separation && Object.keys(sep.lower[_i].separation).length) {
              for (var _k in sep.lower[_i].separation) {
                parse(sep.lower[_i], _k, -1, 0);
              }
            }
          }

          var vCount = (n + 1) * 6;
          var material = new CTX.Material({
            VS: function VS() {
              return "\n                precision ".concat(CTX.maxPrecision.vs.float, " float;\n                ").concat(uProjMat.uniform(this), "\n                ").concat(uViewMat.uniform(this), "\n                ").concat(uRotXY.uniform(this), "\n                ").concat(uZoom.uniform(this), "\n                ").concat(uuIndex.uniform(this), "\n                ").concat(uVisUpper.uniform(this), "\n                ").concat(uVisLower.uniform(this), "\n                attribute vec3 position;\n                attribute vec3 origin;\n                attribute float index;\n                attribute vec2 uv;\n                attribute float tIndex;\n                attribute float location;\n                varying vec2 vUv;\n                ").concat(ROTATION_MATRIX_X, "\n                ").concat(ROTATION_MATRIX_Y, "\n                void main() {\n                  vUv = vec2(uv.x, uv.y / ").concat(values.length, ". + tIndex / ").concat(values.length, ".);\n                  mat4 rot = rotationMatrixY(orbitRotation.y) * rotationMatrixX(orbitRotation.x);\n                  vec4 pos = rot * vec4(position - origin, zoom);\n                  pos.xyz += origin + (rot * vec4(- 4., 2.6, 0., 1.)).xyz;\n                  gl_Position = projectionMatrix * viewMatrix * pos * (1. - abs(uIndex - index)) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n                }\n              ");
            },
            FS: function FS() {
              return "\n                precision ".concat(CTX.maxPrecision.fs.float, " float;\n                ").concat(new CTX.Texture2D({
                name: 'LABEL',
                image: image,
                min: gl.LINEAR_MIPMAP_LINEAR,
                unit: 1
              }).uniform(this), "\n                varying vec2 vUv;\n                void main() {\n                  gl_FragColor = texture2D(LABEL, vUv);\n                  gl_FragColor.w = 1.0;\n                }\n              ");
            }
          });

          if (position.length) {
            var program = material.program;
            var positionBuf = new CTX.VBO({
              content: new Float32Array(position),
              name: 'position',
              location: 0
            });
            var originBuf = new CTX.VBO({
              content: new Float32Array(origin),
              name: 'origin',
              location: 1
            });
            var indexBuf = new CTX.VBO({
              content: new Float32Array(indexes),
              name: 'index',
              size: 1,
              location: 2
            });
            var uvBuf = new CTX.VBO({
              content: new Float32Array(uv),
              name: 'uv',
              size: 2,
              location: 3
            });
            var tIndexBuf = new CTX.VBO({
              content: new Float32Array(tIndexes),
              name: 'tIndex',
              size: 1,
              location: 4
            });
            var locationBuf = new CTX.VBO({
              content: new Float32Array(location),
              name: 'location',
              size: 1,
              location: 5
            });
            var ibo = new CTX.IBO({
              content: new Uint16Array(indices)
            });
            var obj = new CTX.Obj({
              draw: function draw() {
                gl.useProgram(program);
                positionBuf.enable();
                originBuf.enable();
                indexBuf.enable();
                uvBuf.enable();
                tIndexBuf.enable();
                locationBuf.enable();
                ibo.enable();
                gl.drawElements(TRIANGLES, vCount, UNSIGNED_SHORT, 0);
              }
            });
            SEPARATIONS.push(obj);
          }
        }();

        CTX.clbk();
      });
    }
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'quads');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./texgen */ "./src/js/texgen.js"), __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/roots.js":
/*!*************************!*\
  !*** ./src/js/roots.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(WebGL, errorCallback, $, Loader, progressCallback, prepareResponses, getCameras, getDrawFunc4Attr, getDrawFunc2Attr, getGrid, getLayers, getTriangles, extArr, getSlider, getModes, getOrbit, getInfo, setFinalCSS, catchCallback) {var bowser = __webpack_require__(/*! bowser */ "./node_modules/bowser/src/bowser.js");

var correct_color = bowser.safari || bowser.ipad || bowser.iphone;

module.exports = function (ORTHO) {
  var __style = document.createElement('style');

  __style.innerHTML = 'iframe#launcher {display: none !important;}';
  document.getElementsByTagName('head')[0].appendChild(__style);
  var CTX = new WebGL({
    errorCallback: errorCallback,
    alpha: true
  });
  var parent = $('.ortho-gl-container')[0];
  $('.ortho-nowebgl').hide();
  var prefix = ORTHO.source_stage_folder;
  var loader = new Loader();
  loader.load({
    sources: {
      list: ( true ? ORTHO.json['case_roots.json'] : undefined) + "?".concat(Date.now())
    }
  }).then(function (responses) {
    var CASE = JSON.parse(responses.list);

    if (true) {
      CASE.files = Object.values(ORTHO.json);
    }

    var files = {};
    var i = CASE.files.length;

    if (true) {
      while (i--) {
        files[CASE.files[i]] = {
          source: CASE.files[i] + "?".concat(Date.now()),
          type: 'arraybuffer'
        };
      }
    } else {}

    loader.load({
      sources: files,
      progress: progressCallback()
    }).then(function (responses) {
      try {
        var gl = CTX.WebGLRenderingContext;
        var TRIANGLES = gl.TRIANGLES,
            UNSIGNED_SHORT = gl.UNSIGNED_SHORT,
            UNSIGNED_INT = gl.UNSIGNED_INT,
            COLOR_BUFFER_BIT = gl.COLOR_BUFFER_BIT,
            BLEND = gl.BLEND;
        var GLUINT = gl.getExtension('OES_element_index_uint');
        responses = prepareResponses(responses);
        CTX.setSize(0, 0, parent.offsetWidth, parent.offsetHeight);
        gl.clearColor(1, 1, 1, 1);
        gl.clear(COLOR_BUFFER_BIT);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LESS);
        gl.enable(BLEND);
        gl.enable(gl.CULL_FACE);
        gl.cullFace(gl.BACK);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        gl.getExtension('OES_standard_derivatives') || gl.getExtension('MOZ_OES_standard_derivatives') || gl.getExtension('WEBKIT_OES_standard_derivatives'); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var bezier1 = CTX.math.BezierCubicCurve(0.25, 0, 0, 1);
        var ROOTS = [];
        var rootsMode = new CTX.DataFloat1({
          x: 0.6,
          name: 'rootsMode'
        });
        var timeline = [new CTX.DataFloat1(), new CTX.DataFloat1()];
        var timelineJaw = [new CTX.DataFloat1(), new CTX.DataFloat1()];
        var visUpper = new CTX.DataFloat1({
          name: 'visUpper',
          x: 1
        });
        var visLower = new CTX.DataFloat1({
          name: 'visLower',
          x: 1
        });
        var rot = new CTX.DataFloat1({
          name: 'rot'
        });
        var zoom = new CTX.DataFloat1({
          name: 'zoom',
          x: 1
        });
        var uIndex = new CTX.DataFloat1({
          name: 'uIndex'
        });
        var drawGrid = {
          x: 0
        }; // roots

        var upperSrcLayers = CASE.upper.keys.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        }); // jaw, backward compatibility check

        var upperSrcLayersJaw = CASE.upper.keysJaw ? CASE.upper.keysJaw.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        }) : upperSrcLayers;
        var upperSrcSepRoots = CASE.upper.separationsRoots;
        var upperSrcSepJaw = CASE.upper.separationsJaw;
        var lowerSrcLayers = CASE.lower.keys.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        });
        var lowerSrcLayersJaw = CASE.lower.keysJaw ? CASE.lower.keysJaw.map(function (elm, i, arr) {
          return i % 2 !== 0 && arr[i - 1] === elm && arr[i + 1] ? elm + 1 : elm;
        }) : lowerSrcLayers;
        var lowerSrcSepRoots = CASE.lower.separationsRoots;
        var lowerSrcSepJaw = CASE.lower.separationsJaw; // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var _getCameras = getCameras(CTX, parent),
            orbit = _getCameras.orbit,
            updateProjectionMatrix = _getCameras.updateProjectionMatrix;

        updateProjectionMatrix[drawGrid.x](); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var upperInterp = new CTX.DataFloat1();
        var lowerInterp = new CTX.DataFloat1();
        var upperInterpFract = new CTX.DataFloat1({
          name: 'interp'
        });
        var lowerInterpFract = new CTX.DataFloat1({
          name: 'interp'
        });
        var upperInterpJaw = new CTX.DataFloat1();
        var lowerInterpJaw = new CTX.DataFloat1();
        var upperInterpFractJaw = new CTX.DataFloat1({
          name: 'interp'
        });
        var lowerInterpFractJaw = new CTX.DataFloat1({
          name: 'interp'
        });
        var _orbit$camera = orbit.camera,
            projectionMatrix = _orbit$camera.projectionMatrix,
            viewMatrix = _orbit$camera.viewMatrix,
            position = _orbit$camera.position;

        var getMaterial = function getMaterial(vis, interpFract, jaw) {
          return new CTX.Material({
            VS: function VS() {
              return "\n                  precision ".concat(CTX.maxPrecision.vs.float, " float;\n                  ").concat(projectionMatrix.uniform(this), "\n                  ").concat(viewMatrix.uniform(this), "\n                  ").concat(interpFract.uniform(this), "\n                  ").concat(zoom.uniform(this), "\n                  ").concat(vis.uniform(this), "\n                  ").concat(position.uniform(this), "\n                  attribute vec3 aStartPosition;\n                  attribute vec3 aEndPosition;\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  ").concat(jaw ? "\n                  attribute vec3 aStartColor;\n                  attribute vec3 aEndColor;\n                  varying vec3 vColor;\n                  " : '', "\n                  void main() {\n                    vPosition = vec4(mix(aStartPosition, aEndPosition, interp), zoom);\n                    lightDir = normalize(cameraPosition - vPosition.xyz);\n                    gl_Position = projectionMatrix * viewMatrix * vPosition * ").concat(vis.name, ";\n                    ").concat(jaw ? 'vColor = mix(aStartColor, aEndColor, interp);' : '', "\n                  }\n                ");
            },
            FS: function FS() {
              return "\n                  #extension GL_OES_standard_derivatives: enable\n                  precision ".concat(CTX.maxPrecision.fs.float, " float;\n                  varying vec4 vPosition;\n                  varying vec3 lightDir;\n                  ").concat(jaw ? rootsMode.uniform(this) : '', "\n                  ").concat(jaw ? 'varying vec3 vColor;' : '', "\n                  void main() {\n                    float diffuse = dot(normalize(cross(dFdx(vPosition.xyz), dFdy(vPosition.xyz))), lightDir) + .125;\n                    ").concat(jaw ? " vec3 col = mix(".concat(correct_color ? 'mix(vec3(.506, .51, .447), vec3(0.0), 0.5)' : 'vec3(.506, .51, .447)', ", vColor, (rootsMode - .6) * 2.5) * diffuse;") : '', "\n                    gl_FragColor = vec4(").concat(jaw ? 'col, rootsMode' : 'vec3(diffuse), 1.0', ");\n                  }\n                ");
            }
          });
        };

        var getObjectColor = function getObjectColor(item, material, interp) {
          return new CTX.Obj({
            draw: getDrawFunc4Attr(material, item, interp, item.colors, interp, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT)
          });
        };

        var getObject = function getObject(item, material, interp) {
          return new CTX.Obj({
            draw: getDrawFunc2Attr(material, item, interp, GLUINT, CTX, gl, TRIANGLES, UNSIGNED_SHORT, UNSIGNED_INT)
          });
        }; // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////


        var grid = getGrid(CTX, gl, orbit.camera.projectionMatrix, zoom); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var parse4 = function parse4(param) {
          var i = 0;

          for (; i < param.length; i++) {
            if (param[i] === param[i + 1] && param[i + 1] === param[i + 2] && param[i + 2] === param[i + 3] && param[i - 1] + 1) {
              if (param[i + 4] + 1) {
                param.splice(i, 4, param[i - 1], param[i]);
                break;
              } else {
                param.pop();
              }
            }
          }

          if (i < param.length) {
            parse4(param);
          }
        };

        var upperLayersRoots = getLayers(upperSrcLayers, upperSrcSepRoots);
        parse4(upperLayersRoots);
        var upperTrianglesRoots = getTriangles(upperLayersRoots, upperSrcSepRoots);
        var upperLayersJaw = getLayers(upperSrcLayersJaw, upperSrcSepJaw);
        parse4(upperLayersJaw);
        var upperTrianglesJaw = getTriangles(upperLayersJaw, upperSrcSepJaw);
        var upperLayersRootsExt = extArr(upperLayersRoots);
        var upperTrianglesRootsExt = extArr(upperTrianglesRoots);
        var upperLayersJawExt = extArr(upperLayersJaw);
        var upperTrianglesJawExt = extArr(upperTrianglesJaw);
        var lowerLayersRoots = getLayers(lowerSrcLayers, lowerSrcSepRoots);
        parse4(lowerLayersRoots);
        var lowerTrianglesRoots = getTriangles(lowerLayersRoots, lowerSrcSepRoots);
        var lowerLayersJaw = getLayers(lowerSrcLayersJaw, lowerSrcSepJaw);
        parse4(lowerLayersJaw);
        var lowerTrianglesJaw = getTriangles(lowerLayersJaw, lowerSrcSepJaw);
        var lowerLayersRootsExt = extArr(lowerLayersRoots);
        var lowerTrianglesRootsExt = extArr(lowerTrianglesRoots);
        var lowerLayersJawExt = extArr(lowerLayersJaw);
        var lowerTrianglesJawExt = extArr(lowerTrianglesJaw);
        ROOTS.push(getObject({
          triangles: upperTrianglesRootsExt.map(function (elm) {
            return responses["upper_roots_teeth_t_".concat(elm, ".b")];
          }),
          vertices: upperLayersRootsExt.map(function (elm) {
            return responses["upper_roots_teeth_k_".concat(elm, ".b")];
          })
        }, getMaterial(visUpper, upperInterpFract, false), upperInterp));
        ROOTS.push(getObject({
          triangles: lowerTrianglesRootsExt.map(function (elm) {
            return responses["lower_roots_teeth_t_".concat(elm, ".b")];
          }),
          vertices: lowerLayersRootsExt.map(function (elm) {
            return responses["lower_roots_teeth_k_".concat(elm, ".b")];
          })
        }, getMaterial(visLower, lowerInterpFract, false), lowerInterp));
        ROOTS.push(getObjectColor({
          triangles: upperTrianglesJawExt.map(function (elm) {
            return responses["upper_roots_jaw_t_".concat(elm, ".b")];
          }),
          vertices: upperLayersJawExt.map(function (elm) {
            return responses["upper_roots_jaw_k_".concat(elm, ".b")];
          }),
          colors: upperLayersJawExt.map(function (elm) {
            return responses["upper_roots_jaw_c_".concat(elm, ".b")];
          })
        }, getMaterial(visUpper, upperInterpFractJaw, true), upperInterpJaw));
        ROOTS.push(getObjectColor({
          triangles: lowerTrianglesJawExt.map(function (elm) {
            return responses["lower_roots_jaw_t_".concat(elm, ".b")];
          }),
          vertices: lowerLayersJawExt.map(function (elm) {
            return responses["lower_roots_jaw_k_".concat(elm, ".b")];
          }),
          colors: lowerLayersJawExt.map(function (elm) {
            return responses["lower_roots_jaw_c_".concat(elm, ".b")];
          })
        }, getMaterial(visLower, lowerInterpFractJaw, true), lowerInterpJaw)); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var slider = getSlider(upperLayersRoots, lowerLayersRoots, upperLayersJaw, lowerLayersJaw, CTX, timeline, timelineJaw, uIndex, upperInterp, lowerInterp, upperInterpFract, lowerInterpFract, upperInterpJaw, lowerInterpJaw, upperInterpFractJaw, lowerInterpFractJaw);
        getModes(ORTHO, rot, bezier1, visUpper, visLower, updateProjectionMatrix, drawGrid, CTX, false, false, false, orbit, rootsMode, responses['upper_roots_teeth_t_0.b'], responses['lower_roots_teeth_t_0.b']);
        getOrbit(orbit, gl, zoom, CTX, updateProjectionMatrix, drawGrid, slider);
        getInfo(ORTHO, CASE, upperLayersRoots, false, lowerLayersRoots, false, responses['upper_roots_teeth_t_0.b'], responses['lower_roots_teeth_t_0.b']); // //////////////////////////////////
        // //////////////////////////////////
        // //////////////////////////////////

        var BLANK_FUNCTION = function BLANK_FUNCTION() {};

        var ROOTS_LENGHT = ROOTS.length;
        var gridSwitch = [BLANK_FUNCTION, function () {
          grid.draw();
        }];

        var render = function render() {
          renderFlag = 1; // gl.clear(COLOR_BUFFER_BIT);

          orbit.update();

          for (var _i = 0; _i < ROOTS_LENGHT; _i++) {
            ROOTS[_i].draw();
          }

          gridSwitch[drawGrid.x]();
          gl.finish();
        };

        var renderFlag = 0;

        var updateTransitions = function updateTransitions() {
          renderFlag = 0;
          CTX.updateTime();
          CTX.updateTransitions();
          requestAnimationFrame(updateTransitions);
        };

        updateTransitions();
        var renderSwitch = [render, BLANK_FUNCTION];
        parent.appendChild(CTX.canvas);

        CTX.clbk = function () {
          renderSwitch[renderFlag]();
        };

        CTX.clbk();
        setFinalCSS(CTX, gl);
      } catch (evt) {
        (catchCallback || function () {
          return 0;
        })(evt, 'roots');
      }
    }).catch();
  }).catch();
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! glkit */ "./node_modules/glkit/build/index.js")["WebGL"], __webpack_require__(/*! ./error-callback */ "./src/js/error-callback.js"), __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! glkit */ "./node_modules/glkit/build/index.js")["Loader"], __webpack_require__(/*! ./onprogress */ "./src/js/onprogress.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["prepareResponses"], __webpack_require__(/*! ./cameras */ "./src/js/cameras.js"), __webpack_require__(/*! ./draw-func */ "./src/js/draw-func.js")["getDrawFunc4Attr"], __webpack_require__(/*! ./draw-func */ "./src/js/draw-func.js")["getDrawFunc2Attr"], __webpack_require__(/*! ./grid */ "./src/js/grid.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["getLayers"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["getTriangles"], __webpack_require__(/*! ./functions */ "./src/js/functions.js")["extArr"], __webpack_require__(/*! ./slider */ "./src/js/slider.js"), __webpack_require__(/*! ./modes */ "./src/js/modes.js"), __webpack_require__(/*! ./orbit */ "./src/js/orbit.js"), __webpack_require__(/*! ./info */ "./src/js/info.js"), __webpack_require__(/*! ./functions */ "./src/js/functions.js")["setFinalCSS"], __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/slider.js":
/*!**************************!*\
  !*** ./src/js/slider.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, catchCallback) {function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// для roots переменные с окончанием Locks соответствуют Jaws
module.exports = function (upperLayers, lowerLayers, upperLayersLocks, lowerLayersLocks, CTX, timeline, timelineLocks, uIndex, upperInterp, lowerInterp, upperInterpFract, lowerInterpFract, upperInterpLocks, lowerInterpLocks, upperInterpFractLocks, lowerInterpFractLocks, interpColors, interpColorsFract, timelineColors, layersColors, upperLayersRamps, lowerLayersRamps, timelineRamps, upperInterpRamps, lowerInterpRamps, upperInterpFractRamps, lowerInterpFractRamps, upperLayersTorq, lowerLayersTorq, timelineTorq, upperInterpTorq, lowerInterpTorq, upperInterpFractTorq, lowerInterpFractTorq) {
  try {
    var sliderButtons = $('.ortho-controls-actions-item');
    var up = $($('.ortho-controls-current')[0]);
    var down = $($('.ortho-controls-current')[1]);
    var S = $('.ortho-controls-slider')[0];
    S.parent = $('.ortho-controls-inner')[0];
    S.controls = $('.ortho-controls-inner').find('.ortho-controls-actions-inner');
    S.line = $('.ortho-controls-line');
    S.steps = Math.max(upperLayers.slice().pop() || 0, lowerLayers.slice().pop() || 0);

    var _getLayers = function _getLayers(layers) {
      var arr = [];

      for (var i = 0; i <= layers.length; i += 2) {
        var from = parseInt(layers[i]);
        var to = parseInt(layers[i + 1]);
        var step = void 0;

        if (to - from) {
          step = 1 / (to - from);

          for (var k = 0; k < to - from; k++) {
            arr.push(i + step * k);
          }
        } else if (!(layers[i] === layers[i + 1] && layers[i + 1] === layers[i + 2] && layers[i + 2] === layers[i + 3])) {
          arr.push(i);
        }
      }

      return arr;
    };

    S.upperLayers = _getLayers(upperLayers);
    S.lowerLayers = _getLayers(lowerLayers);
    S.upperMax = S.upperLayers.length;
    S.lowerMax = S.lowerLayers.length; // для случаев с одним этапом

    if (upperLayers[0] + upperLayers[1] + upperLayers[2] === 0 && upperLayers.length < 5) {
      S.upperMax = 1;
    }

    if (lowerLayers[0] + lowerLayers[1] + lowerLayers[2] === 0 && lowerLayers.length < 5) {
      S.lowerMax = 1;
    } // if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {


    S.upperLayersLocks = _getLayers(upperLayersLocks);
    S.lowerLayersLocks = _getLayers(lowerLayersLocks);

    if (window.__VIEWER_TYPE__ === 'main') {
      S.upperLayersRamps = _getLayers(upperLayersRamps);
      S.lowerLayersRamps = _getLayers(lowerLayersRamps);
      S.upperLayersTorq = _getLayers(upperLayersTorq);
      S.lowerLayersTorq = _getLayers(lowerLayersTorq);
    } // }


    if (window.__VIEWER_TYPE__ === 'main') {
      // S.upperLayersColors = _getLayers(upperLayersColors);
      S.layersColors = _getLayers(layersColors || []);
    }

    if (S.upperLayers.length > S.lowerLayers.length) {
      var _S$lowerLayers;

      (_S$lowerLayers = S.lowerLayers).push.apply(_S$lowerLayers, _toConsumableArray(new Array(S.upperLayers.length - S.lowerLayers.length).fill(S.lowerLayers[S.lowerLayers.length - 1])));
    } else {
      var _S$upperLayers;

      (_S$upperLayers = S.upperLayers).push.apply(_S$upperLayers, _toConsumableArray(new Array(S.lowerLayers.length - S.upperLayers.length).fill(S.upperLayers[S.upperLayers.length - 1])));
    } // if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {


    if (S.upperLayersLocks.length > S.lowerLayersLocks.length) {
      var _S$lowerLayersLocks;

      (_S$lowerLayersLocks = S.lowerLayersLocks).push.apply(_S$lowerLayersLocks, _toConsumableArray(new Array(S.upperLayersLocks.length - S.lowerLayersLocks.length).fill(S.lowerLayersLocks[S.lowerLayersLocks.length - 1])));
    } else {
      var _S$upperLayersLocks;

      (_S$upperLayersLocks = S.upperLayersLocks).push.apply(_S$upperLayersLocks, _toConsumableArray(new Array(S.lowerLayersLocks.length - S.upperLayersLocks.length).fill(S.upperLayersLocks[S.upperLayersLocks.length - 1])));
    }

    if (window.__VIEWER_TYPE__ === 'main') {
      if (S.upperLayersRamps.length > S.lowerLayersRamps.length) {
        var _S$lowerLayersRamps;

        (_S$lowerLayersRamps = S.lowerLayersRamps).push.apply(_S$lowerLayersRamps, _toConsumableArray(new Array(S.upperLayersRamps.length - S.lowerLayersRamps.length).fill(S.lowerLayersRamps[S.lowerLayersRamps.length - 1])));
      } else {
        var _S$upperLayersRamps;

        (_S$upperLayersRamps = S.upperLayersRamps).push.apply(_S$upperLayersRamps, _toConsumableArray(new Array(S.lowerLayersRamps.length - S.upperLayersRamps.length).fill(S.upperLayersRamps[S.upperLayersRamps.length - 1])));
      }

      if (S.upperLayersTorq.length > S.lowerLayersTorq.length) {
        var _S$lowerLayersTorq;

        (_S$lowerLayersTorq = S.lowerLayersTorq).push.apply(_S$lowerLayersTorq, _toConsumableArray(new Array(S.upperLayersTorq.length - S.lowerLayersTorq.length).fill(S.lowerLayersTorq[S.lowerLayersTorq.length - 1])));
      } else {
        var _S$upperLayersTorq;

        (_S$upperLayersTorq = S.upperLayersTorq).push.apply(_S$upperLayersTorq, _toConsumableArray(new Array(S.lowerLayersTorq.length - S.upperLayersTorq.length).fill(S.upperLayersTorq[S.upperLayersTorq.length - 1])));
      }
    } // }


    S.interval = null;
    S.paused = true;
    S.currStep = 0;
    S.mousedownX = 0;
    S.mouseupX = 0;
    S.left = 0;
    S.touchDown = [];
    S.isMoving = false;
    var tlTrans = new CTX.DataFloat1();
    S.catcherEven = [0];
    S.switchEven = [function (tl) {
      return tl - 1;
    }];

    S.switchEven.undefined = function (tl) {
      return tl;
    };

    S.catcherOdd = [0, 1];
    S.switchOdd = [function (tl) {
      return tl;
    }, function (tl) {
      return tl + 1;
    }];

    S.switchOdd.undefined = function (tl) {
      return tl;
    };

    S.setTLBack = function (tl, layers) {
      tl.x = layers[S.currStep + 1];
      tl.x = S.switchEven[S.catcherEven[tl.x % 2]](tl.x);
      return tl.x;
    };

    S.setTLForw = function (tl, layers) {
      tl.x = layers[S.currStep - 1];
      var next = layers[S.currStep];
      next = S.switchEven[S.catcherEven[next % 2]](next);
      return [tl.x, next];
    };

    S.moveBack = null;

    if (window.__VIEWER_TYPE__ === 'main') {
      S.moveBack = function () {
        var fromUpper = S.setTLBack(timeline[0], S.upperLayers);
        var fromLower = S.setTLBack(timeline[1], S.lowerLayers);
        var fromUpperLocks = S.setTLBack(timelineLocks[0], S.upperLayersLocks);
        var fromLowerLocks = S.setTLBack(timelineLocks[1], S.lowerLayersLocks);
        var fromUpperRamps = S.setTLBack(timelineRamps[0], S.upperLayersRamps);
        var fromLowerRamps = S.setTLBack(timelineRamps[1], S.lowerLayersRamps);
        var fromUpperTorq = S.setTLBack(timelineTorq[0], S.upperLayersTorq);
        var fromLowerTorq = S.setTLBack(timelineTorq[1], S.lowerLayersTorq);
        var fromLowerColors = S.setTLBack(timelineColors, S.layersColors);
        tlTrans.x = 0;
        tlTrans.setExtendedTransition({
          func: CTX.math.Linear,
          to: 1,
          duration: 250,
          onProgress: function onProgress() {
            timeline[0].x = CTX.utility.mix(fromUpper, S.upperLayers[S.currStep], tlTrans.x);
            timeline[1].x = CTX.utility.mix(fromLower, S.lowerLayers[S.currStep], tlTrans.x);
            timelineLocks[0].x = CTX.utility.mix(fromUpperLocks, S.upperLayersLocks[S.currStep], tlTrans.x);
            timelineLocks[1].x = CTX.utility.mix(fromLowerLocks, S.lowerLayersLocks[S.currStep], tlTrans.x);
            timelineRamps[0].x = CTX.utility.mix(fromUpperRamps, S.upperLayersRamps[S.currStep], tlTrans.x);
            timelineRamps[1].x = CTX.utility.mix(fromLowerRamps, S.lowerLayersRamps[S.currStep], tlTrans.x);
            timelineTorq[0].x = CTX.utility.mix(fromUpperTorq, S.upperLayersTorq[S.currStep], tlTrans.x);
            timelineTorq[1].x = CTX.utility.mix(fromLowerTorq, S.lowerLayersTorq[S.currStep], tlTrans.x);
            timelineColors.x = CTX.utility.mix(fromLowerColors, S.layersColors[S.currStep], tlTrans.x);
            upperInterp.x = ~~timeline[0].x;
            lowerInterp.x = ~~timeline[1].x;
            upperInterpFract.x = timeline[0].x - upperInterp.x;
            lowerInterpFract.x = timeline[1].x - lowerInterp.x;
            upperInterpFract.updateUniforms();
            lowerInterpFract.updateUniforms();
            upperInterpLocks.x = ~~timelineLocks[0].x;
            lowerInterpLocks.x = ~~timelineLocks[1].x;
            upperInterpFractLocks.x = timelineLocks[0].x - upperInterpLocks.x;
            lowerInterpFractLocks.x = timelineLocks[1].x - lowerInterpLocks.x;
            upperInterpFractLocks.updateUniforms();
            lowerInterpFractLocks.updateUniforms();
            upperInterpRamps.x = ~~timelineRamps[0].x;
            lowerInterpRamps.x = ~~timelineRamps[1].x;
            upperInterpFractRamps.x = timelineRamps[0].x - upperInterpRamps.x;
            lowerInterpFractRamps.x = timelineRamps[1].x - lowerInterpRamps.x;
            upperInterpFractRamps.updateUniforms();
            lowerInterpFractRamps.updateUniforms();
            upperInterpTorq.x = ~~timelineTorq[0].x;
            lowerInterpTorq.x = ~~timelineTorq[1].x;
            upperInterpFractTorq.x = timelineTorq[0].x - upperInterpTorq.x;
            lowerInterpFractTorq.x = timelineTorq[1].x - lowerInterpTorq.x;
            upperInterpFractTorq.updateUniforms();
            lowerInterpFractTorq.updateUniforms();
            interpColors.x = ~~timelineColors.x;
            interpColorsFract.x = timelineColors.x - interpColors.x;
            interpColorsFract.updateUniforms();
            CTX.clbk();
          }
        });
      };
    } else if (window.__VIEWER_TYPE__ === 'ply' || window.__VIEWER_TYPE__ === 'roots') {
      S.moveBack = function () {
        var fromUpper = S.setTLBack(timeline[0], S.upperLayers);
        var fromLower = S.setTLBack(timeline[1], S.lowerLayers);
        var fromUpperLocks = S.setTLBack(timelineLocks[0], S.upperLayersLocks);
        var fromLowerLocks = S.setTLBack(timelineLocks[1], S.lowerLayersLocks);
        tlTrans.x = 0;
        tlTrans.setExtendedTransition({
          func: CTX.math.Linear,
          to: 1,
          duration: 250,
          onProgress: function onProgress() {
            timeline[0].x = CTX.utility.mix(fromUpper, S.upperLayers[S.currStep], tlTrans.x);
            timeline[1].x = CTX.utility.mix(fromLower, S.lowerLayers[S.currStep], tlTrans.x);
            timelineLocks[0].x = CTX.utility.mix(fromUpperLocks, S.upperLayersLocks[S.currStep], tlTrans.x);
            timelineLocks[1].x = CTX.utility.mix(fromLowerLocks, S.lowerLayersLocks[S.currStep], tlTrans.x);
            upperInterp.x = ~~timeline[0].x;
            lowerInterp.x = ~~timeline[1].x;
            upperInterpFract.x = timeline[0].x - upperInterp.x;
            lowerInterpFract.x = timeline[1].x - lowerInterp.x;
            upperInterpFract.updateUniforms();
            lowerInterpFract.updateUniforms();
            upperInterpLocks.x = ~~timelineLocks[0].x;
            lowerInterpLocks.x = ~~timelineLocks[1].x;
            upperInterpFractLocks.x = timelineLocks[0].x - upperInterpLocks.x;
            lowerInterpFractLocks.x = timelineLocks[1].x - lowerInterpLocks.x;
            upperInterpFractLocks.updateUniforms();
            lowerInterpFractLocks.updateUniforms();
            CTX.clbk();
          }
        });
      };
    } else {// S.moveBack = () => {
      //   const fromUpper = S.setTLBack(timeline[0], S.upperLayers);
      //   const fromLower = S.setTLBack(timeline[1], S.lowerLayers);
      //   tlTrans.x = 0;
      //   tlTrans.setExtendedTransition({
      //     func: CTX.math.Linear,
      //     to: 1,
      //     duration: 250,
      //     onProgress: () => {
      //       timeline[0].x = CTX.utility.mix(fromUpper, S.upperLayers[S.currStep], tlTrans.x);
      //       timeline[1].x = CTX.utility.mix(fromLower, S.lowerLayers[S.currStep], tlTrans.x);
      //       upperInterp.x = ~~timeline[0].x;
      //       lowerInterp.x = ~~timeline[1].x;
      //       upperInterpFract.x = timeline[0].x - upperInterp.x;
      //       lowerInterpFract.x = timeline[1].x - lowerInterp.x;
      //       upperInterpFract.updateUniforms();
      //       lowerInterpFract.updateUniforms();
      //       CTX.clbk();
      //     },
      //   });
      // };
    }

    S.moveForward = null;

    if (window.__VIEWER_TYPE__ === 'main') {
      S.moveForward = function () {
        var fromUpper = S.setTLForw(timeline[0], S.upperLayers);
        var fromLower = S.setTLForw(timeline[1], S.lowerLayers);
        var fromUpperLocks = S.setTLForw(timelineLocks[0], S.upperLayersLocks);
        var fromLowerLocks = S.setTLForw(timelineLocks[1], S.lowerLayersLocks);
        var fromUpperRamps = S.setTLForw(timelineRamps[0], S.upperLayersRamps);
        var fromLowerRamps = S.setTLForw(timelineRamps[1], S.lowerLayersRamps);
        var fromUpperTorq = S.setTLForw(timelineTorq[0], S.upperLayersTorq);
        var fromLowerTorq = S.setTLForw(timelineTorq[1], S.lowerLayersTorq);
        var fromLowerColors = S.setTLForw(timelineColors, S.layersColors);
        tlTrans.x = 0;
        tlTrans.setExtendedTransition({
          func: CTX.math.Linear,
          to: 1,
          duration: 250,
          onProgress: function onProgress() {
            timeline[0].x = CTX.utility.mix(fromUpper[0], fromUpper[1], tlTrans.x);
            timeline[0].x = S.switchOdd[S.catcherOdd[timeline[0].x % 2]](timeline[0].x);
            timeline[1].x = CTX.utility.mix(fromLower[0], fromLower[1], tlTrans.x);
            timeline[1].x = S.switchOdd[S.catcherOdd[timeline[1].x % 2]](timeline[1].x);
            timelineLocks[0].x = CTX.utility.mix(fromUpperLocks[0], fromUpperLocks[1], tlTrans.x);
            timelineLocks[0].x = S.switchOdd[S.catcherOdd[timelineLocks[0].x % 2]](timelineLocks[0].x);
            timelineLocks[1].x = CTX.utility.mix(fromLowerLocks[0], fromLowerLocks[1], tlTrans.x);
            timelineLocks[1].x = S.switchOdd[S.catcherOdd[timelineLocks[1].x % 2]](timelineLocks[1].x);
            timelineRamps[0].x = CTX.utility.mix(fromUpperRamps[0], fromUpperRamps[1], tlTrans.x);
            timelineRamps[0].x = S.switchOdd[S.catcherOdd[timelineRamps[0].x % 2]](timelineRamps[0].x);
            timelineRamps[1].x = CTX.utility.mix(fromLowerRamps[0], fromLowerRamps[1], tlTrans.x);
            timelineRamps[1].x = S.switchOdd[S.catcherOdd[timelineRamps[1].x % 2]](timelineRamps[1].x);
            timelineTorq[0].x = CTX.utility.mix(fromUpperTorq[0], fromUpperTorq[1], tlTrans.x);
            timelineTorq[0].x = S.switchOdd[S.catcherOdd[timelineTorq[0].x % 2]](timelineTorq[0].x);
            timelineTorq[1].x = CTX.utility.mix(fromLowerTorq[0], fromLowerTorq[1], tlTrans.x);
            timelineTorq[1].x = S.switchOdd[S.catcherOdd[timelineTorq[1].x % 2]](timelineTorq[1].x);
            timelineColors.x = CTX.utility.mix(fromLowerColors[0], fromLowerColors[1], tlTrans.x);
            timelineColors.x = S.switchOdd[S.catcherOdd[timelineColors.x % 2]](timelineColors.x);
            upperInterp.x = ~~timeline[0].x;
            lowerInterp.x = ~~timeline[1].x;
            upperInterpFract.x = timeline[0].x - upperInterp.x;
            lowerInterpFract.x = timeline[1].x - lowerInterp.x;
            upperInterpFract.updateUniforms();
            lowerInterpFract.updateUniforms();
            upperInterpLocks.x = ~~timelineLocks[0].x;
            lowerInterpLocks.x = ~~timelineLocks[1].x;
            upperInterpFractLocks.x = timelineLocks[0].x - upperInterpLocks.x;
            lowerInterpFractLocks.x = timelineLocks[1].x - lowerInterpLocks.x;
            upperInterpFractLocks.updateUniforms();
            lowerInterpFractLocks.updateUniforms();
            upperInterpRamps.x = ~~timelineRamps[0].x;
            lowerInterpRamps.x = ~~timelineRamps[1].x;
            upperInterpFractRamps.x = timelineRamps[0].x - upperInterpRamps.x;
            lowerInterpFractRamps.x = timelineRamps[1].x - lowerInterpRamps.x;
            upperInterpFractRamps.updateUniforms();
            lowerInterpFractRamps.updateUniforms();
            upperInterpTorq.x = ~~timelineTorq[0].x;
            lowerInterpTorq.x = ~~timelineTorq[1].x;
            upperInterpFractTorq.x = timelineTorq[0].x - upperInterpTorq.x;
            lowerInterpFractTorq.x = timelineTorq[1].x - lowerInterpTorq.x;
            upperInterpFractTorq.updateUniforms();
            lowerInterpFractTorq.updateUniforms();
            interpColors.x = ~~timelineColors.x;
            interpColorsFract.x = timelineColors.x - interpColors.x;
            interpColorsFract.updateUniforms();
            CTX.clbk();
          }
        });
      };
    } else if (window.__VIEWER_TYPE__ === 'ply' || window.__VIEWER_TYPE__ === 'roots') {
      S.moveForward = function () {
        var fromUpper = S.setTLForw(timeline[0], S.upperLayers);
        var fromLower = S.setTLForw(timeline[1], S.lowerLayers);
        var fromUpperLocks = S.setTLForw(timelineLocks[0], S.upperLayersLocks);
        var fromLowerLocks = S.setTLForw(timelineLocks[1], S.lowerLayersLocks);
        tlTrans.x = 0;
        tlTrans.setExtendedTransition({
          func: CTX.math.Linear,
          to: 1,
          duration: 250,
          onProgress: function onProgress() {
            timeline[0].x = CTX.utility.mix(fromUpper[0], fromUpper[1], tlTrans.x);
            timeline[0].x = S.switchOdd[S.catcherOdd[timeline[0].x % 2]](timeline[0].x);
            timeline[1].x = CTX.utility.mix(fromLower[0], fromLower[1], tlTrans.x);
            timeline[1].x = S.switchOdd[S.catcherOdd[timeline[1].x % 2]](timeline[1].x);
            timelineLocks[0].x = CTX.utility.mix(fromUpperLocks[0], fromUpperLocks[1], tlTrans.x);
            timelineLocks[0].x = S.switchOdd[S.catcherOdd[timelineLocks[0].x % 2]](timelineLocks[0].x);
            timelineLocks[1].x = CTX.utility.mix(fromLowerLocks[0], fromLowerLocks[1], tlTrans.x);
            timelineLocks[1].x = S.switchOdd[S.catcherOdd[timelineLocks[1].x % 2]](timelineLocks[1].x);
            upperInterp.x = ~~timeline[0].x;
            lowerInterp.x = ~~timeline[1].x;
            upperInterpFract.x = timeline[0].x - upperInterp.x;
            lowerInterpFract.x = timeline[1].x - lowerInterp.x;
            upperInterpFract.updateUniforms();
            lowerInterpFract.updateUniforms();
            upperInterpLocks.x = ~~timelineLocks[0].x;
            lowerInterpLocks.x = ~~timelineLocks[1].x;
            upperInterpFractLocks.x = timelineLocks[0].x - upperInterpLocks.x;
            lowerInterpFractLocks.x = timelineLocks[1].x - lowerInterpLocks.x;
            upperInterpFractLocks.updateUniforms();
            lowerInterpFractLocks.updateUniforms();
            CTX.clbk();
          }
        });
      };
    } else {// S.moveForward = () => {
      //   const fromUpper = S.setTLForw(timeline[0], S.upperLayers);
      //   const fromLower = S.setTLForw(timeline[1], S.lowerLayers);
      //   tlTrans.x = 0;
      //   tlTrans.setExtendedTransition({
      //     func: CTX.math.Linear,
      //     to: 1,
      //     duration: 250,
      //     onProgress: () => {
      //       timeline[0].x = CTX.utility.mix(fromUpper[0], fromUpper[1], tlTrans.x);
      //       timeline[0].x = S.switchOdd[S.catcherOdd[timeline[0].x % 2]](timeline[0].x);
      //       timeline[1].x = CTX.utility.mix(fromLower[0], fromLower[1], tlTrans.x);
      //       timeline[1].x = S.switchOdd[S.catcherOdd[timeline[1].x % 2]](timeline[1].x);
      //       upperInterp.x = ~~timeline[0].x;
      //       lowerInterp.x = ~~timeline[1].x;
      //       upperInterpFract.x = timeline[0].x - upperInterp.x;
      //       lowerInterpFract.x = timeline[1].x - lowerInterp.x;
      //       upperInterpFract.updateUniforms();
      //       lowerInterpFract.updateUniforms();
      //       CTX.clbk();
      //     },
      //   });
      // };
    }

    S.moveSide = {
      "-1": function _() {
        return S.moveBack();
      },
      1: function _() {
        return S.moveForward();
      }
    };
    S.move = null;
    var ALIGNER = "Aligner";

    if (window.__VIEWER_TYPE__ === 'main' || window.__VIEWER_TYPE__ === 'ply') {
      S.move = function (next) {
        var dir = S.currStep < next ? 1 : -1;
        S.currStep = next;
        S.style.left = "".concat(S.currStep / S.steps * S.parent.offsetWidth, "px");
        S.moveSide[dir]();
        uIndex.x = S.currStep;
        uIndex.updateUniforms();
        up.html("".concat(ALIGNER, " ").concat((S.currStep > S.upperMax - 1 ? S.upperMax - 1 : S.currStep) + 1));
        down.html("".concat(ALIGNER, " ").concat((S.currStep > S.lowerMax - 1 ? S.lowerMax - 1 : S.currStep) + 1));
        $('.ortho-info-row.-stage').removeClass('-red');
        $(".ortho-info-row.-stage.".concat(S.currStep)).addClass('-red');
      };
    } else {
      S.move = function (next) {
        var dir = S.currStep < next ? 1 : -1;
        S.currStep = next;
        S.style.left = "".concat(S.currStep / S.steps * S.parent.offsetWidth, "px");
        S.moveSide[dir]();
        up.html("".concat(ALIGNER, " ").concat((S.currStep > S.upperMax - 1 ? S.upperMax - 1 : S.currStep) + 1));
        down.html("".concat(ALIGNER, " ").concat((S.currStep > S.lowerMax - 1 ? S.lowerMax - 1 : S.currStep) + 1));
      };
    }

    S.line.on('click', function (e) {
      e.preventDefault();
      S.paused = true;
      clearInterval(S.interval);
      var stepWidth = S.parent.offsetWidth / S.steps;
      var moveTo = Math.round(e.offsetX / stepWidth);
      S.left = moveTo * stepWidth;
      S.mouseupX = S.left;

      if (S.currStep !== moveTo) {
        S.move(moveTo);
      }
    });

    S.mousemove = function (e) {
      S.paused = true;
      clearInterval(S.interval);
      S.left = S.mouseupX + (e.touches ? e.touches[0] : e).clientX - S.mousedownX;

      if (S.left < 0) {
        S.left = 0;
      } else {
        if (window.innerWidth < 768 && S.left > window.innerWidth - 80) {
          S.left = window.innerWidth - 80;
        } else if (window.innerWidth >= 768 && S.left > window.innerWidth - 200) {
          S.left = window.innerWidth - 200;
        }
      }

      var moveTo = Math.round(S.left / S.parent.offsetWidth * S.steps);

      if (S.currStep != moveTo) {
        S.move(moveTo);
      }
    };

    S.keyDownPlayForward = function () {
      S.left = S.mouseupX + 1 / S.steps * S.parent.offsetWidth;
      S.move(S.currStep + 1);
      S.mouseupX = S.left;
    };

    S.keyDownPlayBack = function () {
      S.left = S.mouseupX - 1 / S.steps * S.parent.offsetWidth;
      S.move(S.currStep - 1);
      S.mouseupX = S.left;
    };

    $(S).on('mousedown touchstart', function (e) {
      S.paused = true;
      clearInterval(S.interval);

      if (e.touches) {
        S.mousedownX = e.touches[0].clientX;
        $(S).on('touchmove', S.mousemove);
      } else {
        S.mousedownX = e.clientX;
        $(window).on('mousemove', S.mousemove);
      }
    }).on('touchend', function (e) {
      S.mouseupX = S.left;
      $(S).off('touchmove', S.mousemove);
    });
    $(window).on('mouseup', function (e) {
      S.mouseupX = S.left;
      $(window).off('mousemove', S.mousemove);
    }).on('keydown', function (e) {
      if (e.keyCode == 39 && S.currStep + 1 <= S.steps) {
        S.paused = true;
        clearInterval(S.interval);
        S.keyDownPlayForward();
      } else if (e.keyCode == 37 && S.currStep - 1 >= 0) {
        S.paused = true;
        clearInterval(S.interval);
        S.keyDownPlayBack();
      } else if (e.keyCode == 32) {
        if (S.paused) {
          S.paused = false;
          S.interval = setInterval(function () {
            if (S.currStep + 1 <= S.steps) {
              S.keyDownPlayForward();
            } else {
              S.paused = true;
              clearInterval(S.interval);
            }
          }, 250);
        } else {
          S.paused = true;
          clearInterval(S.interval);
        }
      }
    });
    $(sliderButtons[0]).on('click', function () {
      if (S.currStep) {
        S.paused = true;
        clearInterval(S.interval);
        S.left = 0;
        S.move(0);
        S.mouseupX = 0;
      }
    });
    $(sliderButtons[1]).on('click', function () {
      if (!S.paused) {
        S.paused = true;
        clearInterval(S.interval);
      }
    });
    $(sliderButtons[2]).on('click', function () {
      if (S.paused) {
        S.paused = false;
        S.interval = setInterval(function () {
          if (S.currStep + 1 <= S.steps) {
            S.keyDownPlayForward();
          } else {
            S.paused = true;
            clearInterval(S.interval);
          }
        }, 250);
      }
    });
    $(sliderButtons[3]).on('click', function () {
      if (S.steps - S.currStep) {
        S.paused = true;
        clearInterval(S.interval);
        S.left = S.parent.offsetWidth;
        S.move(S.steps);
        S.mouseupX = S.parent.offsetWidth;
      }
    }); //

    window.__SLIDER_FIRST__ = function () {
      if (S.currStep) {
        S.paused = true;
        clearInterval(S.interval);
        S.left = 0;
        S.move(0);
        S.mouseupX = 0;
      }
    };

    window.__SLIDER_PAUSE__ = function () {
      if (!S.paused) {
        S.paused = true;
        clearInterval(S.interval);
      }
    };

    window.__SLIDER_PLAY__ = function () {
      if (S.paused) {
        S.paused = false;
        S.interval = setInterval(function () {
          if (S.currStep + 1 <= S.steps) {
            S.keyDownPlayForward();
          } else {
            S.paused = true;
            clearInterval(S.interval);
          }
        }, 250);
      }
    };

    window.__SLIDER_LAST__ = function () {
      if (S.steps - S.currStep) {
        S.paused = true;
        clearInterval(S.interval);
        S.left = S.parent.offsetWidth;
        S.move(S.steps);
        S.mouseupX = S.parent.offsetWidth;
      }
    };

    window.__GO_TO__ = function (step) {
      return S.move(step);
    }; //


    return S;
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'slider');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"), __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/spheres.js":
/*!***************************!*\
  !*** ./src/js/spheres.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(catchCallback) {module.exports = function (CTX, gl, uProjMat, uViewMat, uVisLower, uuIndex, uZoom, uVisUpper, uRotXY, sep, SEPARATIONS, ROTATION_MATRIX_X, ROTATION_MATRIX_Y) {
  try {
    var TRIANGLES = gl.TRIANGLES,
        UNSIGNED_SHORT = gl.UNSIGNED_SHORT;
    var n = -1;
    var position = [];
    var indices = [];
    var indexes = [];
    var origin = [];
    var location = [];
    var rad = 2.2;
    var segN = 32;
    var parse = window.__VIEWER_TYPE__ === 'main' ? function (stage, k, dir, loc) {
      n++;
      var a = stage.centroid[stage.separation[k].a];
      var b = stage.centroid[stage.separation[k].b];
      var s = (parseInt(stage.separation[k].a[1]) + parseInt(stage.separation[k].b[1])) * 0.1;
      var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
      var ab = new CTX.DataFloat3({
        x: a[0] - b[0],
        y: a[1] - b[1],
        z: a[2] - b[2]
      });
      ab.normalize();
      var cd = [ab.z, 0, ab.x];
      var d0 = new CTX.DataFloat3({
        x: c[0] - cd[0] * s,
        y: c[1],
        z: c[2] + cd[2] * s
      });
      var d1 = new CTX.DataFloat3({
        x: c[0] + cd[0] * s,
        y: c[1],
        z: c[2] - cd[2] * s
      });
      var d = d0;

      if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
        d = d1;
      }

      var v;
      var u;
      var grid = [];
      var verticesRow = [];
      var index = 0;

      for (var iy = 0; iy <= segN; iy++) {
        verticesRow = [];
        v = iy / segN;

        for (var ix = 0; ix <= segN; ix++) {
          u = ix / segN;
          position.push(d.x - rad * Math.cos(0 + u * 6.3) * Math.sin(0 + v * 6.3), d.y + rad * Math.cos(0 + v * 6.3), d.z + rad * Math.sin(0 + u * 6.3) * Math.sin(0 + v * 6.3));
          location.push(loc);
          indexes.push(stage.model[0].from);
          origin.push(d.x, d.y, d.z);
          verticesRow.push(index++);
        }

        grid.push(verticesRow);
      }

      for (var _iy = 0; _iy < segN; _iy++) {
        for (var _ix = 0; _ix < segN; _ix++) {
          var _a = grid[_iy][_ix + 1];
          var _b = grid[_iy][_ix];
          var _c = grid[_iy + 1][_ix];
          var _d = grid[_iy + 1][_ix + 1];

          if (_iy !== 0 || 0 > 0) {
            indices.push(1089 * n + _a, 1089 * n + _b, 1089 * n + _d);
          }

          if (_iy !== 32 - 1 || Math.PI > 6.3) {
            indices.push(1089 * n + _b, 1089 * n + _c, 1089 * n + _d);
          }
        }
      }
    } : function (stage, k, dir, loc) {
      n++;
      var a = stage.centroid[stage.separation[k].a];
      var b = stage.centroid[stage.separation[k].b];
      var s = (parseInt(stage.separation[k].a[1]) + parseInt(stage.separation[k].b[1])) * 0.1;
      var c = [(a[0] + b[0]) * 0.5, (a[1] + b[1]) * 0.5, (a[2] + b[2]) * 0.5];
      var ab = new CTX.DataFloat3({
        x: a[0] - b[0],
        y: a[1] - b[1],
        z: a[2] - b[2]
      });
      ab.normalize();
      var cd = [ab.z, 0, ab.x];
      var d0 = new CTX.DataFloat3({
        x: c[0] - cd[0] * s,
        y: c[1],
        z: c[2] + cd[2] * s
      });
      var d1 = new CTX.DataFloat3({
        x: c[0] + cd[0] * s,
        y: c[1],
        z: c[2] - cd[2] * s
      });
      var d = d0;

      if (d0.length(new CTX.DataFloat3()) < d1.length(new CTX.DataFloat3())) {
        d = d1;
      }

      var v;
      var u;
      var grid = [];
      var verticesRow = [];
      var index = 0;

      for (var iy = 0; iy <= segN; iy++) {
        verticesRow = [];
        v = iy / segN;

        for (var ix = 0; ix <= segN; ix++) {
          u = ix / segN;
          position.push(d.x - rad * Math.cos(0 + u * 6.3) * Math.sin(0 + v * 6.3), d.y + rad * Math.cos(0 + v * 6.3), d.z + rad * Math.sin(0 + u * 6.3) * Math.sin(0 + v * 6.3));
          location.push(loc);
          indexes.push(stage.model[0] - 1);
          origin.push(d.x, d.y, d.z);
          verticesRow.push(index++);
        }

        grid.push(verticesRow);
      }

      for (var _iy2 = 0; _iy2 < segN; _iy2++) {
        for (var _ix2 = 0; _ix2 < segN; _ix2++) {
          var _a2 = grid[_iy2][_ix2 + 1];
          var _b2 = grid[_iy2][_ix2];
          var _c2 = grid[_iy2 + 1][_ix2];
          var _d2 = grid[_iy2 + 1][_ix2 + 1];

          if (_iy2 !== 0 || 0 > 0) {
            indices.push(1089 * n + _a2, 1089 * n + _b2, 1089 * n + _d2);
          }

          if (_iy2 !== 32 - 1 || Math.PI > 6.3) {
            indices.push(1089 * n + _b2, 1089 * n + _c2, 1089 * n + _d2);
          }
        }
      }
    };

    for (var i in sep.upper) {
      if (sep.upper[i].separation && Object.keys(sep.upper[i].separation).length) {
        for (var k in sep.upper[i].separation) {
          parse(sep.upper[i], k, 1, 1);
        }
      }
    }

    for (var _i in sep.lower) {
      if (sep.lower[_i].separation && Object.keys(sep.lower[_i].separation).length) {
        for (var _k in sep.lower[_i].separation) {
          parse(sep.lower[_i], _k, -1, 0);
        }
      }
    }

    var vCount = indices.length;
    var material = new CTX.Material({
      VS: function VS() {
        return "\n          precision ".concat(CTX.maxPrecision.vs.float, " float;\n          ").concat(uProjMat.uniform(this), "\n          ").concat(uViewMat.uniform(this), "\n          ").concat(uZoom.uniform(this), "\n          ").concat(uuIndex.uniform(this), "\n          ").concat(uVisUpper.uniform(this), "\n          ").concat(uVisLower.uniform(this), "\n          attribute vec3 position;\n          attribute float index;\n          attribute float location;\n          void main() {\n            gl_Position = projectionMatrix * viewMatrix * vec4(position, zoom) * (1. - abs(uIndex - index)) * float((location > .5 && visUpper > .5) || (location < .5 && visLower > .5));\n          }\n        ");
      },
      FS: "\n        precision ".concat(CTX.maxPrecision.fs.float, " float;\n        void main() {\n          gl_FragColor.y = .522;\n          gl_FragColor.z = .541;\n          gl_FragColor.w = 1.0;\n        }\n        ")
    });

    if (position.length) {
      var program = material.program;
      var positionBuf = new CTX.VBO({
        content: new Float32Array(position),
        name: 'position',
        location: 0
      });
      var indexBuf = new CTX.VBO({
        content: new Float32Array(indexes),
        name: 'index',
        size: 1,
        location: 1
      });
      var locationBuf = new CTX.VBO({
        content: new Float32Array(location),
        name: 'location',
        size: 1,
        location: 2
      });
      var ibo = new CTX.IBO({
        content: new Uint16Array(indices)
      });
      var obj = new CTX.Obj({
        draw: function draw() {
          gl.useProgram(program);
          positionBuf.enable();
          indexBuf.enable();
          locationBuf.enable();
          ibo.enable();
          gl.drawElements(TRIANGLES, vCount, UNSIGNED_SHORT, 0);
        }
      });
      SEPARATIONS.push(obj);
    }
  } catch (evt) {
    (catchCallback || function () {
      return 0;
    })(evt, 'spheres');
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./catch-callback */ "./src/js/catch-callback.js")))

/***/ }),

/***/ "./src/js/texgen.js":
/*!**************************!*\
  !*** ./src/js/texgen.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (arr, cb) {
  var data = "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"128\" height=\"".concat(arr.length * 64, "\">\n      ").concat(arr.map(function (elm, i) {
    var img = "\n          <rect x=\"0\" y=\"".concat(i * 64, "\" width=\"128\" height=\"64\" fill=\"white\" stroke=\"#00858a\"/>\n          <text fill=\"black\"\n                text-anchor=\"middle\"\n                x=\"64\"\n                y=\"").concat((i + 1) * 64, "\"\n                font-family=\"Open Sans, sans-serif\"\n                font-size=\"50\"\n                transform=\"translate(0,-14)\">\n            ").concat(elm, "\n          </text>\n          ");
    return img;
  }).join(''), "\n    </svg>\n    ");
  var DOMURL = window.URL || window.webkitURL || window;
  var svg = new Blob([data], {
    type: 'image/svg+xml'
  });
  var url = DOMURL.createObjectURL(svg);
  var img = new Image();
  img.crossOrigin = 'Anonymous';

  img.onload = function () {
    return cb(img);
  };

  img.src = url;
};

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// ./src/views/Viewer/js/index.js